/* eslint-disable */
// Generated by scripts/fetch-local-data.js. Do not edit manually.
const rawLocalData = {
  "C": {
    "lang": "C",
    "promotion": {
      "headerBanners": {
        "{\"page\":\"\"}": [],
        "{\"page\":\"Home\"}": [
          {
            "Id": "9d592dc4-d7a1-4aa6-aaa0-c90e2d531a8f",
            "Lang": "C",
            "LangDesc": "繁體中文",
            "Name": "首頁橫幅廣告",
            "Desc": "首頁橫幅廣告",
            "ImgName": null,
            "ImgPath": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtInfo/9d592dc4-d7a1-4aa6-aaa0-c90e2d531a8f/",
            "CatTypeName": null,
            "Seq": 0,
            "BannerList": [
              {
                "Id": 0,
                "Image": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/9d592dc4-d7a1-4aa6-aaa0-c90e2d531a8f/77990807-070b-4bdc-bbb0-250de3df4627.jpg",
                "Seq": 1,
                "Url": "",
                "Content": "",
                "IsRedirect": true
              },
              {
                "Id": 0,
                "Image": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/9d592dc4-d7a1-4aa6-aaa0-c90e2d531a8f/c727ed87-a6b8-48e2-b7cb-fbfca525dd28.jpg",
                "Seq": 2,
                "Url": "",
                "Content": "",
                "IsRedirect": true
              },
              {
                "Id": 0,
                "Image": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/9d592dc4-d7a1-4aa6-aaa0-c90e2d531a8f/f20dc0e4-d282-4ae9-b354-bc4dd567bba4.png",
                "Seq": 3,
                "Url": "",
                "Content": "",
                "IsRedirect": true
              }
            ],
            "PrmtProductList": []
          }
        ],
        "{\"page\":\"Index\"}": [],
        "{\"page\":\"Product\"}": [],
        "{\"page\":\"PromProductList\"}": []
      },
      "promotionList": {
        "{\"page\":\"\"}": [],
        "{\"page\":\"Home\"}": [
          {
            "Id": "9d592dc4-d7a1-4aa6-aaa0-c90e2d531a8f",
            "Lang": "C",
            "LangDesc": "繁體中文",
            "Name": "首頁橫幅廣告",
            "Desc": "首頁橫幅廣告",
            "ImgName": null,
            "ImgPath": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtInfo/9d592dc4-d7a1-4aa6-aaa0-c90e2d531a8f/",
            "CatTypeName": null,
            "Seq": 0,
            "BannerList": [
              {
                "Id": 0,
                "Image": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/9d592dc4-d7a1-4aa6-aaa0-c90e2d531a8f/77990807-070b-4bdc-bbb0-250de3df4627.jpg",
                "Seq": 1,
                "Url": "",
                "Content": "",
                "IsRedirect": true
              },
              {
                "Id": 0,
                "Image": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/9d592dc4-d7a1-4aa6-aaa0-c90e2d531a8f/c727ed87-a6b8-48e2-b7cb-fbfca525dd28.jpg",
                "Seq": 2,
                "Url": "",
                "Content": "",
                "IsRedirect": true
              },
              {
                "Id": 0,
                "Image": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/9d592dc4-d7a1-4aa6-aaa0-c90e2d531a8f/f20dc0e4-d282-4ae9-b354-bc4dd567bba4.png",
                "Seq": 3,
                "Url": "",
                "Content": "",
                "IsRedirect": true
              }
            ],
            "PrmtProductList": []
          }
        ],
        "{\"page\":\"Index\"}": [],
        "{\"page\":\"Product\"}": [],
        "{\"page\":\"PromProductList\"}": []
      },
      "promotions": {
        "{\"page\":\"PromProductList\",\"position\":0}": {
          "Id": "00000000-0000-0000-0000-000000000000",
          "Lang": null,
          "LangDesc": null,
          "Name": null,
          "Desc": null,
          "ImgName": null,
          "ImgPath": null,
          "CatTypeName": null,
          "Seq": 0,
          "BannerList": [],
          "PrmtProductList": []
        },
        "{\"page\":\"Home\",\"position\":0}": {
          "Id": "9d592dc4-d7a1-4aa6-aaa0-c90e2d531a8f",
          "Lang": "C",
          "LangDesc": "繁體中文",
          "Name": "首頁橫幅廣告",
          "Desc": "首頁橫幅廣告",
          "ImgName": null,
          "ImgPath": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtInfo/9d592dc4-d7a1-4aa6-aaa0-c90e2d531a8f/",
          "CatTypeName": null,
          "Seq": 0,
          "BannerList": [
            {
              "Id": 0,
              "Image": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/9d592dc4-d7a1-4aa6-aaa0-c90e2d531a8f/77990807-070b-4bdc-bbb0-250de3df4627.jpg",
              "Seq": 1,
              "Url": "",
              "Content": "",
              "IsRedirect": true
            },
            {
              "Id": 0,
              "Image": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/9d592dc4-d7a1-4aa6-aaa0-c90e2d531a8f/c727ed87-a6b8-48e2-b7cb-fbfca525dd28.jpg",
              "Seq": 2,
              "Url": "",
              "Content": "",
              "IsRedirect": true
            },
            {
              "Id": 0,
              "Image": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/9d592dc4-d7a1-4aa6-aaa0-c90e2d531a8f/f20dc0e4-d282-4ae9-b354-bc4dd567bba4.png",
              "Seq": 3,
              "Url": "",
              "Content": "",
              "IsRedirect": true
            }
          ],
          "PrmtProductList": []
        },
        "{\"page\":\"Index\",\"position\":0}": {
          "Id": "00000000-0000-0000-0000-000000000000",
          "Lang": null,
          "LangDesc": null,
          "Name": null,
          "Desc": null,
          "ImgName": null,
          "ImgPath": null,
          "CatTypeName": null,
          "Seq": 0,
          "BannerList": [],
          "PrmtProductList": []
        }
      },
      "homeSeoData": {
        "Status": 200,
        "Data": {
          "Title": "NCI",
          "IsPtx": 0,
          "Keywords": [
            {
              "Lang": {
                "Id": 1,
                "Text": "繁體中文",
                "Code": "C"
              },
              "Language": 1,
              "List": null,
              "Desc": "獅子會2022愛心慈善跑"
            },
            {
              "Lang": {
                "Id": 0,
                "Text": "英文",
                "Code": "E"
              },
              "Language": 0,
              "List": null,
              "Desc": "Tengda (Hong Kong) Petrochemical Company Limited has been established as a car products company focusing on R&D, production and sales in 1995. "
            }
          ],
          "Keyword": "獅子會2022愛心慈善跑",
          "Descriptions": [
            {
              "Lang": {
                "Id": 1,
                "Text": "繁體中文",
                "Code": "C"
              },
              "Language": 1,
              "List": null,
              "Desc": "獅子會2022愛心慈善跑"
            },
            {
              "Lang": {
                "Id": 0,
                "Text": "英文",
                "Code": "E"
              },
              "Language": 0,
              "List": null,
              "Desc": "Tengda (Hong Kong) Petrochemical Company Limited has been established as a car products company focusing on R&D, production and sales in 1995. "
            }
          ],
          "Description": "獅子會2022愛心慈善跑",
          "FacebookImage": null,
          "FacebookDescription": null
        }
      },
      "menu": {
        "Succeeded": true,
        "Message": null,
        "ReturnValue": {
          "HeaderMenus": [
            {
              "Id": "90608c4d-d80e-4a74-b3d6-644590ec6334",
              "Name": "關於NCI",
              "Title": "關於NCI",
              "Type": 0,
              "Url": "/cms/content/20346",
              "Image": "",
              "MobileImage": "",
              "Value": {
                "Id": ""
              },
              "Level": 1,
              "ParentId": null,
              "PlaceTop": false,
              "IsNewWin": false,
              "IsAnchor": false,
              "Childs": null,
              "UrlTransId": "abc40f96-0d60-42ca-b65b-54e8cef6e5d5",
              "RedirectUrl": null,
              "CmsKey": null,
              "ParentCmsKey": null
            },
            {
              "Id": "c13de078-690e-477f-907c-72c678508654",
              "Name": "經營理念",
              "Title": "經營理念",
              "Type": 0,
              "Url": "/cms/content/20348",
              "Image": "",
              "MobileImage": "",
              "Value": {
                "Id": ""
              },
              "Level": 1,
              "ParentId": null,
              "PlaceTop": false,
              "IsNewWin": false,
              "IsAnchor": false,
              "Childs": null,
              "UrlTransId": "8aaf5baa-12f8-4ae5-af5e-c5af48953118",
              "RedirectUrl": null,
              "CmsKey": null,
              "ParentCmsKey": null
            },
            {
              "Id": "f35da558-5cfe-4632-bf13-5cf8602f3b95",
              "Name": "優質服務",
              "Title": "優質服務",
              "Type": 0,
              "Url": "/cms/content/20349",
              "Image": "",
              "MobileImage": "",
              "Value": {
                "Id": ""
              },
              "Level": 1,
              "ParentId": null,
              "PlaceTop": false,
              "IsNewWin": false,
              "IsAnchor": false,
              "Childs": null,
              "UrlTransId": "6acd0f22-48a6-4efd-b390-bd53fb752712",
              "RedirectUrl": null,
              "CmsKey": null,
              "ParentCmsKey": null
            },
            {
              "Id": "947a90cc-8411-4dae-b82e-a839ad263fa7",
              "Name": "萬用壽險",
              "Title": "萬用壽險",
              "Type": 0,
              "Url": "/cms/content/20350",
              "Image": "",
              "MobileImage": "",
              "Value": {
                "Id": ""
              },
              "Level": 1,
              "ParentId": null,
              "PlaceTop": false,
              "IsNewWin": false,
              "IsAnchor": false,
              "Childs": null,
              "UrlTransId": "e3632243-3a1c-44e3-8365-70dbc22c87fe",
              "RedirectUrl": null,
              "CmsKey": null,
              "ParentCmsKey": null
            },
            {
              "Id": "b3ac369c-cc48-4275-b98a-db2fa34a6fcf",
              "Name": "聯繫我們",
              "Title": "聯繫我們",
              "Type": 0,
              "Url": "/cms/content/20347",
              "Image": "",
              "MobileImage": "",
              "Value": {
                "Id": ""
              },
              "Level": 1,
              "ParentId": null,
              "PlaceTop": false,
              "IsNewWin": false,
              "IsAnchor": false,
              "Childs": null,
              "UrlTransId": "4be23722-cff1-429a-9e6b-86b4f644eac1",
              "RedirectUrl": null,
              "CmsKey": null,
              "ParentCmsKey": null
            }
          ],
          "FooterMenus": [
            {
              "Id": "9bcba247-5e60-4d3b-9e23-df604864969e",
              "Name": "關於NCI",
              "Title": "關於NCI",
              "Type": -1,
              "Url": "",
              "Image": "",
              "MobileImage": "",
              "Value": {
                "Id": ""
              },
              "Level": 1,
              "ParentId": null,
              "PlaceTop": false,
              "IsNewWin": false,
              "IsAnchor": false,
              "Childs": null,
              "UrlTransId": "0b31cb5b-996c-4e4b-b548-e4ccbd605d52",
              "RedirectUrl": null,
              "CmsKey": null,
              "ParentCmsKey": null
            },
            {
              "Id": "cce0358f-cb57-46b1-bc33-a6ce2dd82a28",
              "Name": "經營理念",
              "Title": "經營理念",
              "Type": 0,
              "Url": "/cms/content/20348",
              "Image": "",
              "MobileImage": "",
              "Value": {
                "Id": ""
              },
              "Level": 1,
              "ParentId": null,
              "PlaceTop": false,
              "IsNewWin": false,
              "IsAnchor": false,
              "Childs": null,
              "UrlTransId": "e95c101d-1192-4dd0-8790-bb8e404dbdcb",
              "RedirectUrl": null,
              "CmsKey": null,
              "ParentCmsKey": null
            },
            {
              "Id": "6003429e-2f64-4b6a-8f97-a3a7121a7653",
              "Name": "優質服務",
              "Title": "優質服務",
              "Type": 0,
              "Url": "/cms/content/20349",
              "Image": "",
              "MobileImage": "",
              "Value": {
                "Id": ""
              },
              "Level": 1,
              "ParentId": null,
              "PlaceTop": false,
              "IsNewWin": false,
              "IsAnchor": false,
              "Childs": null,
              "UrlTransId": "cf730d52-006f-4bca-8032-990d6f02c166",
              "RedirectUrl": null,
              "CmsKey": null,
              "ParentCmsKey": null
            },
            {
              "Id": "b047b2f2-4487-470c-a0ff-61ad5ff8daf9",
              "Name": "萬用壽險",
              "Title": "萬用壽險",
              "Type": 0,
              "Url": "/cms/content/20350",
              "Image": "",
              "MobileImage": "",
              "Value": {
                "Id": ""
              },
              "Level": 1,
              "ParentId": null,
              "PlaceTop": false,
              "IsNewWin": false,
              "IsAnchor": false,
              "Childs": [],
              "UrlTransId": "a72422f2-e7bd-43a8-b855-0b8dc2d8e8fb",
              "RedirectUrl": null,
              "CmsKey": null,
              "ParentCmsKey": null
            },
            {
              "Id": "87b54bd9-f82a-4cff-9bc8-e31a169420dd",
              "Name": "聯繫我們",
              "Title": "聯繫我們",
              "Type": 0,
              "Url": "/cms/content/20347",
              "Image": "",
              "MobileImage": "",
              "Value": {
                "Id": ""
              },
              "Level": 1,
              "ParentId": null,
              "PlaceTop": false,
              "IsNewWin": false,
              "IsAnchor": false,
              "Childs": null,
              "UrlTransId": "99f09e67-95d5-497c-acb5-f35a0de406e3",
              "RedirectUrl": null,
              "CmsKey": null,
              "ParentCmsKey": null
            }
          ]
        },
        "Code": 0
      }
    },
    "cms": {
      "content": {
        "{\"cid\":\"20346\"}": {
          "Id": 20346,
          "Key": "K20260105143250",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "關於NCI",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "<div class=\"AboutNCI\"><div class=\"contentBox\"><div class=\"leftT\"><p class=\"perText\"><em class=\"colorText\">新世紀國際保險顧問有限公司(NCI）</em>於2007年成立，乃香港保險業監理局的會員（牌照號碼FB1543），主要業務為提供客戶優質的保險中介服務。NCI\n擁有完整豐富資歷與多年經驗的專業團隊，在保險規劃領域極具獨創性與主導性，致力為全球高資產客戶提供人壽保險規劃建議，量身設計專屬並縱覽全球的專業服務。</p><p class=\"perText\">高資產客戶的需求不一，NCI 堅守以客為尊信念，深入瞭解每位客戶的獨特需求，提供全方位保險商品建議與銷售。 誠信是最根本的核心價值，NCI\n秉持信念，慎選保險商品與合作夥伴，全力維護客戶權益。我們憑藉獨創完善的保險規劃，提供貼身的優質服務予每位高資產客戶，致力於追求與客戶的互信與長期合作。</p><p class=\"perText\">NCI\n代理多家國際知名保險公司的商品，並與各相關專業夥伴機構如私人銀行、資產管理顧問、會計師等團隊建立緊密的互動關係，竭力為高資產客戶制定最適合的保險方案，配合客戶的資產配置、傳承與理財規劃等目標。</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_29.jpg\"/></div></div><div class=\"bottomImg\"><img src=\"/nci/images/pc/pc_30.jpg\"/></div></div>",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "關於NCI",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 14:32:50",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40129,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/88169d3b-ab92-4ef4-aa4b-219e9a548b7b.jpg",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40129,
            "Name": "關於NCI",
            "ParentId": 0,
            "Path": "40129",
            "CatPaths": [
              {
                "CatId": "40129",
                "PathName": "關於NCI"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": [],
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"cid\":\"20347\"}": {
          "Id": 20347,
          "Key": "ContactUs",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "聯繫我們",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">地址：</p><p class=\"text\">香港九龍長沙灣道833號長沙灣廣場一期5樓502A室</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">電話：</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">傳真：</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">電郵：</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "聯繫我們",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 14:56:39",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40130,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/b5521f4f-fdb3-4f42-8c69-d9c44ce650aa.jpg",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40130,
            "Name": "聯繫我們",
            "ParentId": 0,
            "Path": "40130",
            "CatPaths": [
              {
                "CatId": "40130",
                "PathName": "聯繫我們"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": [],
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"cid\":\"20348\"}": {
          "Id": 20348,
          "Key": "K20260105163008",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "經營理念",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "<div class=\"BusinessPhilosophyBox\"><div class=\"topbox\"><div class=\"warper\"><p class=\"perText\">保險是個人與家庭重要的資產屏障。人生起伏多變，一生奮鬥所累積的財富更可能隨著市場環境之變化而波動。因此，高資產客戶格外需要更積極兼有效益的保險理財規劃，藉此建置厚實的財富屏障，使家族基業得以穩固且茁壯。</p><p class=\"perText\">NCI 洞悉每一位高資產客戶的獨特需求，堅守專業與嚴謹的服務品質，助您完成財富傳承大業。</p></div></div><div class=\"contentBox\"><div class=\"leftT\"><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">NCI </em><em class=\"smallText\">結合保險及其他策略夥伴，致力幫助高資產客戶：</em></p><p class=\"circleText\">擁有安定穩固的個人與家庭保障</p><p class=\"circleText\">整合財富資源、享受豐富人生</p><p class=\"circleText\">資產增值、財富世代傳承</p><p class=\"circleText\">積極正面的保險理財觀</p></div><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">NCI </em><em class=\"smallText\">與眾不同的獨特價值：</em></p><p class=\"circleText\">打破市場藩籬或商品導向，專為客戶量身規劃最佳保險方案</p><p class=\"circleText\">以客戶權益為優先，運用精算技術進行各保險商品比較</p><p class=\"circleText\">按客戶於人生各階段的不同需求，提供最適當的保險規劃</p><p class=\"circleText\">整合合作夥伴資源，協助客戶達成保險理財計劃</p><p class=\"circleText\">掌握趨勢，向國際保險集團建議研發最切合客戶需求的優質保險商品</p></div></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_18.jpg\"/></div></div></div>",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "經營理念",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 16:30:08",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40131,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/ee42a92e-5b0a-497f-afa4-ac01caceb482.jpg",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40131,
            "Name": "經營理念",
            "ParentId": 0,
            "Path": "40131",
            "CatPaths": [
              {
                "CatId": "40131",
                "PathName": "經營理念"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": [],
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"cid\":\"20349\"}": {
          "Id": 20349,
          "Key": "K20260105163036",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "優質服務",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "<div class=\"ExcellentServiceBox\"><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">提供</em><em class=\"smallText\">全面保險規劃</em></p><p class=\"normarText\">NCI\n代理多家國際知名保險公司的保險商品，深入瞭解不同商品的特性，擅長全方位分析與評估，並與全球頂尖的私人銀行、專業稅務與金融團隊合作，建議周全保險規劃，去配合客戶不同時期的資產保全與財富增值，務求能按每位客戶的獨特需求，量身設計最佳的保險規劃方案。</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_12.jpg\"/></div></div></div><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">完善</em><em class=\"smallText\">的產品分析和比較</em></p><p class=\"normarText\">NCI 與保險公司保持密切的合作關係，藉此快速掌握市場最新資訊，使客戶充分瞭解商品的動向、獲利分析、成本計算及其變動。同時，NCI\n的專業團隊運用長期累積的豐富經驗，按客戶需求，分析各家保險商品的優缺利弊，協助客戶充分運用保險與銀行服務，選擇最具自主性的保險理財方案。</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_13.jpg\"/></div></div></div><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">尊榮</em><em class=\"smallText\">的客戶服務</em></p><p class=\"normarText\">NCI 以客為尊，提供優質服務，包括：</p><p class=\"circleText\">為客戶建立全方位保險規劃</p><p class=\"circleText\">製作完善的保險商品分析和比較</p><p class=\"circleText\">提供客戶金融保險市場最新資訊</p><p class=\"circleText\">按原始保險規劃，主動進行年度報表之審查、分析保單逐年的表現，以維護客戶權益</p><p class=\"circleText\">協助高資產客戶建立正確的保險觀念</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_14.jpg\"/></div></div></div></div>",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "優質服務",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 16:30:36",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40132,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/d7564750-42a2-41f7-8cda-a6e15d41db14.jpg",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40132,
            "Name": "優質服務",
            "ParentId": 0,
            "Path": "40132",
            "CatPaths": [
              {
                "CatId": "40132",
                "PathName": "優質服務"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": [],
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"cid\":\"20350\"}": {
          "Id": 20350,
          "Key": "K20260105163059",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "萬用壽險",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "<div class=\"UniversalLifeInsuranceBox\"><div class=\"topbox\"><div class=\"warper\"><p class=\"perText\">萬用壽險是集人壽保障和財富增值於一身之保險商品。與傳統壽險產品相比，萬用壽險在提供保障之餘，更能獲取相對穩健的獲利回報，以達致儲蓄、資產增值與傳承目的。</p></div></div><div class=\"contentBox\"><div class=\"leftT\"><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">更靈活彈性的保險類型 </em></p><p class=\"NrText\">萬用壽險保單大多容許投保人按實際需要更改受保金額，又或更改保單的儲蓄成分，保費可彈性調整。投保人也可按個人條件與金融環境，隨時投入更多資金或提取累積的現金價值。相較傳統壽險產品，萬用壽險更為靈活有彈性，透明度亦更高，能配合投保人的實際家庭及經濟狀況，提供彈性的自主空間，迎合不同人生階段的需要。</p></div><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">保費/保單融資 </em></p><p class=\"NrText\">萬用壽險保單具備穩健的價值，可做為私人銀行貸款之擔保品，使高資產客戶得以善用低利率的融資槓桿操作，提升理財效益。無論是運用保費融資取得高額壽險保障，或利用保單融資額度累積一筆潛在的備用資金，以進行投資、傳承、退休計畫等多項規劃，讓財富保值的同時亦可更有效率的達成多元財務目標。NCI 與多家私人銀行及金融機構緊密合作，按客戶需要，提供保費或保單的融資服務。。</p></div></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_22.jpg\"/></div></div></div>",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "萬用壽險",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 16:30:59",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40133,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/dc3c9aba-8168-4b49-874a-53ae863e8354.jpg",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40133,
            "Name": "萬用壽險",
            "ParentId": 0,
            "Path": "40133",
            "CatPaths": [
              {
                "CatId": "40133",
                "PathName": "萬用壽險"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": [],
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        }
      },
      "contentByDevice": {
        "{\"Key\":\"20346\",\"ContentId\":\"20346\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20346,
            "Key": "K20260105143250",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "關於NCI",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"AboutNCI\"><div class=\"contentBox\"><div class=\"leftT\"><p class=\"perText\"><em class=\"colorText\">新世紀國際保險顧問有限公司(NCI）</em>於2007年成立，乃香港保險業監理局的會員（牌照號碼FB1543），主要業務為提供客戶優質的保險中介服務。NCI\n擁有完整豐富資歷與多年經驗的專業團隊，在保險規劃領域極具獨創性與主導性，致力為全球高資產客戶提供人壽保險規劃建議，量身設計專屬並縱覽全球的專業服務。</p><p class=\"perText\">高資產客戶的需求不一，NCI 堅守以客為尊信念，深入瞭解每位客戶的獨特需求，提供全方位保險商品建議與銷售。 誠信是最根本的核心價值，NCI\n秉持信念，慎選保險商品與合作夥伴，全力維護客戶權益。我們憑藉獨創完善的保險規劃，提供貼身的優質服務予每位高資產客戶，致力於追求與客戶的互信與長期合作。</p><p class=\"perText\">NCI\n代理多家國際知名保險公司的商品，並與各相關專業夥伴機構如私人銀行、資產管理顧問、會計師等團隊建立緊密的互動關係，竭力為高資產客戶制定最適合的保險方案，配合客戶的資產配置、傳承與理財規劃等目標。</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_29.jpg\"/></div></div><div class=\"bottomImg\"><img src=\"/nci/images/pc/pc_30.jpg\"/></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "關於NCI",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 14:32:50",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40129,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/88169d3b-ab92-4ef4-aa4b-219e9a548b7b.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40129,
              "Name": "關於NCI",
              "ParentId": 0,
              "Path": "40129",
              "CatPaths": [
                {
                  "CatId": "40129",
                  "PathName": "關於NCI"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"20346\",\"ContentId\":\"20346\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20346,
            "Key": "K20260105143250",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "關於NCI",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"AboutNCI\"><div class=\"contentBox\"><div class=\"leftT\"><p class=\"perText\"><em class=\"colorText\">新世紀國際保險顧問有限公司(NCI）</em>於2007年成立，乃香港保險業監理局的會員（牌照號碼FB1543），主要業務為提供客戶優質的保險中介服務。NCI\n擁有完整豐富資歷與多年經驗的專業團隊，在保險規劃領域極具獨創性與主導性，致力為全球高資產客戶提供人壽保險規劃建議，量身設計專屬並縱覽全球的專業服務。</p><p class=\"perText\">高資產客戶的需求不一，NCI 堅守以客為尊信念，深入瞭解每位客戶的獨特需求，提供全方位保險商品建議與銷售。 誠信是最根本的核心價值，NCI\n秉持信念，慎選保險商品與合作夥伴，全力維護客戶權益。我們憑藉獨創完善的保險規劃，提供貼身的優質服務予每位高資產客戶，致力於追求與客戶的互信與長期合作。</p><p class=\"perText\">NCI\n代理多家國際知名保險公司的商品，並與各相關專業夥伴機構如私人銀行、資產管理顧問、會計師等團隊建立緊密的互動關係，竭力為高資產客戶制定最適合的保險方案，配合客戶的資產配置、傳承與理財規劃等目標。</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_29.jpg\"/></div></div><div class=\"bottomImg\"><img src=\"/nci/images/mobile/mobileNew_203.jpg\"/></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "關於NCI",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 14:32:50",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40129,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/fe2fe257-242d-4099-8d21-5ef7f69a2fdc.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40129,
              "Name": "關於NCI",
              "ParentId": 0,
              "Path": "40129",
              "CatPaths": [
                {
                  "CatId": "40129",
                  "PathName": "關於NCI"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"20347\",\"ContentId\":\"20347\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20347,
            "Key": "ContactUs",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "聯繫我們",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">地址：</p><p class=\"text\">香港九龍長沙灣道833號長沙灣廣場一期5樓502A室</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">電話：</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">傳真：</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">電郵：</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "聯繫我們",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 14:56:39",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40130,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/b5521f4f-fdb3-4f42-8c69-d9c44ce650aa.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40130,
              "Name": "聯繫我們",
              "ParentId": 0,
              "Path": "40130",
              "CatPaths": [
                {
                  "CatId": "40130",
                  "PathName": "聯繫我們"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"20347\",\"ContentId\":\"20347\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20347,
            "Key": "ContactUs",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "聯繫我們",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">地址：</p><p class=\"text\">香港九龍長沙灣道833號長沙灣廣場一期5樓502A室</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">電話：</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">傳真：</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">電郵：</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "聯繫我們",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 14:56:39",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40130,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/1fd7df0d-99a8-4560-925a-1ef12c26e643.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40130,
              "Name": "聯繫我們",
              "ParentId": 0,
              "Path": "40130",
              "CatPaths": [
                {
                  "CatId": "40130",
                  "PathName": "聯繫我們"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"20348\",\"ContentId\":\"20348\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20348,
            "Key": "K20260105163008",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "經營理念",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"BusinessPhilosophyBox\"><div class=\"topbox\"><div class=\"warper\"><p class=\"perText\">保險是個人與家庭重要的資產屏障。人生起伏多變，一生奮鬥所累積的財富更可能隨著市場環境之變化而波動。因此，高資產客戶格外需要更積極兼有效益的保險理財規劃，藉此建置厚實的財富屏障，使家族基業得以穩固且茁壯。</p><p class=\"perText\">NCI 洞悉每一位高資產客戶的獨特需求，堅守專業與嚴謹的服務品質，助您完成財富傳承大業。</p></div></div><div class=\"contentBox\"><div class=\"leftT\"><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">NCI </em><em class=\"smallText\">結合保險及其他策略夥伴，致力幫助高資產客戶：</em></p><p class=\"circleText\">擁有安定穩固的個人與家庭保障</p><p class=\"circleText\">整合財富資源、享受豐富人生</p><p class=\"circleText\">資產增值、財富世代傳承</p><p class=\"circleText\">積極正面的保險理財觀</p></div><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">NCI </em><em class=\"smallText\">與眾不同的獨特價值：</em></p><p class=\"circleText\">打破市場藩籬或商品導向，專為客戶量身規劃最佳保險方案</p><p class=\"circleText\">以客戶權益為優先，運用精算技術進行各保險商品比較</p><p class=\"circleText\">按客戶於人生各階段的不同需求，提供最適當的保險規劃</p><p class=\"circleText\">整合合作夥伴資源，協助客戶達成保險理財計劃</p><p class=\"circleText\">掌握趨勢，向國際保險集團建議研發最切合客戶需求的優質保險商品</p></div></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_18.jpg\"/></div></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "經營理念",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 16:30:08",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40131,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/ee42a92e-5b0a-497f-afa4-ac01caceb482.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40131,
              "Name": "經營理念",
              "ParentId": 0,
              "Path": "40131",
              "CatPaths": [
                {
                  "CatId": "40131",
                  "PathName": "經營理念"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"20348\",\"ContentId\":\"20348\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20348,
            "Key": "K20260105163008",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "經營理念",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"BusinessPhilosophyBox\"><div class=\"topbox\"><div class=\"warper\"><p class=\"perText\">保險是個人與家庭重要的資產屏障。人生起伏多變，一生奮鬥所累積的財富更可能隨著市場環境之變化而波動。因此，高資產客戶格外需要更積極兼有效益的保險理財規劃，藉此建置厚實的財富屏障，使家族基業得以穩固且茁壯。</p><p class=\"perText\">NCI 洞悉每一位高資產客戶的獨特需求，堅守專業與嚴謹的服務品質，助您完成財富傳承大業。</p></div></div><div class=\"contentBox\"><div class=\"leftT\"><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">NCI </em><em class=\"smallText\">結合保險及其他策略夥伴，致力幫助高資產客戶：</em></p><p class=\"circleText\">擁有安定穩固的個人與家庭保障</p><p class=\"circleText\">整合財富資源、享受豐富人生</p><p class=\"circleText\">資產增值、財富世代傳承</p><p class=\"circleText\">積極正面的保險理財觀</p></div><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">NCI </em><em class=\"smallText\">與眾不同的獨特價值：</em></p><p class=\"circleText\">打破市場藩籬或商品導向，專為客戶量身規劃最佳保險方案</p><p class=\"circleText\">以客戶權益為優先，運用精算技術進行各保險商品比較</p><p class=\"circleText\">按客戶於人生各階段的不同需求，提供最適當的保險規劃</p><p class=\"circleText\">整合合作夥伴資源，協助客戶達成保險理財計劃</p><p class=\"circleText\">掌握趨勢，向國際保險集團建議研發最切合客戶需求的優質保險商品</p></div></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_18.jpg\"/></div></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "經營理念",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 16:30:08",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40131,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0fc342fc-c883-41d4-8a28-f95f696145b1.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40131,
              "Name": "經營理念",
              "ParentId": 0,
              "Path": "40131",
              "CatPaths": [
                {
                  "CatId": "40131",
                  "PathName": "經營理念"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"20349\",\"ContentId\":\"20349\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20349,
            "Key": "K20260105163036",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "優質服務",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"ExcellentServiceBox\"><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">提供</em><em class=\"smallText\">全面保險規劃</em></p><p class=\"normarText\">NCI\n代理多家國際知名保險公司的保險商品，深入瞭解不同商品的特性，擅長全方位分析與評估，並與全球頂尖的私人銀行、專業稅務與金融團隊合作，建議周全保險規劃，去配合客戶不同時期的資產保全與財富增值，務求能按每位客戶的獨特需求，量身設計最佳的保險規劃方案。</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_12.jpg\"/></div></div></div><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">完善</em><em class=\"smallText\">的產品分析和比較</em></p><p class=\"normarText\">NCI 與保險公司保持密切的合作關係，藉此快速掌握市場最新資訊，使客戶充分瞭解商品的動向、獲利分析、成本計算及其變動。同時，NCI\n的專業團隊運用長期累積的豐富經驗，按客戶需求，分析各家保險商品的優缺利弊，協助客戶充分運用保險與銀行服務，選擇最具自主性的保險理財方案。</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_13.jpg\"/></div></div></div><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">尊榮</em><em class=\"smallText\">的客戶服務</em></p><p class=\"normarText\">NCI 以客為尊，提供優質服務，包括：</p><p class=\"circleText\">為客戶建立全方位保險規劃</p><p class=\"circleText\">製作完善的保險商品分析和比較</p><p class=\"circleText\">提供客戶金融保險市場最新資訊</p><p class=\"circleText\">按原始保險規劃，主動進行年度報表之審查、分析保單逐年的表現，以維護客戶權益</p><p class=\"circleText\">協助高資產客戶建立正確的保險觀念</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_14.jpg\"/></div></div></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "優質服務",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 16:30:36",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40132,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/d7564750-42a2-41f7-8cda-a6e15d41db14.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40132,
              "Name": "優質服務",
              "ParentId": 0,
              "Path": "40132",
              "CatPaths": [
                {
                  "CatId": "40132",
                  "PathName": "優質服務"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"20349\",\"ContentId\":\"20349\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20349,
            "Key": "K20260105163036",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "優質服務",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"ExcellentServiceBox\"><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">提供</em><em class=\"smallText\">全面保險規劃</em></p><p class=\"normarText\">NCI\n代理多家國際知名保險公司的保險商品，深入瞭解不同商品的特性，擅長全方位分析與評估，並與全球頂尖的私人銀行、專業稅務與金融團隊合作，建議周全保險規劃，去配合客戶不同時期的資產保全與財富增值，務求能按每位客戶的獨特需求，量身設計最佳的保險規劃方案。</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_12.jpg\"/></div></div></div><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">完善</em><em class=\"smallText\">的產品分析和比較</em></p><p class=\"normarText\">NCI 與保險公司保持密切的合作關係，藉此快速掌握市場最新資訊，使客戶充分瞭解商品的動向、獲利分析、成本計算及其變動。同時，NCI\n的專業團隊運用長期累積的豐富經驗，按客戶需求，分析各家保險商品的優缺利弊，協助客戶充分運用保險與銀行服務，選擇最具自主性的保險理財方案。</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_13.jpg\"/></div></div></div><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">尊榮</em><em class=\"smallText\">的客戶服務</em></p><p class=\"normarText\">NCI 以客為尊，提供優質服務，包括：</p><p class=\"circleText\">為客戶建立全方位保險規劃</p><p class=\"circleText\">製作完善的保險商品分析和比較</p><p class=\"circleText\">提供客戶金融保險市場最新資訊</p><p class=\"circleText\">按原始保險規劃，主動進行年度報表之審查、分析保單逐年的表現，以維護客戶權益</p><p class=\"circleText\">協助高資產客戶建立正確的保險觀念</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_14.jpg\"/></div></div></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "優質服務",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 16:30:36",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40132,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/01e2bf99-4d43-4e5f-b9c7-2eda80034a4d.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40132,
              "Name": "優質服務",
              "ParentId": 0,
              "Path": "40132",
              "CatPaths": [
                {
                  "CatId": "40132",
                  "PathName": "優質服務"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"20350\",\"ContentId\":\"20350\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20350,
            "Key": "K20260105163059",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "萬用壽險",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"UniversalLifeInsuranceBox\"><div class=\"topbox\"><div class=\"warper\"><p class=\"perText\">萬用壽險是集人壽保障和財富增值於一身之保險商品。與傳統壽險產品相比，萬用壽險在提供保障之餘，更能獲取相對穩健的獲利回報，以達致儲蓄、資產增值與傳承目的。</p></div></div><div class=\"contentBox\"><div class=\"leftT\"><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">更靈活彈性的保險類型 </em></p><p class=\"NrText\">萬用壽險保單大多容許投保人按實際需要更改受保金額，又或更改保單的儲蓄成分，保費可彈性調整。投保人也可按個人條件與金融環境，隨時投入更多資金或提取累積的現金價值。相較傳統壽險產品，萬用壽險更為靈活有彈性，透明度亦更高，能配合投保人的實際家庭及經濟狀況，提供彈性的自主空間，迎合不同人生階段的需要。</p></div><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">保費/保單融資 </em></p><p class=\"NrText\">萬用壽險保單具備穩健的價值，可做為私人銀行貸款之擔保品，使高資產客戶得以善用低利率的融資槓桿操作，提升理財效益。無論是運用保費融資取得高額壽險保障，或利用保單融資額度累積一筆潛在的備用資金，以進行投資、傳承、退休計畫等多項規劃，讓財富保值的同時亦可更有效率的達成多元財務目標。NCI 與多家私人銀行及金融機構緊密合作，按客戶需要，提供保費或保單的融資服務。。</p></div></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_22.jpg\"/></div></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "萬用壽險",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 16:30:59",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40133,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/dc3c9aba-8168-4b49-874a-53ae863e8354.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40133,
              "Name": "萬用壽險",
              "ParentId": 0,
              "Path": "40133",
              "CatPaths": [
                {
                  "CatId": "40133",
                  "PathName": "萬用壽險"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"20350\",\"ContentId\":\"20350\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20350,
            "Key": "K20260105163059",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "萬用壽險",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"UniversalLifeInsuranceBox\"><div class=\"topbox\"><div class=\"warper\"><p class=\"perText\">萬用壽險是集人壽保障和財富增值於一身之保險商品。與傳統壽險產品相比，萬用壽險在提供保障之餘，更能獲取相對穩健的獲利回報，以達致儲蓄、資產增值與傳承目的。</p></div></div><div class=\"contentBox\"><div class=\"leftT\"><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">更靈活彈性的保險類型 </em></p><p class=\"NrText\">萬用壽險保單大多容許投保人按實際需要更改受保金額，又或更改保單的儲蓄成分，保費可彈性調整。投保人也可按個人條件與金融環境，隨時投入更多資金或提取累積的現金價值。相較傳統壽險產品，萬用壽險更為靈活有彈性，透明度亦更高，能配合投保人的實際家庭及經濟狀況，提供彈性的自主空間，迎合不同人生階段的需要。</p></div><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">保費/保單融資 </em></p><p class=\"NrText\">萬用壽險保單具備穩健的價值，可做為私人銀行貸款之擔保品，使高資產客戶得以善用低利率的融資槓桿操作，提升理財效益。無論是運用保費融資取得高額壽險保障，或利用保單融資額度累積一筆潛在的備用資金，以進行投資、傳承、退休計畫等多項規劃，讓財富保值的同時亦可更有效率的達成多元財務目標。NCI 與多家私人銀行及金融機構緊密合作，按客戶需要，提供保費或保單的融資服務。。</p></div></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_22.jpg\"/></div></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "萬用壽險",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 16:30:59",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40133,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0ae31735-79f4-44fd-9338-216971e31dad.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40133,
              "Name": "萬用壽險",
              "ParentId": 0,
              "Path": "40133",
              "CatPaths": [
                {
                  "CatId": "40133",
                  "PathName": "萬用壽險"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeRelated\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeRelated\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeAbout\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20340,
            "Key": "HomeAbout",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "關於NCI",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"HomeNormal\"><p class=\"perText\"><em class=\"colorText\">新世紀國際保險顧問有限公司（NCI）</em>於2007年成立，乃保險業監管局的會員（牌照號碼FB1543）主要業務為提供客戶優質的保險中介服務。NCI 擁有完整豐富資歷與多年經驗的專業團隊，在保險規劃領域極具獨創性與主導性，致力為全球高資產客戶提供人壽保險規劃建議，量身設計專屬並縱覽全球的專業服務。</p><p class=\"perText\">高資產客戶的需求不一，NCI 堅守以客為尊信念，深入瞭解每位客戶的獨特需求……</p></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "關於NCI",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 10:52:40",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0cb969dd-55f4-4c53-bbe1-9bdf58e7498e.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "首頁相關",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "首頁相關"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": "20341",
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeAbout\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20340,
            "Key": "HomeAbout",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "關於NCI",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"HomeNormal\"><p class=\"perText\"><em class=\"colorText\">新世紀國際保險顧問有限公司（NCI）</em>於2007年成立，乃保險業監管局的會員（牌照號碼FB1543），主要業務為提供客戶優質的保險中介服務。NCI 擁有完整豐富資歷與多年經驗的專業團隊，在保險規劃領域極具獨創性與主導性，致力為全球高資產客戶提供人壽保險規劃建議，量身設計專屬並縱覽全球的專業服務。</p><p class=\"perText\">高資產客戶的需求不一，NCI 堅守以客為尊信念，深入瞭解每位客戶的獨特需求……</p></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "關於NCI",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 10:52:40",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/5e466c8a-c463-40cb-b1eb-3966dfb332f4.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "首頁相關",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "首頁相關"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": "20341",
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeBusinessPhilosophy\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20341,
            "Key": "HomeBusinessPhilosophy",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "經營理念",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"HomeNormal\"><p class=\"perText\">保險是個人與家庭重要的資產屏障。人生起伏多變，一生奮鬥所累積的財富更可能隨著市場環境之變化而波動。因此，高資產客戶格外需要更積極兼有效益的保險理財規劃，藉此建置厚實的財富屏障，使家族基業得以穩固且茁壯。</p><p class=\"perText\">NCI 洞悉每一位高資產客戶的獨特需求，堅守專業與嚴謹的服務品質，助您完成財富傳承大業……</p></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "經營理念",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 10:53:37",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0667ecec-42aa-4579-bd0e-30bce7c2cb05.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "首頁相關",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "首頁相關"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": "20340",
            "NextId": "20342",
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeBusinessPhilosophy\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20341,
            "Key": "HomeBusinessPhilosophy",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "經營理念",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"HomeNormal\"><p class=\"perText\">保險是個人與家庭重要的資產屏障。人生起伏多變，一生奮鬥所累積的財富更可能隨著市場環境之變化而波動。因此，高資產客戶格外需要更積極兼有效益的保險理財規劃，藉此建置厚實的財富屏障，使家族基業得以穩固且茁壯。</p><p class=\"perText\">NCI 洞悉每一位高資產客戶的獨特需求，堅守專業與嚴謹的服務品質，助您完成財富傳承大業……</p></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "經營理念",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 10:53:37",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/c98b9ba6-b92b-4850-b3c4-78a06e1f1e68.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "首頁相關",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "首頁相關"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": "20340",
            "NextId": "20342",
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeQualityService\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20342,
            "Key": "HomeQualityService",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "優質服務",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "優質服務",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 10:54:26",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/9d33db81-8d18-47ab-b094-fcefd67b61c7.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "首頁相關",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "首頁相關"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": "20341",
            "NextId": "20343",
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeQualityService\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20342,
            "Key": "HomeQualityService",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "優質服務",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "優質服務",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 10:54:26",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/ccd42020-f121-4be6-82d7-64a277b99d6b.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "首頁相關",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "首頁相關"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": "20341",
            "NextId": "20343",
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeUniversalLifeInsurance\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20343,
            "Key": "HomeUniversalLifeInsurance",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "萬用壽險",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"HomeNormal\"><p class=\"perText\">萬用壽險是集人壽保障和財富增值於一身之保險商品。與傳統壽險產品相比，萬用壽險在提供保障之餘，更能獲取相對穩健的獲利回報，以達致儲蓄、資產增值與傳承目的……</p></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "萬用壽險",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 10:54:59",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/3d242c00-301d-4a2d-bb1d-2f83a18a779e.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "首頁相關",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "首頁相關"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": "20342",
            "NextId": "20344",
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeUniversalLifeInsurance\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20343,
            "Key": "HomeUniversalLifeInsurance",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "萬用壽險",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"HomeNormal\"><p class=\"perText\">萬用壽險是集人壽保障和財富增值於一身之保險商品。與傳統壽險產品相比，萬用壽險在提供保障之餘，更能獲取相對穩健的獲利回報，以達致儲蓄、資產增值與傳承目的……</p></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "萬用壽險",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 10:54:59",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/b01b6a8d-da30-4e94-871d-ce4603e10b0a.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "首頁相關",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "首頁相關"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": "20342",
            "NextId": "20344",
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeContactUs\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20345,
            "Key": "HomeContactUs",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "聯絡我們",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">地址：</p><p class=\"text\">香港九龍長沙灣道833號長沙灣廣場一期5樓502A室</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">電話：</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">傳真：</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">電郵：</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "聯絡我們",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 11:49:48",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "首頁相關",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "首頁相關"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": "20344",
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeContactUs\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20345,
            "Key": "HomeContactUs",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "聯絡我們",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">地址：</p><p class=\"text\">香港九龍長沙灣道833號長沙灣廣場一期5樓502A室</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">電話：</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">傳真：</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">電郵：</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "聯絡我們",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 11:49:48",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "首頁相關",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "首頁相關"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": "20344",
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeMap\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20344,
            "Key": "HomeMap",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "Map",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<p><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.4372524704454!2d114.14615207586719!3d22.33711294155908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340407548be66e61%3A0xc6bc9dedfdffc038!2z6ZW_5rKZ5rm-5bm_5Zy6!5e0!3m2!1szh-CN!2shk!4v1767584496915!5m2!1szh-CN!2shk\" width=\"100%\" height=\"100%\" frameborder=\"0\"></iframe></p>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "Map",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 11:43:13",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "首頁相關",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "首頁相關"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": "20343",
            "NextId": "20345",
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeMap\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20344,
            "Key": "HomeMap",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "Map",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<p><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.4372524704454!2d114.14615207586719!3d22.33711294155908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340407548be66e61%3A0xc6bc9dedfdffc038!2z6ZW_5rKZ5rm-5bm_5Zy6!5e0!3m2!1szh-CN!2shk!4v1767584496915!5m2!1szh-CN!2shk\" width=\"100%\" height=\"100%\" frameborder=\"0\"></iframe></p>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "Map",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 11:43:13",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "首頁相關",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "首頁相關"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": "20343",
            "NextId": "20345",
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"footerContact\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"footerContact\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"LINK\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"LINK\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"AppointmentRenewal\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"AppointmentRenewal\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        }
      },
      "contentByKey": {
        "{\"key\":\"HomeRelated\"}": {
          "Id": 0,
          "Key": "",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 0,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/?flag=1778685603877",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 0,
            "Name": null,
            "ParentId": 0,
            "Path": null,
            "CatPaths": null
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": null,
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"key\":\"HomeAbout\"}": {
          "Id": 20340,
          "Key": "HomeAbout",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "關於NCI",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "<div class=\"HomeNormal\"><p class=\"perText\"><em class=\"colorText\">新世紀國際保險顧問有限公司（NCI）</em>於2007年成立，乃保險業監管局的會員（牌照號碼FB1543）主要業務為提供客戶優質的保險中介服務。NCI 擁有完整豐富資歷與多年經驗的專業團隊，在保險規劃領域極具獨創性與主導性，致力為全球高資產客戶提供人壽保險規劃建議，量身設計專屬並縱覽全球的專業服務。</p><p class=\"perText\">高資產客戶的需求不一，NCI 堅守以客為尊信念，深入瞭解每位客戶的獨特需求……</p></div>",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "關於NCI",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 10:52:40",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40128,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0cb969dd-55f4-4c53-bbe1-9bdf58e7498e.jpg",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40128,
            "Name": "首頁相關",
            "ParentId": 0,
            "Path": "40128",
            "CatPaths": [
              {
                "CatId": "40128",
                "PathName": "首頁相關"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": null,
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"key\":\"HomeBusinessPhilosophy\"}": {
          "Id": 20341,
          "Key": "HomeBusinessPhilosophy",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "經營理念",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "<div class=\"HomeNormal\"><p class=\"perText\">保險是個人與家庭重要的資產屏障。人生起伏多變，一生奮鬥所累積的財富更可能隨著市場環境之變化而波動。因此，高資產客戶格外需要更積極兼有效益的保險理財規劃，藉此建置厚實的財富屏障，使家族基業得以穩固且茁壯。</p><p class=\"perText\">NCI 洞悉每一位高資產客戶的獨特需求，堅守專業與嚴謹的服務品質，助您完成財富傳承大業……</p></div>",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "經營理念",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 10:53:37",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40128,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0667ecec-42aa-4579-bd0e-30bce7c2cb05.jpg",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40128,
            "Name": "首頁相關",
            "ParentId": 0,
            "Path": "40128",
            "CatPaths": [
              {
                "CatId": "40128",
                "PathName": "首頁相關"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": null,
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"key\":\"HomeQualityService\"}": {
          "Id": 20342,
          "Key": "HomeQualityService",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "優質服務",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "優質服務",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 10:54:26",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40128,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/9d33db81-8d18-47ab-b094-fcefd67b61c7.jpg",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40128,
            "Name": "首頁相關",
            "ParentId": 0,
            "Path": "40128",
            "CatPaths": [
              {
                "CatId": "40128",
                "PathName": "首頁相關"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": null,
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"key\":\"HomeUniversalLifeInsurance\"}": {
          "Id": 20343,
          "Key": "HomeUniversalLifeInsurance",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "萬用壽險",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "<div class=\"HomeNormal\"><p class=\"perText\">萬用壽險是集人壽保障和財富增值於一身之保險商品。與傳統壽險產品相比，萬用壽險在提供保障之餘，更能獲取相對穩健的獲利回報，以達致儲蓄、資產增值與傳承目的……</p></div>",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "萬用壽險",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 10:54:59",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40128,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/3d242c00-301d-4a2d-bb1d-2f83a18a779e.jpg",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40128,
            "Name": "首頁相關",
            "ParentId": 0,
            "Path": "40128",
            "CatPaths": [
              {
                "CatId": "40128",
                "PathName": "首頁相關"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": null,
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"key\":\"HomeContactUs\"}": {
          "Id": 20345,
          "Key": "HomeContactUs",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "聯絡我們",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">地址：</p><p class=\"text\">香港九龍長沙灣道833號長沙灣廣場一期5樓502A室</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">電話：</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">傳真：</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">電郵：</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "聯絡我們",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 11:49:48",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40128,
          "Cover": "",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40128,
            "Name": "首頁相關",
            "ParentId": 0,
            "Path": "40128",
            "CatPaths": [
              {
                "CatId": "40128",
                "PathName": "首頁相關"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": null,
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"key\":\"HomeMap\"}": {
          "Id": 20344,
          "Key": "HomeMap",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "Map",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "<p><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.4372524704454!2d114.14615207586719!3d22.33711294155908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340407548be66e61%3A0xc6bc9dedfdffc038!2z6ZW_5rKZ5rm-5bm_5Zy6!5e0!3m2!1szh-CN!2shk!4v1767584496915!5m2!1szh-CN!2shk\" width=\"100%\" height=\"100%\" frameborder=\"0\"></iframe></p>",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "Map",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 11:43:13",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40128,
          "Cover": "",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40128,
            "Name": "首頁相關",
            "ParentId": 0,
            "Path": "40128",
            "CatPaths": [
              {
                "CatId": "40128",
                "PathName": "首頁相關"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": null,
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"key\":\"footerContact\"}": {
          "Id": 0,
          "Key": "",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 0,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/?flag=1778685624955",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 0,
            "Name": null,
            "ParentId": 0,
            "Path": null,
            "CatPaths": null
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": null,
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"key\":\"LINK\"}": {
          "Id": 0,
          "Key": "",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 0,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/?flag=1778685627737",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 0,
            "Name": null,
            "ParentId": 0,
            "Path": null,
            "CatPaths": null
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": null,
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"key\":\"AppointmentRenewal\"}": {
          "Id": 0,
          "Key": "",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 0,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/?flag=1778685629533",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 0,
            "Name": null,
            "ParentId": 0,
            "Path": null,
            "CatPaths": null
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": null,
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        }
      },
      "contentsByCatKey": {
        "{\"key\":\"HomeRelated\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 1,
          "TotalRecord": 6,
          "Data": [
            {
              "Id": 20340,
              "Key": "HomeAbout",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "關於NCI",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeNormal\"><p class=\"perText\"><em class=\"colorText\">新世紀國際保險顧問有限公司（NCI）</em>於2007年成立，乃保險業監管局的會員（牌照號碼FB1543）主要業務為提供客戶優質的保險中介服務。NCI 擁有完整豐富資歷與多年經驗的專業團隊，在保險規劃領域極具獨創性與主導性，致力為全球高資產客戶提供人壽保險規劃建議，量身設計專屬並縱覽全球的專業服務。</p><p class=\"perText\">高資產客戶的需求不一，NCI 堅守以客為尊信念，深入瞭解每位客戶的獨特需求……</p></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "關於NCI",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:52:40",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:52:40",
              "UpdateDateVal": "2026-05-07 15:45:50",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0cb969dd-55f4-4c53-bbe1-9bdf58e7498e.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "首頁相關",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "首頁相關"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:51:49",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            },
            {
              "Id": 20345,
              "Key": "HomeContactUs",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "聯絡我們",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">地址：</p><p class=\"text\">香港九龍長沙灣道833號長沙灣廣場一期5樓502A室</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">電話：</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">傳真：</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">電郵：</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "聯絡我們",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 11:49:48",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 11:49:48",
              "UpdateDateVal": "2026-01-05 11:49:48",
              "CatId": 40128,
              "Cover": "",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "首頁相關",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "首頁相關"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 11:48:37",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            },
            {
              "Id": 20344,
              "Key": "HomeMap",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Map",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<p><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.4372524704454!2d114.14615207586719!3d22.33711294155908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340407548be66e61%3A0xc6bc9dedfdffc038!2z6ZW_5rKZ5rm-5bm_5Zy6!5e0!3m2!1szh-CN!2shk!4v1767584496915!5m2!1szh-CN!2shk\" width=\"100%\" height=\"100%\" frameborder=\"0\"></iframe></p>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Map",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 11:43:13",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 11:43:13",
              "UpdateDateVal": "2026-01-05 11:43:13",
              "CatId": 40128,
              "Cover": "",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "首頁相關",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "首頁相關"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 11:42:07",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            },
            {
              "Id": 20342,
              "Key": "HomeQualityService",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "優質服務",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "優質服務",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:54:26",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:54:26",
              "UpdateDateVal": "2026-01-05 11:25:57",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/9d33db81-8d18-47ab-b094-fcefd67b61c7.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "首頁相關",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "首頁相關"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:53:40",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            },
            {
              "Id": 20343,
              "Key": "HomeUniversalLifeInsurance",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "萬用壽險",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeNormal\"><p class=\"perText\">萬用壽險是集人壽保障和財富增值於一身之保險商品。與傳統壽險產品相比，萬用壽險在提供保障之餘，更能獲取相對穩健的獲利回報，以達致儲蓄、資產增值與傳承目的……</p></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "萬用壽險",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:54:59",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:54:59",
              "UpdateDateVal": "2026-01-05 11:21:47",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/3d242c00-301d-4a2d-bb1d-2f83a18a779e.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "首頁相關",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "首頁相關"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:54:29",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            },
            {
              "Id": 20341,
              "Key": "HomeBusinessPhilosophy",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "經營理念",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeNormal\"><p class=\"perText\">保險是個人與家庭重要的資產屏障。人生起伏多變，一生奮鬥所累積的財富更可能隨著市場環境之變化而波動。因此，高資產客戶格外需要更積極兼有效益的保險理財規劃，藉此建置厚實的財富屏障，使家族基業得以穩固且茁壯。</p><p class=\"perText\">NCI 洞悉每一位高資產客戶的獨特需求，堅守專業與嚴謹的服務品質，助您完成財富傳承大業……</p></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "經營理念",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:53:37",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:53:37",
              "UpdateDateVal": "2026-01-05 11:06:26",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0667ecec-42aa-4579-bd0e-30bce7c2cb05.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "首頁相關",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "首頁相關"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:52:46",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            }
          ],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"key\":\"HomeAbout\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"key\":\"HomeBusinessPhilosophy\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"key\":\"HomeQualityService\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"key\":\"HomeUniversalLifeInsurance\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"key\":\"HomeContactUs\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"key\":\"HomeMap\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"key\":\"footerContact\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"key\":\"LINK\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"key\":\"AppointmentRenewal\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        }
      },
      "contentsByCatKeyEx": {
        "{\"Key\":\"HomeRelated\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 1,
          "TotalRecord": 6,
          "Data": [
            {
              "Id": 20340,
              "Key": "HomeAbout",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "關於NCI",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeNormal\"><p class=\"perText\"><em class=\"colorText\">新世紀國際保險顧問有限公司（NCI）</em>於2007年成立，乃保險業監管局的會員（牌照號碼FB1543）主要業務為提供客戶優質的保險中介服務。NCI 擁有完整豐富資歷與多年經驗的專業團隊，在保險規劃領域極具獨創性與主導性，致力為全球高資產客戶提供人壽保險規劃建議，量身設計專屬並縱覽全球的專業服務。</p><p class=\"perText\">高資產客戶的需求不一，NCI 堅守以客為尊信念，深入瞭解每位客戶的獨特需求……</p></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "關於NCI",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:52:40",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:52:40",
              "UpdateDateVal": "2026-05-07 15:45:50",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0cb969dd-55f4-4c53-bbe1-9bdf58e7498e.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "首頁相關",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "首頁相關"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:51:49",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": "星期一",
              "ContentDateTimeStr": "2026年01月05日 10:51:49",
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            },
            {
              "Id": 20345,
              "Key": "HomeContactUs",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "聯絡我們",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">地址：</p><p class=\"text\">香港九龍長沙灣道833號長沙灣廣場一期5樓502A室</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">電話：</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">傳真：</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">電郵：</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "聯絡我們",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 11:49:48",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 11:49:48",
              "UpdateDateVal": "2026-01-05 11:49:48",
              "CatId": 40128,
              "Cover": "",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "首頁相關",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "首頁相關"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 11:48:37",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": "星期一",
              "ContentDateTimeStr": "2026年01月05日 11:48:37",
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            },
            {
              "Id": 20344,
              "Key": "HomeMap",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Map",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<p><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.4372524704454!2d114.14615207586719!3d22.33711294155908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340407548be66e61%3A0xc6bc9dedfdffc038!2z6ZW_5rKZ5rm-5bm_5Zy6!5e0!3m2!1szh-CN!2shk!4v1767584496915!5m2!1szh-CN!2shk\" width=\"100%\" height=\"100%\" frameborder=\"0\"></iframe></p>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Map",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 11:43:13",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 11:43:13",
              "UpdateDateVal": "2026-01-05 11:43:13",
              "CatId": 40128,
              "Cover": "",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "首頁相關",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "首頁相關"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 11:42:07",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": "星期一",
              "ContentDateTimeStr": "2026年01月05日 11:42:07",
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            },
            {
              "Id": 20342,
              "Key": "HomeQualityService",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "優質服務",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "優質服務",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:54:26",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:54:26",
              "UpdateDateVal": "2026-01-05 11:25:57",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/9d33db81-8d18-47ab-b094-fcefd67b61c7.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "首頁相關",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "首頁相關"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:53:40",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": "星期一",
              "ContentDateTimeStr": "2026年01月05日 10:53:40",
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            },
            {
              "Id": 20343,
              "Key": "HomeUniversalLifeInsurance",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "萬用壽險",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeNormal\"><p class=\"perText\">萬用壽險是集人壽保障和財富增值於一身之保險商品。與傳統壽險產品相比，萬用壽險在提供保障之餘，更能獲取相對穩健的獲利回報，以達致儲蓄、資產增值與傳承目的……</p></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "萬用壽險",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:54:59",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:54:59",
              "UpdateDateVal": "2026-01-05 11:21:47",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/3d242c00-301d-4a2d-bb1d-2f83a18a779e.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "首頁相關",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "首頁相關"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:54:29",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": "星期一",
              "ContentDateTimeStr": "2026年01月05日 10:54:29",
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            },
            {
              "Id": 20341,
              "Key": "HomeBusinessPhilosophy",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "經營理念",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeNormal\"><p class=\"perText\">保險是個人與家庭重要的資產屏障。人生起伏多變，一生奮鬥所累積的財富更可能隨著市場環境之變化而波動。因此，高資產客戶格外需要更積極兼有效益的保險理財規劃，藉此建置厚實的財富屏障，使家族基業得以穩固且茁壯。</p><p class=\"perText\">NCI 洞悉每一位高資產客戶的獨特需求，堅守專業與嚴謹的服務品質，助您完成財富傳承大業……</p></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "經營理念",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:53:37",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:53:37",
              "UpdateDateVal": "2026-01-05 11:06:26",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0667ecec-42aa-4579-bd0e-30bce7c2cb05.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "首頁相關",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "首頁相關"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:52:46",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": "星期一",
              "ContentDateTimeStr": "2026年01月05日 10:52:46",
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            }
          ],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"Key\":\"HomeAbout\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"Key\":\"HomeBusinessPhilosophy\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"Key\":\"HomeQualityService\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"Key\":\"HomeUniversalLifeInsurance\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"Key\":\"HomeContactUs\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"Key\":\"HomeMap\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"Key\":\"footerContact\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"Key\":\"LINK\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"Key\":\"AppointmentRenewal\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        }
      },
      "contentsByCatId": {
        "{\"catId\":\"40137\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        }
      },
      "contents": {},
      "categoryTree": {
        "{\"id\":\"40137\"}": [],
        "{\"Id\":40137}": []
      },
      "nextCategoryTree": {},
      "subCatContents": {
        "{\"CatId\":\"40137\",\"IsMobile\":false}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"CatId\":\"40137\",\"IsMobile\":true}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        }
      },
      "lastestContents": {},
      "categoryRelateContent": {},
      "contentsByTitle": {
        "{\"Title\":\"\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 2,
          "TotalRecord": 11,
          "Data": [
            {
              "Id": 20340,
              "Key": "HomeAbout",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "關於NCI",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeNormal\"><p class=\"perText\"><em class=\"colorText\">新世紀國際保險顧問有限公司（NCI）</em>於2007年成立，乃保險業監管局的會員（牌照號碼FB1543）主要業務為提供客戶優質的保險中介服務。NCI 擁有完整豐富資歷與多年經驗的專業團隊，在保險規劃領域極具獨創性與主導性，致力為全球高資產客戶提供人壽保險規劃建議，量身設計專屬並縱覽全球的專業服務。</p><p class=\"perText\">高資產客戶的需求不一，NCI 堅守以客為尊信念，深入瞭解每位客戶的獨特需求……</p></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "關於NCI",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:52:40",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:52:40",
              "UpdateDateVal": "2026-05-07 15:45:50",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0cb969dd-55f4-4c53-bbe1-9bdf58e7498e.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "首頁相關",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "首頁相關"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:51:49",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": null
            },
            {
              "Id": 20346,
              "Key": "K20260105143250",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "關於NCI",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"AboutNCI\"><div class=\"contentBox\"><div class=\"leftT\"><p class=\"perText\"><em class=\"colorText\">新世紀國際保險顧問有限公司(NCI）</em>於2007年成立，乃香港保險業監理局的會員（牌照號碼FB1543），主要業務為提供客戶優質的保險中介服務。NCI\n擁有完整豐富資歷與多年經驗的專業團隊，在保險規劃領域極具獨創性與主導性，致力為全球高資產客戶提供人壽保險規劃建議，量身設計專屬並縱覽全球的專業服務。</p><p class=\"perText\">高資產客戶的需求不一，NCI 堅守以客為尊信念，深入瞭解每位客戶的獨特需求，提供全方位保險商品建議與銷售。 誠信是最根本的核心價值，NCI\n秉持信念，慎選保險商品與合作夥伴，全力維護客戶權益。我們憑藉獨創完善的保險規劃，提供貼身的優質服務予每位高資產客戶，致力於追求與客戶的互信與長期合作。</p><p class=\"perText\">NCI\n代理多家國際知名保險公司的商品，並與各相關專業夥伴機構如私人銀行、資產管理顧問、會計師等團隊建立緊密的互動關係，竭力為高資產客戶制定最適合的保險方案，配合客戶的資產配置、傳承與理財規劃等目標。</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_29.jpg\"/></div></div><div class=\"bottomImg\"><img src=\"/nci/images/pc/pc_30.jpg\"/></div></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "關於NCI",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 14:32:50",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 14:32:50",
              "UpdateDateVal": "2026-05-06 15:36:56",
              "CatId": 40129,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/88169d3b-ab92-4ef4-aa4b-219e9a548b7b.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40129,
                "Name": "關於NCI",
                "ParentId": 0,
                "Path": "40129",
                "CatPaths": [
                  {
                    "CatId": "40129",
                    "PathName": "關於NCI"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 14:32:33",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": null
            },
            {
              "Id": 20349,
              "Key": "K20260105163036",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "優質服務",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"ExcellentServiceBox\"><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">提供</em><em class=\"smallText\">全面保險規劃</em></p><p class=\"normarText\">NCI\n代理多家國際知名保險公司的保險商品，深入瞭解不同商品的特性，擅長全方位分析與評估，並與全球頂尖的私人銀行、專業稅務與金融團隊合作，建議周全保險規劃，去配合客戶不同時期的資產保全與財富增值，務求能按每位客戶的獨特需求，量身設計最佳的保險規劃方案。</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_12.jpg\"/></div></div></div><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">完善</em><em class=\"smallText\">的產品分析和比較</em></p><p class=\"normarText\">NCI 與保險公司保持密切的合作關係，藉此快速掌握市場最新資訊，使客戶充分瞭解商品的動向、獲利分析、成本計算及其變動。同時，NCI\n的專業團隊運用長期累積的豐富經驗，按客戶需求，分析各家保險商品的優缺利弊，協助客戶充分運用保險與銀行服務，選擇最具自主性的保險理財方案。</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_13.jpg\"/></div></div></div><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">尊榮</em><em class=\"smallText\">的客戶服務</em></p><p class=\"normarText\">NCI 以客為尊，提供優質服務，包括：</p><p class=\"circleText\">為客戶建立全方位保險規劃</p><p class=\"circleText\">製作完善的保險商品分析和比較</p><p class=\"circleText\">提供客戶金融保險市場最新資訊</p><p class=\"circleText\">按原始保險規劃，主動進行年度報表之審查、分析保單逐年的表現，以維護客戶權益</p><p class=\"circleText\">協助高資產客戶建立正確的保險觀念</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_14.jpg\"/></div></div></div></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "優質服務",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 16:30:36",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 16:30:36",
              "UpdateDateVal": "2026-01-06 15:59:30",
              "CatId": 40132,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/d7564750-42a2-41f7-8cda-a6e15d41db14.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40132,
                "Name": "優質服務",
                "ParentId": 0,
                "Path": "40132",
                "CatPaths": [
                  {
                    "CatId": "40132",
                    "PathName": "優質服務"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 16:30:14",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": null
            },
            {
              "Id": 20350,
              "Key": "K20260105163059",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "萬用壽險",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"UniversalLifeInsuranceBox\"><div class=\"topbox\"><div class=\"warper\"><p class=\"perText\">萬用壽險是集人壽保障和財富增值於一身之保險商品。與傳統壽險產品相比，萬用壽險在提供保障之餘，更能獲取相對穩健的獲利回報，以達致儲蓄、資產增值與傳承目的。</p></div></div><div class=\"contentBox\"><div class=\"leftT\"><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">更靈活彈性的保險類型 </em></p><p class=\"NrText\">萬用壽險保單大多容許投保人按實際需要更改受保金額，又或更改保單的儲蓄成分，保費可彈性調整。投保人也可按個人條件與金融環境，隨時投入更多資金或提取累積的現金價值。相較傳統壽險產品，萬用壽險更為靈活有彈性，透明度亦更高，能配合投保人的實際家庭及經濟狀況，提供彈性的自主空間，迎合不同人生階段的需要。</p></div><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">保費/保單融資 </em></p><p class=\"NrText\">萬用壽險保單具備穩健的價值，可做為私人銀行貸款之擔保品，使高資產客戶得以善用低利率的融資槓桿操作，提升理財效益。無論是運用保費融資取得高額壽險保障，或利用保單融資額度累積一筆潛在的備用資金，以進行投資、傳承、退休計畫等多項規劃，讓財富保值的同時亦可更有效率的達成多元財務目標。NCI 與多家私人銀行及金融機構緊密合作，按客戶需要，提供保費或保單的融資服務。。</p></div></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_22.jpg\"/></div></div></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "萬用壽險",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 16:30:59",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 16:30:59",
              "UpdateDateVal": "2026-01-06 15:25:08",
              "CatId": 40133,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/dc3c9aba-8168-4b49-874a-53ae863e8354.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40133,
                "Name": "萬用壽險",
                "ParentId": 0,
                "Path": "40133",
                "CatPaths": [
                  {
                    "CatId": "40133",
                    "PathName": "萬用壽險"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 16:30:40",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": null
            },
            {
              "Id": 20348,
              "Key": "K20260105163008",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "經營理念",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"BusinessPhilosophyBox\"><div class=\"topbox\"><div class=\"warper\"><p class=\"perText\">保險是個人與家庭重要的資產屏障。人生起伏多變，一生奮鬥所累積的財富更可能隨著市場環境之變化而波動。因此，高資產客戶格外需要更積極兼有效益的保險理財規劃，藉此建置厚實的財富屏障，使家族基業得以穩固且茁壯。</p><p class=\"perText\">NCI 洞悉每一位高資產客戶的獨特需求，堅守專業與嚴謹的服務品質，助您完成財富傳承大業。</p></div></div><div class=\"contentBox\"><div class=\"leftT\"><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">NCI </em><em class=\"smallText\">結合保險及其他策略夥伴，致力幫助高資產客戶：</em></p><p class=\"circleText\">擁有安定穩固的個人與家庭保障</p><p class=\"circleText\">整合財富資源、享受豐富人生</p><p class=\"circleText\">資產增值、財富世代傳承</p><p class=\"circleText\">積極正面的保險理財觀</p></div><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">NCI </em><em class=\"smallText\">與眾不同的獨特價值：</em></p><p class=\"circleText\">打破市場藩籬或商品導向，專為客戶量身規劃最佳保險方案</p><p class=\"circleText\">以客戶權益為優先，運用精算技術進行各保險商品比較</p><p class=\"circleText\">按客戶於人生各階段的不同需求，提供最適當的保險規劃</p><p class=\"circleText\">整合合作夥伴資源，協助客戶達成保險理財計劃</p><p class=\"circleText\">掌握趨勢，向國際保險集團建議研發最切合客戶需求的優質保險商品</p></div></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_18.jpg\"/></div></div></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "經營理念",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 16:30:08",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 16:30:08",
              "UpdateDateVal": "2026-01-06 14:59:48",
              "CatId": 40131,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/ee42a92e-5b0a-497f-afa4-ac01caceb482.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40131,
                "Name": "經營理念",
                "ParentId": 0,
                "Path": "40131",
                "CatPaths": [
                  {
                    "CatId": "40131",
                    "PathName": "經營理念"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 16:29:45",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": null
            },
            {
              "Id": 20347,
              "Key": "ContactUs",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "聯繫我們",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">地址：</p><p class=\"text\">香港九龍長沙灣道833號長沙灣廣場一期5樓502A室</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">電話：</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">傳真：</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">電郵：</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "聯繫我們",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 14:56:39",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 14:56:39",
              "UpdateDateVal": "2026-01-05 15:01:24",
              "CatId": 40130,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/b5521f4f-fdb3-4f42-8c69-d9c44ce650aa.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40130,
                "Name": "聯繫我們",
                "ParentId": 0,
                "Path": "40130",
                "CatPaths": [
                  {
                    "CatId": "40130",
                    "PathName": "聯繫我們"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 14:56:20",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": null
            },
            {
              "Id": 20345,
              "Key": "HomeContactUs",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "聯絡我們",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">地址：</p><p class=\"text\">香港九龍長沙灣道833號長沙灣廣場一期5樓502A室</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">電話：</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">傳真：</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">電郵：</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "聯絡我們",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 11:49:48",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 11:49:48",
              "UpdateDateVal": "2026-01-05 11:49:48",
              "CatId": 40128,
              "Cover": "",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "首頁相關",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "首頁相關"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 11:48:37",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": null
            },
            {
              "Id": 20344,
              "Key": "HomeMap",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Map",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<p><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.4372524704454!2d114.14615207586719!3d22.33711294155908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340407548be66e61%3A0xc6bc9dedfdffc038!2z6ZW_5rKZ5rm-5bm_5Zy6!5e0!3m2!1szh-CN!2shk!4v1767584496915!5m2!1szh-CN!2shk\" width=\"100%\" height=\"100%\" frameborder=\"0\"></iframe></p>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Map",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 11:43:13",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 11:43:13",
              "UpdateDateVal": "2026-01-05 11:43:13",
              "CatId": 40128,
              "Cover": "",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "首頁相關",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "首頁相關"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 11:42:07",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": null
            },
            {
              "Id": 20342,
              "Key": "HomeQualityService",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "優質服務",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "優質服務",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:54:26",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:54:26",
              "UpdateDateVal": "2026-01-05 11:25:57",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/9d33db81-8d18-47ab-b094-fcefd67b61c7.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "首頁相關",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "首頁相關"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:53:40",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": null
            },
            {
              "Id": 20343,
              "Key": "HomeUniversalLifeInsurance",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "萬用壽險",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeNormal\"><p class=\"perText\">萬用壽險是集人壽保障和財富增值於一身之保險商品。與傳統壽險產品相比，萬用壽險在提供保障之餘，更能獲取相對穩健的獲利回報，以達致儲蓄、資產增值與傳承目的……</p></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "萬用壽險",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:54:59",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:54:59",
              "UpdateDateVal": "2026-01-05 11:21:47",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/3d242c00-301d-4a2d-bb1d-2f83a18a779e.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "首頁相關",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "首頁相關"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:54:29",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": null
            }
          ],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        }
      },
      "category": {
        "{\"id\":\"40137\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        }
      },
      "categoryByDevice": {
        "{\"Key\":\"HomeRelated\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 40128,
            "Key": "HomeRelated",
            "Name": "首頁相關",
            "Description": "首頁相關",
            "Content": "",
            "URL": "/cms/catDetail/40128",
            "OpenNewWin": true,
            "ParentId": 0,
            "PageStyle": "1",
            "Children": [],
            "Img": null,
            "Collapse": false,
            "ImagePath": "",
            "Path": "40128",
            "CatPaths": [
              {
                "CatId": "40128",
                "PathName": "首頁相關"
              }
            ],
            "SeoKeyword": "",
            "SeoDesc": "",
            "Father": [],
            "GroupId": 0,
            "RedirectURL": null,
            "Contents": [
              {
                "Id": 20340,
                "Key": "HomeAbout",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "關於NCI",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeNormal\"><p class=\"perText\"><em class=\"colorText\">新世紀國際保險顧問有限公司（NCI）</em>於2007年成立，乃保險業監管局的會員（牌照號碼FB1543）主要業務為提供客戶優質的保險中介服務。NCI 擁有完整豐富資歷與多年經驗的專業團隊，在保險規劃領域極具獨創性與主導性，致力為全球高資產客戶提供人壽保險規劃建議，量身設計專屬並縱覽全球的專業服務。</p><p class=\"perText\">高資產客戶的需求不一，NCI 堅守以客為尊信念，深入瞭解每位客戶的獨特需求……</p></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "關於NCI",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:52:40",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:52:40",
                "UpdateDateVal": "2026-05-07 15:45:50",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0cb969dd-55f4-4c53-bbe1-9bdf58e7498e.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "首頁相關",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "首頁相關"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:51:49",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": "星期一",
                "ContentDateTimeStr": "2026年01月05日 10:51:49",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20345,
                "Key": "HomeContactUs",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "聯絡我們",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">地址：</p><p class=\"text\">香港九龍長沙灣道833號長沙灣廣場一期5樓502A室</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">電話：</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">傳真：</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">電郵：</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "聯絡我們",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 11:49:48",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 11:49:48",
                "UpdateDateVal": "2026-01-05 11:49:48",
                "CatId": 40128,
                "Cover": "",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "首頁相關",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "首頁相關"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 11:48:37",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": "星期一",
                "ContentDateTimeStr": "2026年01月05日 11:48:37",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20344,
                "Key": "HomeMap",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "Map",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<p><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.4372524704454!2d114.14615207586719!3d22.33711294155908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340407548be66e61%3A0xc6bc9dedfdffc038!2z6ZW_5rKZ5rm-5bm_5Zy6!5e0!3m2!1szh-CN!2shk!4v1767584496915!5m2!1szh-CN!2shk\" width=\"100%\" height=\"100%\" frameborder=\"0\"></iframe></p>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "Map",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 11:43:13",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 11:43:13",
                "UpdateDateVal": "2026-01-05 11:43:13",
                "CatId": 40128,
                "Cover": "",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "首頁相關",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "首頁相關"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 11:42:07",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": "星期一",
                "ContentDateTimeStr": "2026年01月05日 11:42:07",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20342,
                "Key": "HomeQualityService",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "優質服務",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "優質服務",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:54:26",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:54:26",
                "UpdateDateVal": "2026-01-05 11:25:57",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/9d33db81-8d18-47ab-b094-fcefd67b61c7.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "首頁相關",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "首頁相關"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:53:40",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": "星期一",
                "ContentDateTimeStr": "2026年01月05日 10:53:40",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20343,
                "Key": "HomeUniversalLifeInsurance",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "萬用壽險",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeNormal\"><p class=\"perText\">萬用壽險是集人壽保障和財富增值於一身之保險商品。與傳統壽險產品相比，萬用壽險在提供保障之餘，更能獲取相對穩健的獲利回報，以達致儲蓄、資產增值與傳承目的……</p></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "萬用壽險",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:54:59",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:54:59",
                "UpdateDateVal": "2026-01-05 11:21:47",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/3d242c00-301d-4a2d-bb1d-2f83a18a779e.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "首頁相關",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "首頁相關"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:54:29",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": "星期一",
                "ContentDateTimeStr": "2026年01月05日 10:54:29",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20341,
                "Key": "HomeBusinessPhilosophy",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "經營理念",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeNormal\"><p class=\"perText\">保險是個人與家庭重要的資產屏障。人生起伏多變，一生奮鬥所累積的財富更可能隨著市場環境之變化而波動。因此，高資產客戶格外需要更積極兼有效益的保險理財規劃，藉此建置厚實的財富屏障，使家族基業得以穩固且茁壯。</p><p class=\"perText\">NCI 洞悉每一位高資產客戶的獨特需求，堅守專業與嚴謹的服務品質，助您完成財富傳承大業……</p></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "經營理念",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:53:37",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:53:37",
                "UpdateDateVal": "2026-01-05 11:06:26",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0667ecec-42aa-4579-bd0e-30bce7c2cb05.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "首頁相關",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "首頁相關"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:52:46",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": "星期一",
                "ContentDateTimeStr": "2026年01月05日 10:52:46",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              }
            ],
            "Seq": 0,
            "CreateDate": "2026-01-05 10:51:44",
            "UpdateDate": "2026-01-05 10:51:44"
          },
          "Code": 0
        },
        "{\"Key\":\"HomeRelated\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 40128,
            "Key": "HomeRelated",
            "Name": "首頁相關",
            "Description": "首頁相關",
            "Content": "",
            "URL": "/cms/catDetail/40128",
            "OpenNewWin": true,
            "ParentId": 0,
            "PageStyle": "1",
            "Children": [],
            "Img": null,
            "Collapse": false,
            "ImagePath": "",
            "Path": "40128",
            "CatPaths": [
              {
                "CatId": "40128",
                "PathName": "首頁相關"
              }
            ],
            "SeoKeyword": "",
            "SeoDesc": "",
            "Father": [],
            "GroupId": 0,
            "RedirectURL": null,
            "Contents": [
              {
                "Id": 20340,
                "Key": "HomeAbout",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "關於NCI",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeNormal\"><p class=\"perText\"><em class=\"colorText\">新世紀國際保險顧問有限公司（NCI）</em>於2007年成立，乃保險業監管局的會員（牌照號碼FB1543），主要業務為提供客戶優質的保險中介服務。NCI 擁有完整豐富資歷與多年經驗的專業團隊，在保險規劃領域極具獨創性與主導性，致力為全球高資產客戶提供人壽保險規劃建議，量身設計專屬並縱覽全球的專業服務。</p><p class=\"perText\">高資產客戶的需求不一，NCI 堅守以客為尊信念，深入瞭解每位客戶的獨特需求……</p></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "關於NCI",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:52:40",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:52:40",
                "UpdateDateVal": "2026-05-07 15:45:50",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/5e466c8a-c463-40cb-b1eb-3966dfb332f4.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "首頁相關",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "首頁相關"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:51:49",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": true,
                "WeekNum": "星期一",
                "ContentDateTimeStr": "2026年01月05日 10:51:49",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20345,
                "Key": "HomeContactUs",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "聯絡我們",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">地址：</p><p class=\"text\">香港九龍長沙灣道833號長沙灣廣場一期5樓502A室</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">電話：</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">傳真：</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">電郵：</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "聯絡我們",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 11:49:48",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 11:49:48",
                "UpdateDateVal": "2026-01-05 11:49:48",
                "CatId": 40128,
                "Cover": "",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "首頁相關",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "首頁相關"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 11:48:37",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": true,
                "WeekNum": "星期一",
                "ContentDateTimeStr": "2026年01月05日 11:48:37",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20344,
                "Key": "HomeMap",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "Map",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<p><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.4372524704454!2d114.14615207586719!3d22.33711294155908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340407548be66e61%3A0xc6bc9dedfdffc038!2z6ZW_5rKZ5rm-5bm_5Zy6!5e0!3m2!1szh-CN!2shk!4v1767584496915!5m2!1szh-CN!2shk\" width=\"100%\" height=\"100%\" frameborder=\"0\"></iframe></p>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "Map",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 11:43:13",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 11:43:13",
                "UpdateDateVal": "2026-01-05 11:43:13",
                "CatId": 40128,
                "Cover": "",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "首頁相關",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "首頁相關"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 11:42:07",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": true,
                "WeekNum": "星期一",
                "ContentDateTimeStr": "2026年01月05日 11:42:07",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20342,
                "Key": "HomeQualityService",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "優質服務",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "優質服務",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:54:26",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:54:26",
                "UpdateDateVal": "2026-01-05 11:25:57",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/ccd42020-f121-4be6-82d7-64a277b99d6b.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "首頁相關",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "首頁相關"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:53:40",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": true,
                "WeekNum": "星期一",
                "ContentDateTimeStr": "2026年01月05日 10:53:40",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20343,
                "Key": "HomeUniversalLifeInsurance",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "萬用壽險",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeNormal\"><p class=\"perText\">萬用壽險是集人壽保障和財富增值於一身之保險商品。與傳統壽險產品相比，萬用壽險在提供保障之餘，更能獲取相對穩健的獲利回報，以達致儲蓄、資產增值與傳承目的……</p></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "萬用壽險",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:54:59",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:54:59",
                "UpdateDateVal": "2026-01-05 11:21:47",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/b01b6a8d-da30-4e94-871d-ce4603e10b0a.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "首頁相關",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "首頁相關"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:54:29",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": true,
                "WeekNum": "星期一",
                "ContentDateTimeStr": "2026年01月05日 10:54:29",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20341,
                "Key": "HomeBusinessPhilosophy",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "經營理念",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeNormal\"><p class=\"perText\">保險是個人與家庭重要的資產屏障。人生起伏多變，一生奮鬥所累積的財富更可能隨著市場環境之變化而波動。因此，高資產客戶格外需要更積極兼有效益的保險理財規劃，藉此建置厚實的財富屏障，使家族基業得以穩固且茁壯。</p><p class=\"perText\">NCI 洞悉每一位高資產客戶的獨特需求，堅守專業與嚴謹的服務品質，助您完成財富傳承大業……</p></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "經營理念",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:53:37",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:53:37",
                "UpdateDateVal": "2026-01-05 11:06:26",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/c98b9ba6-b92b-4850-b3c4-78a06e1f1e68.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "首頁相關",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "首頁相關"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:52:46",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": true,
                "WeekNum": "星期一",
                "ContentDateTimeStr": "2026年01月05日 10:52:46",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              }
            ],
            "Seq": 0,
            "CreateDate": "2026-01-05 10:51:44",
            "UpdateDate": "2026-01-05 10:51:44"
          },
          "Code": 0
        },
        "{\"Key\":\"HomeAbout\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeAbout\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeBusinessPhilosophy\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeBusinessPhilosophy\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeQualityService\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeQualityService\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeUniversalLifeInsurance\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeUniversalLifeInsurance\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeContactUs\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeContactUs\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeMap\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeMap\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"footerContact\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"footerContact\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"LINK\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"LINK\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"AppointmentRenewal\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"AppointmentRenewal\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"CatId\":\"40137\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"CatId\":\"40137\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        }
      },
      "catByKey": {
        "{\"key\":\"HomeRelated\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 40128,
            "Key": "HomeRelated",
            "Name": "首頁相關",
            "Description": "首頁相關",
            "Content": "",
            "URL": "/cms/catDetail/40128",
            "OpenNewWin": true,
            "ParentId": 0,
            "PageStyle": "1",
            "Children": [],
            "Img": null,
            "Collapse": false,
            "ImagePath": "",
            "Path": "40128",
            "CatPaths": [
              {
                "CatId": "40128",
                "PathName": "首頁相關"
              }
            ],
            "SeoKeyword": "",
            "SeoDesc": "",
            "Father": [],
            "GroupId": 0,
            "RedirectURL": null,
            "Contents": [
              {
                "Id": 20340,
                "Key": "HomeAbout",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "關於NCI",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeNormal\"><p class=\"perText\"><em class=\"colorText\">新世紀國際保險顧問有限公司（NCI）</em>於2007年成立，乃保險業監管局的會員（牌照號碼FB1543）主要業務為提供客戶優質的保險中介服務。NCI 擁有完整豐富資歷與多年經驗的專業團隊，在保險規劃領域極具獨創性與主導性，致力為全球高資產客戶提供人壽保險規劃建議，量身設計專屬並縱覽全球的專業服務。</p><p class=\"perText\">高資產客戶的需求不一，NCI 堅守以客為尊信念，深入瞭解每位客戶的獨特需求……</p></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "關於NCI",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:52:40",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:52:40",
                "UpdateDateVal": "2026-05-07 15:45:50",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0cb969dd-55f4-4c53-bbe1-9bdf58e7498e.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "首頁相關",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "首頁相關"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:51:49",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": null,
                "ContentDateTimeStr": null,
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20345,
                "Key": "HomeContactUs",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "聯絡我們",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">地址：</p><p class=\"text\">香港九龍長沙灣道833號長沙灣廣場一期5樓502A室</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">電話：</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">傳真：</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">電郵：</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "聯絡我們",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 11:49:48",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 11:49:48",
                "UpdateDateVal": "2026-01-05 11:49:48",
                "CatId": 40128,
                "Cover": "",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "首頁相關",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "首頁相關"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 11:48:37",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": null,
                "ContentDateTimeStr": null,
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20344,
                "Key": "HomeMap",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "Map",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<p><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.4372524704454!2d114.14615207586719!3d22.33711294155908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340407548be66e61%3A0xc6bc9dedfdffc038!2z6ZW_5rKZ5rm-5bm_5Zy6!5e0!3m2!1szh-CN!2shk!4v1767584496915!5m2!1szh-CN!2shk\" width=\"100%\" height=\"100%\" frameborder=\"0\"></iframe></p>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "Map",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 11:43:13",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 11:43:13",
                "UpdateDateVal": "2026-01-05 11:43:13",
                "CatId": 40128,
                "Cover": "",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "首頁相關",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "首頁相關"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 11:42:07",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": null,
                "ContentDateTimeStr": null,
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20342,
                "Key": "HomeQualityService",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "優質服務",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "優質服務",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:54:26",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:54:26",
                "UpdateDateVal": "2026-01-05 11:25:57",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/9d33db81-8d18-47ab-b094-fcefd67b61c7.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "首頁相關",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "首頁相關"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:53:40",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": null,
                "ContentDateTimeStr": null,
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20343,
                "Key": "HomeUniversalLifeInsurance",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "萬用壽險",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeNormal\"><p class=\"perText\">萬用壽險是集人壽保障和財富增值於一身之保險商品。與傳統壽險產品相比，萬用壽險在提供保障之餘，更能獲取相對穩健的獲利回報，以達致儲蓄、資產增值與傳承目的……</p></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "萬用壽險",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:54:59",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:54:59",
                "UpdateDateVal": "2026-01-05 11:21:47",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/3d242c00-301d-4a2d-bb1d-2f83a18a779e.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "首頁相關",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "首頁相關"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:54:29",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": null,
                "ContentDateTimeStr": null,
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20341,
                "Key": "HomeBusinessPhilosophy",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "經營理念",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeNormal\"><p class=\"perText\">保險是個人與家庭重要的資產屏障。人生起伏多變，一生奮鬥所累積的財富更可能隨著市場環境之變化而波動。因此，高資產客戶格外需要更積極兼有效益的保險理財規劃，藉此建置厚實的財富屏障，使家族基業得以穩固且茁壯。</p><p class=\"perText\">NCI 洞悉每一位高資產客戶的獨特需求，堅守專業與嚴謹的服務品質，助您完成財富傳承大業……</p></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "經營理念",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:53:37",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:53:37",
                "UpdateDateVal": "2026-01-05 11:06:26",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0667ecec-42aa-4579-bd0e-30bce7c2cb05.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "首頁相關",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "首頁相關"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:52:46",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": null,
                "ContentDateTimeStr": null,
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              }
            ],
            "Seq": 0,
            "CreateDate": "2026-01-05 10:51:44",
            "UpdateDate": "2026-01-05 10:51:44"
          },
          "Code": 0
        },
        "{\"key\":\"HomeAbout\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"key\":\"HomeBusinessPhilosophy\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"key\":\"HomeQualityService\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"key\":\"HomeUniversalLifeInsurance\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"key\":\"HomeContactUs\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"key\":\"HomeMap\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"key\":\"footerContact\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"key\":\"LINK\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"key\":\"AppointmentRenewal\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        }
      }
    },
    "product": {
      "products": {},
      "search": {
        "{\"Key\":\"\",\"Type\":0,\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        }
      },
      "catProducts": {},
      "related": {},
      "latest": {
        "{\"qty\":12}": []
      },
      "catalogs": [],
      "catalog": {},
      "attrImage": {},
      "productUpOrDown": {},
      "checkProductStatus": {}
    },
    "site": {
      "contact": {
        "__fetchError": true,
        "status": 404,
        "message": "Request failed with status code 404",
        "data": {
          "Message": "No HTTP resource was found that matches the request URI 'https://api.uat.in-store.hk/V2/common/contact'.",
          "MessageDetail": "No type was found that matches the controller named 'common'."
        }
      }
    },
    "photoAlbum": {
      "folders": {
        "TotalPage": 0,
        "TotalRecord": 0,
        "Data": [],
        "Page": 1,
        "PageSize": 50,
        "Offset": 0,
        "SortName": "",
        "SortOrder": ""
      },
      "folderInfo": {}
    },
    "calendar": {
      "listByCond": {
        "{\"Year\":2026,\"Month\":5,\"Day\":13}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "TotalPage": 0,
            "TotalRecord": 0,
            "Data": [],
            "Page": 1,
            "PageSize": 10,
            "Offset": 0,
            "SortName": "",
            "SortOrder": ""
          },
          "Code": 0
        }
      },
      "byId": {}
    },
    "common": {
      "country": [
        {
          "Id": 537,
          "Name": "阿富汗",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AFA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 538,
          "Name": "阿爾巴尼亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ALA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 539,
          "Name": "阿爾及利亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "DZA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 540,
          "Name": "安道爾",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ADA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 541,
          "Name": "安哥拉",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AOA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 542,
          "Name": "安圭拉島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AIA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 543,
          "Name": "安提瓜及巴布達",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AGA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 544,
          "Name": "阿根廷",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ARA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 545,
          "Name": "亞美尼亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AMA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 546,
          "Name": "阿森松",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ACA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 547,
          "Name": "阿魯巴",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AWA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 548,
          "Name": "澳大利亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AUA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 549,
          "Name": "澳大利亞 (其他省份)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AUB",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 550,
          "Name": "奧地利",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ATA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 551,
          "Name": "阿塞拜彊",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AZA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 552,
          "Name": "亞速爾",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PTB",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 553,
          "Name": "巴哈馬",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BSA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 554,
          "Name": "巴林",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BHA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 555,
          "Name": "巴利阿里群島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "IBA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 556,
          "Name": "孟加拉",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BDA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 557,
          "Name": "巴巴多斯",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BBA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 558,
          "Name": "白俄羅斯",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BYA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 559,
          "Name": "比利時",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BEA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 560,
          "Name": "伯利茲",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BZA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 561,
          "Name": "貝寧",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BJA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 562,
          "Name": "百慕達",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BMA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 563,
          "Name": "不丹",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BTA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 564,
          "Name": "玻利維亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BOA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 565,
          "Name": "波斯尼亞 - 黑塞哥維那",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BAA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 566,
          "Name": "博茨瓦納",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BWA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 567,
          "Name": "巴西",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BRA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 568,
          "Name": "英屬印度洋地區",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "IOA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 569,
          "Name": "文萊",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BNA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 570,
          "Name": "保加利亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BGA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 571,
          "Name": "布基納法索",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BFA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 572,
          "Name": "布隆迪",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BIA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 573,
          "Name": "柬埔寨",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KHA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 574,
          "Name": "喀麥隆",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CMA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 575,
          "Name": "加拿大",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CAA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 576,
          "Name": "加那利群島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ESC",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 577,
          "Name": "佛得角群島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CVA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 578,
          "Name": "加羅林群島(密克羅尼西亞)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "FMA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 579,
          "Name": "加羅林群島(帕勞)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PWA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 580,
          "Name": "開曼群島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KYA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 581,
          "Name": "中非共和國",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CFA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 582,
          "Name": "查得",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TDA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 583,
          "Name": "智利",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CLA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 584,
          "Name": "聖誕島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CXA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 585,
          "Name": "科科斯群島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CCA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 586,
          "Name": "哥倫比亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "COA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 587,
          "Name": "科摩羅",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KMA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 588,
          "Name": "剛果民主共和國",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CDA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 589,
          "Name": "剛果",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CGA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 590,
          "Name": "科西嘉島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "EUA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 591,
          "Name": "哥斯達黎加",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CRA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 592,
          "Name": "科特迪瓦 (象牙海岸)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CIA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 593,
          "Name": "克羅地亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "HRA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 594,
          "Name": "古巴 (關塔那摩灣)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CUA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 595,
          "Name": "古巴 (其他地方)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CUB",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 596,
          "Name": "塞浦路斯",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CYA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 597,
          "Name": "捷克",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CZA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 598,
          "Name": "丹麥",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "DKA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 599,
          "Name": "吉布提",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "DJA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 600,
          "Name": "多米尼加島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "DMA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 601,
          "Name": "多米尼加共和國",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "DOA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 602,
          "Name": "東帝汶",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TPA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 603,
          "Name": "厄瓜多爾",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ECA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 604,
          "Name": "埃及",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "EGA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 605,
          "Name": "薩爾瓦多",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SVA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 606,
          "Name": "赤道幾內亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GQA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 607,
          "Name": "厄立特里亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ERA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 608,
          "Name": "愛沙尼亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "EEA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 609,
          "Name": "埃塞俄比亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ETA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 610,
          "Name": "福克蘭群島(包括屬地)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "FKA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 611,
          "Name": "法羅群島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "FOA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 612,
          "Name": "斐濟",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "FJA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 613,
          "Name": "芬蘭",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "FIA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 614,
          "Name": "法國",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "FRA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 615,
          "Name": "法屬圭亞那",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GFA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 616,
          "Name": "法屬波利尼西亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PFA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 617,
          "Name": "法屬西印度群島 (瓜德羅普島)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GPA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 618,
          "Name": "法屬西印度群島 (馬提尼克島)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MQA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 619,
          "Name": "加蓬",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GAA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 620,
          "Name": "岡比亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GMA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 621,
          "Name": "加沙和汗尤尼斯",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "XEA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 622,
          "Name": "格魯吉亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GEA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 623,
          "Name": "德國",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "DEA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 624,
          "Name": "加納",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GHA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 625,
          "Name": "直布羅陀",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GIA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 626,
          "Name": "希臘",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GRA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 627,
          "Name": "格陵蘭",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GLA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 628,
          "Name": "格林納達",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GDA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 629,
          "Name": "關島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GUA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 630,
          "Name": "危地馬拉",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GTA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 631,
          "Name": "幾內亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GNA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 632,
          "Name": "幾內亞比紹",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GWA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 633,
          "Name": "圭亞那",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GYA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 634,
          "Name": "海地",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "HTA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 635,
          "Name": "洪都拉斯",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "HNA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 636,
          "Name": "匈牙利",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "HUA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 637,
          "Name": "冰島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ISA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 638,
          "Name": "印度",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "INA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 639,
          "Name": "印度 (其他地方)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "INB",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 640,
          "Name": "印度尼西亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "IDA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 641,
          "Name": "伊朗",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "IRA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 642,
          "Name": "伊拉克",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "IQA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 643,
          "Name": "愛爾蘭",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "IEA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 644,
          "Name": "以色列",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ILA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 645,
          "Name": "意大利",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ITA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 646,
          "Name": "牙買加",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "JMA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 647,
          "Name": "日本",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "JPA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 648,
          "Name": "日本 (琉球群島)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "JPB",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 649,
          "Name": "約旦",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "JOA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 650,
          "Name": "哈薩克",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KZA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 651,
          "Name": "肯尼亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KEA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 652,
          "Name": "基里巴斯",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KIA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 653,
          "Name": "北韓",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KPA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 654,
          "Name": "南韓",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KRA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 655,
          "Name": "科威特",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KWA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 656,
          "Name": "吉爾吉斯",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KGA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 657,
          "Name": "老撾",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LAA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 658,
          "Name": "拉脫維亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LVA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 659,
          "Name": "黎巴嫩",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LBA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 660,
          "Name": "萊索托",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LSA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 661,
          "Name": "利比里亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LRA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 662,
          "Name": "利比亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LYA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 663,
          "Name": "列支敦士登",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LIA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 664,
          "Name": "立陶宛",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LTA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 665,
          "Name": "盧森堡",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LUA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 666,
          "Name": "澳門",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MOA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 667,
          "Name": "馬其頓",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MKA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 668,
          "Name": "馬達加斯加",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MGA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 669,
          "Name": "馬德拉",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PTC",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 670,
          "Name": "馬拉維",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MWA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 671,
          "Name": "馬來西亞 (半島馬來西亞)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MYA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 672,
          "Name": "馬來西亞 (沙巴)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MYB",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 673,
          "Name": "馬來西亞 (沙撈越)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MYC",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 674,
          "Name": "馬爾代夫",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MVA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 675,
          "Name": "馬里",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MLA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 676,
          "Name": "馬爾他",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MTA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 677,
          "Name": "馬里亞納群島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MPA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 678,
          "Name": "馬紹爾群島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MHA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 679,
          "Name": "毛里塔尼亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MRA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 680,
          "Name": "毛里求斯",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MUA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 681,
          "Name": "墨西哥",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MXA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 682,
          "Name": "摩爾多瓦",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MDA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 683,
          "Name": "摩納哥",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MCA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 684,
          "Name": "蒙古",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MNA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 685,
          "Name": "黑山(共和國)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MEA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 686,
          "Name": "蒙特塞拉特",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MSA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 687,
          "Name": "摩洛哥",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MAA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 688,
          "Name": "莫桑比克",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MZA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 689,
          "Name": "緬甸",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MMA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 690,
          "Name": "納米比亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NAA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 691,
          "Name": "瑙魯群島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NRA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 692,
          "Name": "尼泊爾",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NPA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 693,
          "Name": "荷蘭",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NLA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 694,
          "Name": "荷屬安的列斯群島及阿魯巴島 (荷屬安的列斯群島)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ANA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 695,
          "Name": "荷屬安的列斯群島及阿魯巴島 (阿魯巴島)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ANB",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 696,
          "Name": "新喀里多尼亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NCA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 697,
          "Name": "新西蘭",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NZA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 698,
          "Name": "新西蘭屬土島嶼 (庫克群島)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "XLA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 699,
          "Name": "尼加拉瓜",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NIA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 700,
          "Name": "尼日爾",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NEA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 701,
          "Name": "尼日利亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NGA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 702,
          "Name": "諾褔克島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NFA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 703,
          "Name": "挪威",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NOA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 704,
          "Name": "阿曼",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "OMA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 705,
          "Name": "巴基斯坦",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PKA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 706,
          "Name": "巴拿馬",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PAA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 707,
          "Name": "巴布亞新幾內亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PGA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 708,
          "Name": "巴拉圭",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PYA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 709,
          "Name": "秘魯",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PEA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 710,
          "Name": "菲律賓",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PHA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 711,
          "Name": "皮特凱恩島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PNA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 712,
          "Name": "波蘭",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PLA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 713,
          "Name": "葡萄牙",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PTA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 714,
          "Name": "波多黎各",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PRA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 715,
          "Name": "卡塔爾",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "QAA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 716,
          "Name": "留尼汪島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "REA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 717,
          "Name": "羅馬尼亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ROA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 718,
          "Name": "俄羅斯聯邦",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "RUA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 719,
          "Name": "盧旺達",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "RWA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 720,
          "Name": "薩摩亞 (美國屬土)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ASA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 721,
          "Name": "聖馬力諾",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SMA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 722,
          "Name": "聖多美和普林西比",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "STA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 723,
          "Name": "沙地阿拉伯",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SAA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 724,
          "Name": "塞內加爾",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SNA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 725,
          "Name": "塞爾維亞(共和國)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "RSA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 726,
          "Name": "塞舌爾",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SCA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 727,
          "Name": "塞拉里昂",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SLA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 728,
          "Name": "新加坡",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SGA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 729,
          "Name": "斯洛伐克(共和國)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SKA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 730,
          "Name": "斯洛文尼亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SIA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 731,
          "Name": "所羅門群島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SBA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 732,
          "Name": "索馬里",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SOA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 733,
          "Name": "南非",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ZAA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 734,
          "Name": "西班牙",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ESA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 735,
          "Name": "北非西班牙屬土",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ESB",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 736,
          "Name": "斯匹次卑爾根群島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SJA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 737,
          "Name": "斯里蘭卡",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LKA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 738,
          "Name": "聖克里斯托佛島及尼維斯島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KNA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 739,
          "Name": "聖赫勒拿島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SHA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 740,
          "Name": "聖盧西亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LCA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 741,
          "Name": "聖皮埃爾島和密克隆島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PMA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 742,
          "Name": "聖文森特和格林納丁斯",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "VCA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 743,
          "Name": "蘇丹",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SDA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 744,
          "Name": "蘇里南",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SRA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 745,
          "Name": "斯威士蘭",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SZA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 746,
          "Name": "瑞典",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SEA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 747,
          "Name": "瑞士",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CHA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 748,
          "Name": "阿拉伯敘利亞共和國(敘利亞)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SYA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 749,
          "Name": "台灣",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TWA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 750,
          "Name": "塔吉克",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TJA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 751,
          "Name": "坦桑尼亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TZA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 752,
          "Name": "泰國",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "THA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 753,
          "Name": "多哥",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TGA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 754,
          "Name": "湯加",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TOA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 755,
          "Name": "托爾托拉島(英屬處女群島)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "VGA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 756,
          "Name": "千里達和多巴哥",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TTA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 757,
          "Name": "特里斯坦 - 達庫尼亞島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TAA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 758,
          "Name": "突尼斯",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TNA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 759,
          "Name": "土耳其",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TRA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 760,
          "Name": "土庫曼",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TMA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 761,
          "Name": "特克斯和凱科斯群島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TCA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 762,
          "Name": "圖瓦盧",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TVA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 763,
          "Name": "烏干達",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "UGA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 764,
          "Name": "烏克蘭",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "UAA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 765,
          "Name": "阿拉伯聯合酋長國",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AEA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 766,
          "Name": "英國",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GBA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 767,
          "Name": "美國 (夏威夷)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "USA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 768,
          "Name": "美國 (紐約)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "USB",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 769,
          "Name": "美國 (其他州)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "USC",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 770,
          "Name": "烏拉圭",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "UYA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 771,
          "Name": "烏茲別克",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "UZA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 772,
          "Name": "瓦努阿圖",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "VUA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 773,
          "Name": "梵蒂岡",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "VAA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 774,
          "Name": "委內瑞拉",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "VEA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 775,
          "Name": "越南",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "VNA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 776,
          "Name": "美屬處女群島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "VIA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 777,
          "Name": "威克島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "UMA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 778,
          "Name": "瓦利斯群島和富圖納群島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "WFA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 779,
          "Name": "西薩摩亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "WSA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 780,
          "Name": "也門 (屬前阿拉伯也門共和國的地方)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "YEA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 781,
          "Name": "也門 (其他地方)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "YEB",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 782,
          "Name": "贊比亞",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ZMA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 783,
          "Name": "津巴布韋",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ZWA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 784,
          "Name": "中國大陸",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CNA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 786,
          "Name": "香港本地",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "HKG",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 821,
          "Name": "Aruba 阿魯巴",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AWA",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 1821,
          "Name": "海外",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "03",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 1822,
          "Name": "本地離島",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "05",
          "Code2": null,
          "Code3": null,
          "Language": "C",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        }
      ],
      "paymentMethod": [
        {
          "Id": 3020,
          "Code": "MASTER",
          "Desc": "VISA & MASTER CARD",
          "Name": "VISA & MASTER CARD",
          "Img": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/paymethods/0_20191227094137.jpg?flag=1778685638065",
          "PaymentDiscount": [],
          "PayType": 0
        },
        {
          "Id": 3021,
          "Code": "UNION",
          "Desc": "MPGS-UNIONPAY",
          "Name": "MPGS-UNIONPAY",
          "Img": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/paymethods/0_20191227094401.jpg?flag=1778685638065",
          "PaymentDiscount": [],
          "PayType": 0
        },
        {
          "Id": 3022,
          "Code": "WeChat",
          "Desc": "WeChat Pay",
          "Name": "WeChat Pay",
          "Img": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/paymethods/0_20191227094439.png?flag=1778685638065",
          "PaymentDiscount": [],
          "PayType": 0
        },
        {
          "Id": 3025,
          "Code": "Stripe",
          "Desc": "Stripe",
          "Name": "Stripe",
          "Img": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/paymethods/0_20191227094513.png?flag=1778685638065",
          "PaymentDiscount": [],
          "PayType": 0
        },
        {
          "Id": 3026,
          "Code": "Paypal",
          "Desc": "Paypal",
          "Name": "Paypal",
          "Img": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/paymethods/0_20191227094940.png?flag=1778685638065",
          "PaymentDiscount": [],
          "PayType": 0
        },
        {
          "Id": 3027,
          "Code": "Payme",
          "Desc": "Payme",
          "Name": "Payme",
          "Img": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/paymethods/0_20200214135924.jpg?flag=1778685638065",
          "PaymentDiscount": [],
          "PayType": 0
        }
      ],
      "expressAndOutlets": [
        {
          "Id": null,
          "ExpressCompanyId": "P",
          "ExpressPointId": null,
          "ExpressPointList": null,
          "ExpressCompanyName": "門店自取",
          "Price": 0,
          "Discount": 0,
          "CountryCode": null,
          "ServiceType": null,
          "IsExpressPoint": true,
          "IsSelfDefineDeliveryDate": false,
          "ComeFrom": null,
          "ExpressCode": null,
          "DiscountPrice": 0,
          "PickupDateRequire": null,
          "PickupInfoRequire": null
        }
      ],
      "pickupAddress": [
        {
          "Id": "66",
          "Phone": "11111111",
          "Address": "456",
          "Name": "123",
          "Seq": "1"
        },
        {
          "Id": "67",
          "Phone": "2",
          "Address": "22",
          "Name": "222",
          "Seq": "3"
        }
      ],
      "attrList": {
        "{\"type\":1}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": [],
          "Code": 1
        }
      }
    }
  },
  "E": {
    "lang": "E",
    "promotion": {
      "headerBanners": {
        "{\"page\":\"\"}": [],
        "{\"page\":\"Home\"}": [
          {
            "Id": "220adf20-0505-4d7b-9b6a-b4db538d50a6",
            "Lang": "E",
            "LangDesc": "English",
            "Name": "首頁橫幅廣告",
            "Desc": "首頁橫幅廣告",
            "ImgName": null,
            "ImgPath": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtInfo/220adf20-0505-4d7b-9b6a-b4db538d50a6/",
            "CatTypeName": null,
            "Seq": 0,
            "BannerList": [
              {
                "Id": 0,
                "Image": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/220adf20-0505-4d7b-9b6a-b4db538d50a6/4984bed1-baae-401f-a889-c4432493693b.jpg",
                "Seq": 1,
                "Url": "",
                "Content": "",
                "IsRedirect": true
              },
              {
                "Id": 0,
                "Image": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/220adf20-0505-4d7b-9b6a-b4db538d50a6/72de305c-42f5-46ac-bd2f-668fc6c0fc4f.jpg",
                "Seq": 2,
                "Url": "",
                "Content": "",
                "IsRedirect": true
              },
              {
                "Id": 0,
                "Image": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/220adf20-0505-4d7b-9b6a-b4db538d50a6/bfa3fdc4-f10d-48f2-943c-e9ffcbd4d82f.png",
                "Seq": 3,
                "Url": "",
                "Content": "",
                "IsRedirect": true
              }
            ],
            "PrmtProductList": []
          }
        ],
        "{\"page\":\"Index\"}": [],
        "{\"page\":\"Product\"}": [],
        "{\"page\":\"PromProductList\"}": []
      },
      "promotionList": {
        "{\"page\":\"\"}": [],
        "{\"page\":\"Home\"}": [
          {
            "Id": "220adf20-0505-4d7b-9b6a-b4db538d50a6",
            "Lang": "E",
            "LangDesc": "English",
            "Name": "首頁橫幅廣告",
            "Desc": "首頁橫幅廣告",
            "ImgName": null,
            "ImgPath": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtInfo/220adf20-0505-4d7b-9b6a-b4db538d50a6/",
            "CatTypeName": null,
            "Seq": 0,
            "BannerList": [
              {
                "Id": 0,
                "Image": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/220adf20-0505-4d7b-9b6a-b4db538d50a6/4984bed1-baae-401f-a889-c4432493693b.jpg",
                "Seq": 1,
                "Url": "",
                "Content": "",
                "IsRedirect": true
              },
              {
                "Id": 0,
                "Image": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/220adf20-0505-4d7b-9b6a-b4db538d50a6/72de305c-42f5-46ac-bd2f-668fc6c0fc4f.jpg",
                "Seq": 2,
                "Url": "",
                "Content": "",
                "IsRedirect": true
              },
              {
                "Id": 0,
                "Image": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/220adf20-0505-4d7b-9b6a-b4db538d50a6/bfa3fdc4-f10d-48f2-943c-e9ffcbd4d82f.png",
                "Seq": 3,
                "Url": "",
                "Content": "",
                "IsRedirect": true
              }
            ],
            "PrmtProductList": []
          }
        ],
        "{\"page\":\"Index\"}": [],
        "{\"page\":\"Product\"}": [],
        "{\"page\":\"PromProductList\"}": []
      },
      "promotions": {
        "{\"page\":\"PromProductList\",\"position\":0}": {
          "Id": "00000000-0000-0000-0000-000000000000",
          "Lang": null,
          "LangDesc": null,
          "Name": null,
          "Desc": null,
          "ImgName": null,
          "ImgPath": null,
          "CatTypeName": null,
          "Seq": 0,
          "BannerList": [],
          "PrmtProductList": []
        },
        "{\"page\":\"Home\",\"position\":0}": {
          "Id": "220adf20-0505-4d7b-9b6a-b4db538d50a6",
          "Lang": "E",
          "LangDesc": "English",
          "Name": "首頁橫幅廣告",
          "Desc": "首頁橫幅廣告",
          "ImgName": null,
          "ImgPath": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtInfo/220adf20-0505-4d7b-9b6a-b4db538d50a6/",
          "CatTypeName": null,
          "Seq": 0,
          "BannerList": [
            {
              "Id": 0,
              "Image": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/220adf20-0505-4d7b-9b6a-b4db538d50a6/4984bed1-baae-401f-a889-c4432493693b.jpg",
              "Seq": 1,
              "Url": "",
              "Content": "",
              "IsRedirect": true
            },
            {
              "Id": 0,
              "Image": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/220adf20-0505-4d7b-9b6a-b4db538d50a6/72de305c-42f5-46ac-bd2f-668fc6c0fc4f.jpg",
              "Seq": 2,
              "Url": "",
              "Content": "",
              "IsRedirect": true
            },
            {
              "Id": 0,
              "Image": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/220adf20-0505-4d7b-9b6a-b4db538d50a6/bfa3fdc4-f10d-48f2-943c-e9ffcbd4d82f.png",
              "Seq": 3,
              "Url": "",
              "Content": "",
              "IsRedirect": true
            }
          ],
          "PrmtProductList": []
        },
        "{\"page\":\"Index\",\"position\":0}": {
          "Id": "00000000-0000-0000-0000-000000000000",
          "Lang": null,
          "LangDesc": null,
          "Name": null,
          "Desc": null,
          "ImgName": null,
          "ImgPath": null,
          "CatTypeName": null,
          "Seq": 0,
          "BannerList": [],
          "PrmtProductList": []
        }
      },
      "homeSeoData": {
        "Status": 200,
        "Data": {
          "Title": "NCI",
          "IsPtx": 0,
          "Keywords": [
            {
              "Lang": {
                "Id": 1,
                "Text": "Traditional Chinese",
                "Code": "C"
              },
              "Language": 1,
              "List": null,
              "Desc": "獅子會2022愛心慈善跑"
            },
            {
              "Lang": {
                "Id": 0,
                "Text": "English",
                "Code": "E"
              },
              "Language": 0,
              "List": null,
              "Desc": "Tengda (Hong Kong) Petrochemical Company Limited has been established as a car products company focusing on R&D, production and sales in 1995. "
            }
          ],
          "Keyword": "Tengda (Hong Kong) Petrochemical Company Limited has been established as a car products company focusing on R&D, production and sales in 1995. ",
          "Descriptions": [
            {
              "Lang": {
                "Id": 1,
                "Text": "Traditional Chinese",
                "Code": "C"
              },
              "Language": 1,
              "List": null,
              "Desc": "獅子會2022愛心慈善跑"
            },
            {
              "Lang": {
                "Id": 0,
                "Text": "English",
                "Code": "E"
              },
              "Language": 0,
              "List": null,
              "Desc": "Tengda (Hong Kong) Petrochemical Company Limited has been established as a car products company focusing on R&D, production and sales in 1995. "
            }
          ],
          "Description": "Tengda (Hong Kong) Petrochemical Company Limited has been established as a car products company focusing on R&D, production and sales in 1995. ",
          "FacebookImage": null,
          "FacebookDescription": null
        }
      },
      "menu": {
        "Succeeded": true,
        "Message": null,
        "ReturnValue": {
          "HeaderMenus": [
            {
              "Id": "90608c4d-d80e-4a74-b3d6-644590ec6334",
              "Name": "About Us",
              "Title": "About Us",
              "Type": 0,
              "Url": "/cms/content/20346",
              "Image": "",
              "MobileImage": "",
              "Value": {
                "Id": ""
              },
              "Level": 1,
              "ParentId": null,
              "PlaceTop": false,
              "IsNewWin": false,
              "IsAnchor": false,
              "Childs": null,
              "UrlTransId": "abc40f96-0d60-42ca-b65b-54e8cef6e5d5",
              "RedirectUrl": null,
              "CmsKey": null,
              "ParentCmsKey": null
            },
            {
              "Id": "c13de078-690e-477f-907c-72c678508654",
              "Name": "Business Philosophy",
              "Title": "Business Philosophy",
              "Type": 0,
              "Url": "/cms/content/20348",
              "Image": "",
              "MobileImage": "",
              "Value": {
                "Id": ""
              },
              "Level": 1,
              "ParentId": null,
              "PlaceTop": false,
              "IsNewWin": false,
              "IsAnchor": false,
              "Childs": null,
              "UrlTransId": "8aaf5baa-12f8-4ae5-af5e-c5af48953118",
              "RedirectUrl": null,
              "CmsKey": null,
              "ParentCmsKey": null
            },
            {
              "Id": "f35da558-5cfe-4632-bf13-5cf8602f3b95",
              "Name": "High-quality Service",
              "Title": "High-quality Service",
              "Type": 0,
              "Url": "/cms/content/20349",
              "Image": "",
              "MobileImage": "",
              "Value": {
                "Id": ""
              },
              "Level": 1,
              "ParentId": null,
              "PlaceTop": false,
              "IsNewWin": false,
              "IsAnchor": false,
              "Childs": null,
              "UrlTransId": "6acd0f22-48a6-4efd-b390-bd53fb752712",
              "RedirectUrl": null,
              "CmsKey": null,
              "ParentCmsKey": null
            },
            {
              "Id": "947a90cc-8411-4dae-b82e-a839ad263fa7",
              "Name": "Universal Life Insurance",
              "Title": "Universal Life Insurance",
              "Type": 0,
              "Url": "/cms/content/20350",
              "Image": "",
              "MobileImage": "",
              "Value": {
                "Id": ""
              },
              "Level": 1,
              "ParentId": null,
              "PlaceTop": false,
              "IsNewWin": false,
              "IsAnchor": false,
              "Childs": null,
              "UrlTransId": "e3632243-3a1c-44e3-8365-70dbc22c87fe",
              "RedirectUrl": null,
              "CmsKey": null,
              "ParentCmsKey": null
            },
            {
              "Id": "b3ac369c-cc48-4275-b98a-db2fa34a6fcf",
              "Name": "Contact Us",
              "Title": "Contact Us",
              "Type": 0,
              "Url": "/cms/content/20347",
              "Image": "",
              "MobileImage": "",
              "Value": {
                "Id": ""
              },
              "Level": 1,
              "ParentId": null,
              "PlaceTop": false,
              "IsNewWin": false,
              "IsAnchor": false,
              "Childs": null,
              "UrlTransId": "4be23722-cff1-429a-9e6b-86b4f644eac1",
              "RedirectUrl": null,
              "CmsKey": null,
              "ParentCmsKey": null
            }
          ],
          "FooterMenus": [
            {
              "Id": "9bcba247-5e60-4d3b-9e23-df604864969e",
              "Name": "About Us",
              "Title": "About Us",
              "Type": -1,
              "Url": "",
              "Image": "",
              "MobileImage": "",
              "Value": {
                "Id": ""
              },
              "Level": 1,
              "ParentId": null,
              "PlaceTop": false,
              "IsNewWin": false,
              "IsAnchor": false,
              "Childs": null,
              "UrlTransId": "0b31cb5b-996c-4e4b-b548-e4ccbd605d52",
              "RedirectUrl": null,
              "CmsKey": null,
              "ParentCmsKey": null
            },
            {
              "Id": "cce0358f-cb57-46b1-bc33-a6ce2dd82a28",
              "Name": "Business Philosophy",
              "Title": "Business Philosophy",
              "Type": 0,
              "Url": "/cms/content/20348",
              "Image": "",
              "MobileImage": "",
              "Value": {
                "Id": ""
              },
              "Level": 1,
              "ParentId": null,
              "PlaceTop": false,
              "IsNewWin": false,
              "IsAnchor": false,
              "Childs": null,
              "UrlTransId": "e95c101d-1192-4dd0-8790-bb8e404dbdcb",
              "RedirectUrl": null,
              "CmsKey": null,
              "ParentCmsKey": null
            },
            {
              "Id": "6003429e-2f64-4b6a-8f97-a3a7121a7653",
              "Name": "High-quality Service",
              "Title": "High-quality Service",
              "Type": 0,
              "Url": "/cms/content/20349",
              "Image": "",
              "MobileImage": "",
              "Value": {
                "Id": ""
              },
              "Level": 1,
              "ParentId": null,
              "PlaceTop": false,
              "IsNewWin": false,
              "IsAnchor": false,
              "Childs": null,
              "UrlTransId": "cf730d52-006f-4bca-8032-990d6f02c166",
              "RedirectUrl": null,
              "CmsKey": null,
              "ParentCmsKey": null
            },
            {
              "Id": "b047b2f2-4487-470c-a0ff-61ad5ff8daf9",
              "Name": "Universal Life Insurance",
              "Title": "Universal Life Insurance",
              "Type": 0,
              "Url": "/cms/content/20350",
              "Image": "",
              "MobileImage": "",
              "Value": {
                "Id": ""
              },
              "Level": 1,
              "ParentId": null,
              "PlaceTop": false,
              "IsNewWin": false,
              "IsAnchor": false,
              "Childs": [],
              "UrlTransId": "a72422f2-e7bd-43a8-b855-0b8dc2d8e8fb",
              "RedirectUrl": null,
              "CmsKey": null,
              "ParentCmsKey": null
            },
            {
              "Id": "87b54bd9-f82a-4cff-9bc8-e31a169420dd",
              "Name": "Contact Us",
              "Title": "Contact Us",
              "Type": 0,
              "Url": "/cms/content/20347",
              "Image": "",
              "MobileImage": "",
              "Value": {
                "Id": ""
              },
              "Level": 1,
              "ParentId": null,
              "PlaceTop": false,
              "IsNewWin": false,
              "IsAnchor": false,
              "Childs": null,
              "UrlTransId": "99f09e67-95d5-497c-acb5-f35a0de406e3",
              "RedirectUrl": null,
              "CmsKey": null,
              "ParentCmsKey": null
            }
          ]
        },
        "Code": 0
      }
    },
    "cms": {
      "content": {
        "{\"cid\":\"20346\"}": {
          "Id": 20346,
          "Key": "K20260105143250",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "About NCI",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "<div class=\"AboutNCI\"><div class=\"contentBox\"><div class=\"leftT\"><p class=\"perText\"><em class=\"colorText\">New Century International Insurance Advisory Limited (NCI)</em> was established in 2007 and is a member of the Insurance Authority of Hong Kong (License Number FB1543). Its main business is to provide customers with high-quality insurance intermediary services. NCI has a professional team with comprehensive and rich qualifications and years of experience. It is highly innovative and leading in the field of insurance planning and is committed to providing high-net-worth clients worldwide with life insurance planning advice and tailor-designed professional services with a global perspective.</p><p class=\"perText\">High-net-worth clients have diverse needs. NCI adheres to the customer-centric belief, deeply understanding the unique needs of each client and providing comprehensive insurance product advice and sales. Integrity is the most fundamental core value. NCI upholds this belief, carefully selecting insurance products and partners to fully safeguard client rights and interests. With its innovative and comprehensive insurance planning, NCI provides personalized and high-quality services to each high-net-worth client, striving to pursue mutual trust and long-term cooperation with clients.</p><p class=\"perText\">NCI represents products from several internationally renowned insurance companies and has established close interactive relationships with relevant professional partner institutions such as private banks, asset management consultants, accountants, and other teams. It strives to formulate the most suitable insurance plans for high-net-worth clients, aligning with clients&#39; goals such as asset allocation, inheritance, and financial planning.</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_29.jpg\"/></div></div><div class=\"bottomImg\"><img src=\"/nci/images/pc/Ebanner/Ebanner_02.png\"/></div></div>",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "About NCI",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 14:32:50",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40129,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/aa3c60e9-ad80-442b-ae3f-8f3dc5d64898.jpg",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40129,
            "Name": "About NCI",
            "ParentId": 0,
            "Path": "40129",
            "CatPaths": [
              {
                "CatId": "40129",
                "PathName": "About NCI"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": [],
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"cid\":\"20347\"}": {
          "Id": 20347,
          "Key": "ContactUs",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "Contact Us",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">Address:</p><p class=\"text\">Room 502A, 5/F, Phase I, Cheung Sha Wan Plaza, 833 Cheung Sha Wan Road, Kowloon, Hong Kong</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">Telephone:</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">Fax:</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">Email:</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "Contact Us",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 14:56:39",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40130,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/6cc86398-3d89-4fd5-868a-d51aa4306425.jpg",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40130,
            "Name": "Contact Us",
            "ParentId": 0,
            "Path": "40130",
            "CatPaths": [
              {
                "CatId": "40130",
                "PathName": "Contact Us"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": [],
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"cid\":\"20348\"}": {
          "Id": 20348,
          "Key": "K20260105163008",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "Business Philosophy",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "<div class=\"BusinessPhilosophyBox\">\n  <div class=\"topbox\">\n    <div class=\"warper\">\n      <p class=\"perText\">\n        Insurance is an important asset barrier for individuals and families. Life is full of ups and downs, and the wealth accumulated through a lifetime of hard work may fluctuate with changes in the market environment. Therefore, high-net-worth clients particularly need more proactive and effective insurance financial planning to build a solid wealth barrier, enabling the family business to remain stable and thrive.\n      </p>\n      <p class=\"perText\">NCI understands the unique needs of every high-net-worth client and upholds professional and rigorous service quality to help you achieve the great endeavor of wealth inheritance.\n      </p>\n    </div>\n  </div>\n  <div class=\"contentBox\">\n    <div class=\"leftT\">\n      <div class=\"tpA\">\n        <p class=\"perTitle\"><em class=\"bigText\">NCI </em><em class=\"smallText\">combines insurance with other strategic partners to strive to help high-net-worth clients:</em></p>\n        <p class=\"circleText\">Have stable and secure personal and family protection</p>\n        <p class=\"circleText\">Integrate wealth resources and enjoy a rich life</p>\n        <p class=\"circleText\">Achieve asset appreciation and intergenerational wealth inheritance</p>\n        <p class=\"circleText\">Develop a positive and proactive insurance financial outlook</p>\n      </div>\n      <div class=\"tpA\">\n        <p class=\"perTitle\"><em class=\"bigText\">NCI </em><em class=\"smallText\">stands out with its unique values:</em></p>\n        <p class=\"circleText\">Break through market barriers or product-oriented approaches and tailor the best insurance plans specifically for clients</p>\n        <p class=\"circleText\">Prioritize client interests and use actuarial techniques to compare various insurance products</p>\n        <p class=\"circleText\">Provide the most appropriate insurance planning according to clients' different needs at various life stages</p>\n        <p class=\"circleText\">Integrate partner resources to assist clients in achieving their insurance financial plans</p>\n        <p class=\"circleText\">Grasp trends and suggest to international insurance groups to develop high-quality insurance products that best meet clients' needs</p>\n      </div>\n    </div>\n    <div class=\"rightT\">\n      <img src=\"/nci/images/pc/pc_18.jpg\">\n    </div>\n  </div>\n</div>",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "Business Philosophy",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 16:30:08",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40131,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/7e277cbe-d10a-42b2-bf51-f466e3eac7a6.jpg",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40131,
            "Name": "Business Philosophy",
            "ParentId": 0,
            "Path": "40131",
            "CatPaths": [
              {
                "CatId": "40131",
                "PathName": "Business Philosophy"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": [],
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"cid\":\"20349\"}": {
          "Id": 20349,
          "Key": "K20260105163036",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "Quality Service",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "<div class=\"ExcellentServiceBox\"><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">Providing</em><em class=\"smallText\">Comprehensive Insurance Planning</em></p><p class=\"normarText\">NCI\nrepresents insurance products from multiple internationally renowned insurance companies. We have an in-depth understanding of the characteristics of different products, excel at comprehensive analysis and evaluation, and collaborate with top-tier private banks, professional tax and financial teams worldwide to recommend well-rounded insurance plans. These plans are tailored to match clients&#39; asset preservation and wealth appreciation needs at different stages, aiming to design the best insurance planning solutions according to each client&#39;s unique requirements.</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_12.jpg\"/></div></div></div><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">Comprehensive</em><em class=\"smallText\">Product Analysis and Comparison</em></p><p class=\"normarText\">NCI maintains close cooperative relationships with insurance companies, enabling us to quickly grasp the latest market information and keep clients fully informed about product trends, profitability analysis, cost calculations, and changes. Meanwhile, our professional team leverages long-accumulated rich experience to analyze the pros and cons of various insurance products according to clients&#39; needs, assisting clients in making full use of insurance and banking services to select the most autonomous insurance and financial planning solutions.</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_13.jpg\"/></div></div></div><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">Prestigious</em><em class=\"smallText\">Customer Service</em></p><p class=\"normarText\">NCI places clients at the forefront and provides high-quality services, including:</p><p class=\"circleText\">Establishing comprehensive insurance plans for clients</p><p class=\"circleText\">Creating comprehensive insurance product analyses and comparisons</p><p class=\"circleText\">Providing clients with the latest information on the financial insurance market</p><p class=\"circleText\">Proactively reviewing annual reports based on the original insurance plans, analyzing the performance of policies over the years to safeguard clients&#39; rights and interests</p><p class=\"circleText\">Assisting high-net-worth clients in establishing correct insurance concepts</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_14.jpg\"/></div></div></div></div>",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "Quality Service",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 16:30:36",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40132,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/1ac895eb-52fe-4fdd-bb8c-e72db4bb7b48.jpg",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40132,
            "Name": "Quality Service",
            "ParentId": 0,
            "Path": "40132",
            "CatPaths": [
              {
                "CatId": "40132",
                "PathName": "Quality Service"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": [],
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"cid\":\"20350\"}": {
          "Id": 20350,
          "Key": "K20260105163059",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "Universal Life Insurance",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "<div class=\"UniversalLifeInsuranceBox\"><div class=\"topbox\"><div class=\"warper\"><p class=\"perText\">Universal life insurance is an insurance product that combines life protection and wealth appreciation. Compared with traditional life insurance products, universal life insurance not only provides protection but also enables relatively stable investment returns, achieving the goals of savings, asset appreciation, and inheritance.</p></div></div><div class=\"contentBox\"><div class=\"leftT\"><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">A More Flexible Type of Insurance </em></p><p class=\"NrText\">Most universal life insurance policies allow the policyholder to adjust the insured amount according to actual needs or modify the savings component of the policy, with flexible premium adjustments. Policyholders can also invest additional funds or withdraw the accumulated cash value at any time based on their personal circumstances and financial environment. Compared with traditional life insurance products, universal life insurance is more flexible and transparent, providing policyholders with adaptable autonomy to meet the needs of different life stages in line with their actual family and financial situations.</p></div><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">Premium/Policy Financing </em></p><p class=\"NrText\">Universal life insurance policies have stable value and can serve as collateral for private bank loans, enabling high-net-worth clients to make good use of low-interest-rate financing leverage to enhance financial management efficiency. Whether it is using premium financing to obtain high-amount life insurance protection or utilizing policy financing limits to accumulate a potential reserve fund for various plans such as investment, inheritance, and retirement, it allows wealth preservation while more efficiently achieving diverse financial goals. NCI closely collaborates with multiple private banks and financial institutions to provide premium or policy financing services according to clients&#39; needs.</p></div></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_22.jpg\"/></div></div></div>",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "Universal Life Insurance",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 16:30:59",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40133,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/f740b11e-6925-4eaf-9979-151dcdb2e09c.jpg",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40133,
            "Name": "Universal Life Insurance",
            "ParentId": 0,
            "Path": "40133",
            "CatPaths": [
              {
                "CatId": "40133",
                "PathName": "Universal Life Insurance"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": [],
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        }
      },
      "contentByDevice": {
        "{\"Key\":\"20346\",\"ContentId\":\"20346\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20346,
            "Key": "K20260105143250",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "About NCI",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"AboutNCI\"><div class=\"contentBox\"><div class=\"leftT\"><p class=\"perText\"><em class=\"colorText\">New Century International Insurance Advisory Limited (NCI)</em> was established in 2007 and is a member of the Insurance Authority of Hong Kong (License Number FB1543). Its main business is to provide customers with high-quality insurance intermediary services. NCI has a professional team with comprehensive and rich qualifications and years of experience. It is highly innovative and leading in the field of insurance planning and is committed to providing high-net-worth clients worldwide with life insurance planning advice and tailor-designed professional services with a global perspective.</p><p class=\"perText\">High-net-worth clients have diverse needs. NCI adheres to the customer-centric belief, deeply understanding the unique needs of each client and providing comprehensive insurance product advice and sales. Integrity is the most fundamental core value. NCI upholds this belief, carefully selecting insurance products and partners to fully safeguard client rights and interests. With its innovative and comprehensive insurance planning, NCI provides personalized and high-quality services to each high-net-worth client, striving to pursue mutual trust and long-term cooperation with clients.</p><p class=\"perText\">NCI represents products from several internationally renowned insurance companies and has established close interactive relationships with relevant professional partner institutions such as private banks, asset management consultants, accountants, and other teams. It strives to formulate the most suitable insurance plans for high-net-worth clients, aligning with clients&#39; goals such as asset allocation, inheritance, and financial planning.</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_29.jpg\"/></div></div><div class=\"bottomImg\"><img src=\"/nci/images/pc/Ebanner/Ebanner_02.png\"/></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "About NCI",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 14:32:50",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40129,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/aa3c60e9-ad80-442b-ae3f-8f3dc5d64898.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40129,
              "Name": "About NCI",
              "ParentId": 0,
              "Path": "40129",
              "CatPaths": [
                {
                  "CatId": "40129",
                  "PathName": "About NCI"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"20346\",\"ContentId\":\"20346\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20346,
            "Key": "K20260105143250",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "About NCI",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"AboutNCI\"><div class=\"contentBox\"><div class=\"leftT\"><p class=\"perText\"><em class=\"colorText\">New Century International Insurance Advisory Limited (NCI)</em> was established in 2007 and is a member of the Insurance Authority of Hong Kong (License Number FB1543). Its main business is to provide customers with high-quality insurance intermediary services. NCI has a professional team with comprehensive and rich qualifications and years of experience. It is highly innovative and leading in the field of insurance planning and is committed to providing high-net-worth clients worldwide with life insurance planning advice and tailor-designed professional services with a global perspective.</p><p class=\"perText\">High-net-worth clients have diverse needs. NCI adheres to the customer-centric belief, deeply understanding the unique needs of each client and providing comprehensive insurance product advice and sales. Integrity is the most fundamental core value. NCI upholds this belief, carefully selecting insurance products and partners to fully safeguard client rights and interests. With its innovative and comprehensive insurance planning, NCI provides personalized and high-quality services to each high-net-worth client, striving to pursue mutual trust and long-term cooperation with clients.</p><p class=\"perText\">NCI represents products from several internationally renowned insurance companies and has established close interactive relationships with relevant professional partner institutions such as private banks, asset management consultants, accountants, and other teams. It strives to formulate the most suitable insurance plans for high-net-worth clients, aligning with clients&#39; goals such as asset allocation, inheritance, and financial planning.</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_29.jpg\"/></div></div><div class=\"bottomImg\"><img src=\"/nci/images/pc/Ebanner/Ebanner_01.png\"/></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "About NCI",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 14:32:50",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40129,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/c001629d-5f34-46ba-b220-2ac313c68971.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40129,
              "Name": "About NCI",
              "ParentId": 0,
              "Path": "40129",
              "CatPaths": [
                {
                  "CatId": "40129",
                  "PathName": "About NCI"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"20347\",\"ContentId\":\"20347\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20347,
            "Key": "ContactUs",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "Contact Us",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">Address:</p><p class=\"text\">Room 502A, 5/F, Phase I, Cheung Sha Wan Plaza, 833 Cheung Sha Wan Road, Kowloon, Hong Kong</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">Telephone:</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">Fax:</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">Email:</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "Contact Us",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 14:56:39",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40130,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/6cc86398-3d89-4fd5-868a-d51aa4306425.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40130,
              "Name": "Contact Us",
              "ParentId": 0,
              "Path": "40130",
              "CatPaths": [
                {
                  "CatId": "40130",
                  "PathName": "Contact Us"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"20347\",\"ContentId\":\"20347\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20347,
            "Key": "ContactUs",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "Contact Us",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">Address:</p><p class=\"text\">Room 502A, 5/F, Phase I, Cheung Sha Wan Plaza, 833 Cheung Sha Wan Road, Kowloon, Hong Kong</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">Telephone:</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">Fax:</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">Email:</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "Contact Us",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 14:56:39",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40130,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/35c1cef8-eede-4c6d-a747-603f6424fea4.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40130,
              "Name": "Contact Us",
              "ParentId": 0,
              "Path": "40130",
              "CatPaths": [
                {
                  "CatId": "40130",
                  "PathName": "Contact Us"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"20348\",\"ContentId\":\"20348\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20348,
            "Key": "K20260105163008",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "Business Philosophy",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"BusinessPhilosophyBox\">\n  <div class=\"topbox\">\n    <div class=\"warper\">\n      <p class=\"perText\">\n        Insurance is an important asset barrier for individuals and families. Life is full of ups and downs, and the wealth accumulated through a lifetime of hard work may fluctuate with changes in the market environment. Therefore, high-net-worth clients particularly need more proactive and effective insurance financial planning to build a solid wealth barrier, enabling the family business to remain stable and thrive.\n      </p>\n      <p class=\"perText\">NCI understands the unique needs of every high-net-worth client and upholds professional and rigorous service quality to help you achieve the great endeavor of wealth inheritance.\n      </p>\n    </div>\n  </div>\n  <div class=\"contentBox\">\n    <div class=\"leftT\">\n      <div class=\"tpA\">\n        <p class=\"perTitle\"><em class=\"bigText\">NCI </em><em class=\"smallText\">combines insurance with other strategic partners to strive to help high-net-worth clients:</em></p>\n        <p class=\"circleText\">Have stable and secure personal and family protection</p>\n        <p class=\"circleText\">Integrate wealth resources and enjoy a rich life</p>\n        <p class=\"circleText\">Achieve asset appreciation and intergenerational wealth inheritance</p>\n        <p class=\"circleText\">Develop a positive and proactive insurance financial outlook</p>\n      </div>\n      <div class=\"tpA\">\n        <p class=\"perTitle\"><em class=\"bigText\">NCI </em><em class=\"smallText\">stands out with its unique values:</em></p>\n        <p class=\"circleText\">Break through market barriers or product-oriented approaches and tailor the best insurance plans specifically for clients</p>\n        <p class=\"circleText\">Prioritize client interests and use actuarial techniques to compare various insurance products</p>\n        <p class=\"circleText\">Provide the most appropriate insurance planning according to clients' different needs at various life stages</p>\n        <p class=\"circleText\">Integrate partner resources to assist clients in achieving their insurance financial plans</p>\n        <p class=\"circleText\">Grasp trends and suggest to international insurance groups to develop high-quality insurance products that best meet clients' needs</p>\n      </div>\n    </div>\n    <div class=\"rightT\">\n      <img src=\"/nci/images/pc/pc_18.jpg\">\n    </div>\n  </div>\n</div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "Business Philosophy",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 16:30:08",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40131,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/7e277cbe-d10a-42b2-bf51-f466e3eac7a6.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40131,
              "Name": "Business Philosophy",
              "ParentId": 0,
              "Path": "40131",
              "CatPaths": [
                {
                  "CatId": "40131",
                  "PathName": "Business Philosophy"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"20348\",\"ContentId\":\"20348\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20348,
            "Key": "K20260105163008",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "Business Philosophy",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"BusinessPhilosophyBox\"><div class=\"topbox\"><div class=\"warper\"><p class=\"perText\">Insurance is an important asset barrier for individuals and families. Life is full of ups and downs, and the wealth accumulated through a lifetime of hard work may fluctuate with changes in the market environment. Therefore, high-net-worth clients particularly need more proactive and effective insurance financial planning to build a solid wealth barrier, enabling the family business to remain stable and thrive.</p><p class=\"perText\">NCI understands the unique needs of every high-net-worth client and upholds professional and rigorous service quality to help you achieve the great endeavor of wealth inheritance.</p></div></div><div class=\"contentBox\"><div class=\"leftT\"><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">NCI </em><em class=\"smallText\">combines insurance with other strategic partners to strive to help high-net-worth clients:</em></p><p class=\"circleText\">Have stable and secure personal and family protection</p><p class=\"circleText\">Integrate wealth resources and enjoy a rich life</p><p class=\"circleText\">Achieve asset appreciation and intergenerational wealth inheritance</p><p class=\"circleText\">Develop a positive and proactive insurance financial outlook</p></div><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">NCI </em><em class=\"smallText\">stands out with its unique values:</em></p><p class=\"circleText\">Break through market barriers or product-oriented approaches and tailor the best insurance plans specifically for clients</p><p class=\"circleText\">Prioritize client interests and use actuarial techniques to compare various insurance products</p><p class=\"circleText\">Provide the most appropriate insurance planning according to clients&#39; different needs at various life stages</p><p class=\"circleText\">Integrate partner resources to assist clients in achieving their insurance financial plans</p><p class=\"circleText\">Grasp trends and suggest to international insurance groups to develop high-quality insurance products that best meet clients&#39; needs</p></div></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_18.jpg\"/></div></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "Business Philosophy",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 16:30:08",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40131,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/ef71390e-f227-4759-a2d8-f37894a8ca04.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40131,
              "Name": "Business Philosophy",
              "ParentId": 0,
              "Path": "40131",
              "CatPaths": [
                {
                  "CatId": "40131",
                  "PathName": "Business Philosophy"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"20349\",\"ContentId\":\"20349\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20349,
            "Key": "K20260105163036",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "Quality Service",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"ExcellentServiceBox\"><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">Providing</em><em class=\"smallText\">Comprehensive Insurance Planning</em></p><p class=\"normarText\">NCI\nrepresents insurance products from multiple internationally renowned insurance companies. We have an in-depth understanding of the characteristics of different products, excel at comprehensive analysis and evaluation, and collaborate with top-tier private banks, professional tax and financial teams worldwide to recommend well-rounded insurance plans. These plans are tailored to match clients&#39; asset preservation and wealth appreciation needs at different stages, aiming to design the best insurance planning solutions according to each client&#39;s unique requirements.</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_12.jpg\"/></div></div></div><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">Comprehensive</em><em class=\"smallText\">Product Analysis and Comparison</em></p><p class=\"normarText\">NCI maintains close cooperative relationships with insurance companies, enabling us to quickly grasp the latest market information and keep clients fully informed about product trends, profitability analysis, cost calculations, and changes. Meanwhile, our professional team leverages long-accumulated rich experience to analyze the pros and cons of various insurance products according to clients&#39; needs, assisting clients in making full use of insurance and banking services to select the most autonomous insurance and financial planning solutions.</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_13.jpg\"/></div></div></div><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">Prestigious</em><em class=\"smallText\">Customer Service</em></p><p class=\"normarText\">NCI places clients at the forefront and provides high-quality services, including:</p><p class=\"circleText\">Establishing comprehensive insurance plans for clients</p><p class=\"circleText\">Creating comprehensive insurance product analyses and comparisons</p><p class=\"circleText\">Providing clients with the latest information on the financial insurance market</p><p class=\"circleText\">Proactively reviewing annual reports based on the original insurance plans, analyzing the performance of policies over the years to safeguard clients&#39; rights and interests</p><p class=\"circleText\">Assisting high-net-worth clients in establishing correct insurance concepts</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_14.jpg\"/></div></div></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "Quality Service",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 16:30:36",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40132,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/1ac895eb-52fe-4fdd-bb8c-e72db4bb7b48.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40132,
              "Name": "Quality Service",
              "ParentId": 0,
              "Path": "40132",
              "CatPaths": [
                {
                  "CatId": "40132",
                  "PathName": "Quality Service"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"20349\",\"ContentId\":\"20349\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20349,
            "Key": "K20260105163036",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "Quality Service",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"ExcellentServiceBox\"><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">Providing</em><em class=\"smallText\">Comprehensive Insurance Planning</em></p><p class=\"normarText\">NCI\nrepresents insurance products from multiple internationally renowned insurance companies. We have an in-depth understanding of the characteristics of different products, excel at comprehensive analysis and evaluation, and collaborate with top-tier private banks, professional tax and financial teams worldwide to recommend well-rounded insurance plans. These plans are tailored to match clients&#39; asset preservation and wealth appreciation needs at different stages, aiming to design the best insurance planning solutions according to each client&#39;s unique requirements.</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_12.jpg\"/></div></div></div><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">Comprehensive</em><em class=\"smallText\">Product Analysis and Comparison</em></p><p class=\"normarText\">NCI maintains close cooperative relationships with insurance companies, enabling us to quickly grasp the latest market information and keep clients fully informed about product trends, profitability analysis, cost calculations, and changes. Meanwhile, our professional team leverages long-accumulated rich experience to analyze the pros and cons of various insurance products according to clients&#39; needs, assisting clients in making full use of insurance and banking services to select the most autonomous insurance and financial planning solutions.</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_13.jpg\"/></div></div></div><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">Prestigious</em><em class=\"smallText\">Customer Service</em></p><p class=\"normarText\">NCI places clients at the forefront and provides high-quality services, including:</p><p class=\"circleText\">Establishing comprehensive insurance plans for clients</p><p class=\"circleText\">Creating comprehensive insurance product analyses and comparisons</p><p class=\"circleText\">Providing clients with the latest information on the financial insurance market</p><p class=\"circleText\">Proactively reviewing annual reports based on the original insurance plans, analyzing the performance of policies over the years to safeguard clients&#39; rights and interests</p><p class=\"circleText\">Assisting high-net-worth clients in establishing correct insurance concepts</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_14.jpg\"/></div></div></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "Quality Service",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 16:30:36",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40132,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/c7d9fa04-86f5-4800-a493-39128c5e1592.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40132,
              "Name": "Quality Service",
              "ParentId": 0,
              "Path": "40132",
              "CatPaths": [
                {
                  "CatId": "40132",
                  "PathName": "Quality Service"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"20350\",\"ContentId\":\"20350\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20350,
            "Key": "K20260105163059",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "Universal Life Insurance",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"UniversalLifeInsuranceBox\"><div class=\"topbox\"><div class=\"warper\"><p class=\"perText\">Universal life insurance is an insurance product that combines life protection and wealth appreciation. Compared with traditional life insurance products, universal life insurance not only provides protection but also enables relatively stable investment returns, achieving the goals of savings, asset appreciation, and inheritance.</p></div></div><div class=\"contentBox\"><div class=\"leftT\"><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">A More Flexible Type of Insurance </em></p><p class=\"NrText\">Most universal life insurance policies allow the policyholder to adjust the insured amount according to actual needs or modify the savings component of the policy, with flexible premium adjustments. Policyholders can also invest additional funds or withdraw the accumulated cash value at any time based on their personal circumstances and financial environment. Compared with traditional life insurance products, universal life insurance is more flexible and transparent, providing policyholders with adaptable autonomy to meet the needs of different life stages in line with their actual family and financial situations.</p></div><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">Premium/Policy Financing </em></p><p class=\"NrText\">Universal life insurance policies have stable value and can serve as collateral for private bank loans, enabling high-net-worth clients to make good use of low-interest-rate financing leverage to enhance financial management efficiency. Whether it is using premium financing to obtain high-amount life insurance protection or utilizing policy financing limits to accumulate a potential reserve fund for various plans such as investment, inheritance, and retirement, it allows wealth preservation while more efficiently achieving diverse financial goals. NCI closely collaborates with multiple private banks and financial institutions to provide premium or policy financing services according to clients&#39; needs.</p></div></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_22.jpg\"/></div></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "Universal Life Insurance",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 16:30:59",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40133,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/f740b11e-6925-4eaf-9979-151dcdb2e09c.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40133,
              "Name": "Universal Life Insurance",
              "ParentId": 0,
              "Path": "40133",
              "CatPaths": [
                {
                  "CatId": "40133",
                  "PathName": "Universal Life Insurance"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"20350\",\"ContentId\":\"20350\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20350,
            "Key": "K20260105163059",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "Universal Life Insurance",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"UniversalLifeInsuranceBox\"><div class=\"topbox\"><div class=\"warper\"><p class=\"perText\">Universal life insurance is an insurance product that combines life protection and wealth appreciation. Compared with traditional life insurance products, universal life insurance not only provides protection but also enables relatively stable investment returns, achieving the goals of savings, asset appreciation, and inheritance.</p></div></div><div class=\"contentBox\"><div class=\"leftT\"><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">A More Flexible Type of Insurance </em></p><p class=\"NrText\">Most universal life insurance policies allow the policyholder to adjust the insured amount according to actual needs or modify the savings component of the policy, with flexible premium adjustments. Policyholders can also invest additional funds or withdraw the accumulated cash value at any time based on their personal circumstances and financial environment. Compared with traditional life insurance products, universal life insurance is more flexible and transparent, providing policyholders with adaptable autonomy to meet the needs of different life stages in line with their actual family and financial situations.</p></div><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">Premium/Policy Financing </em></p><p class=\"NrText\">Universal life insurance policies have stable value and can serve as collateral for private bank loans, enabling high-net-worth clients to make good use of low-interest-rate financing leverage to enhance financial management efficiency. Whether it is using premium financing to obtain high-amount life insurance protection or utilizing policy financing limits to accumulate a potential reserve fund for various plans such as investment, inheritance, and retirement, it allows wealth preservation while more efficiently achieving diverse financial goals. NCI closely collaborates with multiple private banks and financial institutions to provide premium or policy financing services according to clients&#39; needs.</p></div></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_22.jpg\"/></div></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "Universal Life Insurance",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 16:30:59",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40133,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/80bb3c5e-b170-43f6-a7ea-461a753b9c5a.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40133,
              "Name": "Universal Life Insurance",
              "ParentId": 0,
              "Path": "40133",
              "CatPaths": [
                {
                  "CatId": "40133",
                  "PathName": "Universal Life Insurance"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeRelated\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeRelated\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeAbout\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20340,
            "Key": "HomeAbout",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "About Us",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"HomeNormal\"><p class=\"perText\"><em class=\"colorText\">New Century International Insurance Advisory Limited (NCI)</em> was established in 2007 and is a <span style=\"color: rgb(15, 17, 21); font-family: quote-cjk-patch, Inter, system-ui, -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Oxygen, Ubuntu, Cantarell, &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, sans-serif; background-color: rgb(255, 255, 255);\">Member of the Insurance Authority (License Number FB1543)</span>. Its main business is to provide customers with high-quality insurance intermediary services. NCI has a professional team with comprehensive and rich qualifications and years of experience. It is highly innovative and leading in the field of insurance planning and is committed to providing high-net-worth clients worldwide with life insurance planning advice and tailor-made professional services with a global perspective.</p><p class=\"perText\">The needs of high-net-worth clients vary, and NCI adheres to the customer-centric belief, delving deep into understanding the unique needs of each client...</p></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "About Us",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 10:52:40",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0cb969dd-55f4-4c53-bbe1-9bdf58e7498e.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "HomeRelated",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "HomeRelated"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": "20341",
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeAbout\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20340,
            "Key": "HomeAbout",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "About Us",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"HomeNormal\"><p class=\"perText\"><em class=\"colorText\">New Century International Insurance Advisory Limited (NCI)</em> was established in 2007 and is a <span style=\"color: rgb(15, 17, 21); font-family: quote-cjk-patch, Inter, system-ui, -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Oxygen, Ubuntu, Cantarell, &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, sans-serif; background-color: rgb(255, 255, 255);\">Member of the Insurance Authority (License Number FB1543)</span>. Its main business is to provide customers with high-quality insurance intermediary services. NCI has a professional team with comprehensive and rich qualifications and years of experience. It is highly innovative and leading in the field of insurance planning and is committed to providing high-net-worth clients worldwide with life insurance planning advice and tailor-made professional services with a global perspective.</p><p class=\"perText\">The needs of high-net-worth clients vary, and NCI adheres to the customer-centric belief, delving deep into understanding the unique needs of each client...</p></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "About Us",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 10:52:40",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/5e466c8a-c463-40cb-b1eb-3966dfb332f4.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "HomeRelated",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "HomeRelated"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": null,
            "NextId": "20341",
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeBusinessPhilosophy\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20341,
            "Key": "HomeBusinessPhilosophy",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "Business Philosophy",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"HomeNormal\"><p class=\"perText\">Insurance serves as an important asset safeguard for individuals and families. Life is full of ups and downs, and the wealth accumulated through a lifetime of hard work may fluctuate with changes in the market environment. Therefore, high-net-worth clients particularly need more proactive and effective insurance and financial planning to build a solid wealth safeguard, enabling their family businesses to remain stable and thrive.</p><p class=\"perText\">NCI understands the unique needs of every high-net-worth client and adheres to professional and rigorous service quality to help you accomplish the great task of wealth inheritance...</p></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "Business Philosophy",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 10:53:37",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0667ecec-42aa-4579-bd0e-30bce7c2cb05.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "HomeRelated",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "HomeRelated"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": "20340",
            "NextId": "20342",
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeBusinessPhilosophy\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20341,
            "Key": "HomeBusinessPhilosophy",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "Business Philosophy",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"HomeNormal\"><p class=\"perText\">Insurance serves as an important asset safeguard for individuals and families. Life is full of ups and downs, and the wealth accumulated through a lifetime of hard work may fluctuate with changes in the market environment. Therefore, high-net-worth clients particularly need more proactive and effective insurance and financial planning to build a solid wealth safeguard, enabling their family businesses to remain stable and thrive.</p><p class=\"perText\">NCI understands the unique needs of every high-net-worth client and adheres to professional and rigorous service quality to help you accomplish the great task of wealth inheritance...</p></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "Business Philosophy",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 10:53:37",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/c98b9ba6-b92b-4850-b3c4-78a06e1f1e68.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "HomeRelated",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "HomeRelated"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": "20340",
            "NextId": "20342",
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeQualityService\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20342,
            "Key": "HomeQualityService",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "Quality Service",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "Quality Service",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 10:54:26",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/226b859b-d3fd-49f7-a19d-eaa154941db7.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "HomeRelated",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "HomeRelated"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": "20341",
            "NextId": "20343",
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeQualityService\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20342,
            "Key": "HomeQualityService",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "Quality Service",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "Quality Service",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 10:54:26",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0b7880a1-04e6-4b49-8f16-cbb9fe317fd7.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "HomeRelated",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "HomeRelated"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": "20341",
            "NextId": "20343",
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeUniversalLifeInsurance\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20343,
            "Key": "HomeUniversalLifeInsurance",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "Universal Life Insurance",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"HomeNormal\"><p class=\"perText\">Universal life insurance is an insurance product that combines life protection and wealth appreciation. Compared to traditional life insurance products, universal life insurance not only provides protection but also offers relatively stable profit returns, achieving the goals of savings, asset appreciation, and inheritance...</p></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "Universal Life Insurance",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 10:54:59",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/3d242c00-301d-4a2d-bb1d-2f83a18a779e.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "HomeRelated",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "HomeRelated"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": "20342",
            "NextId": "20344",
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeUniversalLifeInsurance\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20343,
            "Key": "HomeUniversalLifeInsurance",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "Universal Life Insurance",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"HomeNormal\"><p class=\"perText\">Universal life insurance is an insurance product that combines life protection and wealth appreciation. Compared to traditional life insurance products, universal life insurance not only provides protection but also offers relatively stable profit returns, achieving the goals of savings, asset appreciation, and inheritance...</p></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "Universal Life Insurance",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 10:54:59",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/b01b6a8d-da30-4e94-871d-ce4603e10b0a.jpg",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "HomeRelated",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "HomeRelated"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": "20342",
            "NextId": "20344",
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeContactUs\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20345,
            "Key": "HomeContactUs",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "Contact Us",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">Address:</p><p class=\"text\">Room 502A, 5/F, Phase I, Cheung Sha Wan Plaza, 833 Cheung Sha Wan Road, Kowloon, Hong Kong</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">Telephone:</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">Fax:</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">Email:</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "Contact Us",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 11:49:48",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "HomeRelated",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "HomeRelated"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": "20344",
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeContactUs\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20345,
            "Key": "HomeContactUs",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "Contact Us",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">Address:</p><p class=\"text\">Room 502A, 5/F, Phase I, Cheung Sha Wan Plaza, 833 Cheung Sha Wan Road, Kowloon, Hong Kong</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">Telephone:</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">Fax:</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">Email:</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "Contact Us",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 11:49:48",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "HomeRelated",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "HomeRelated"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": "20344",
            "NextId": null,
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeMap\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20344,
            "Key": "HomeMap",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "Map",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<p><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.4372524704454!2d114.14615207586719!3d22.33711294155908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340407548be66e61%3A0xc6bc9dedfdffc038!2z6ZW_5rKZ5rm-5bm_5Zy6!5e0!3m2!1szh-CN!2shk!4v1767584496915!5m2!1szh-CN!2shk\" width=\"100%\" height=\"100%\" frameborder=\"0\"></iframe></p>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "Map",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 11:43:13",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "HomeRelated",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "HomeRelated"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": false,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": "20343",
            "NextId": "20345",
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"HomeMap\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 20344,
            "Key": "HomeMap",
            "Author": "",
            "AuthorTransId": "00000000-0000-0000-0000-000000000000",
            "Desc": "Map",
            "DescTransId": "00000000-0000-0000-0000-000000000000",
            "Body": "<p><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.4372524704454!2d114.14615207586719!3d22.33711294155908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340407548be66e61%3A0xc6bc9dedfdffc038!2z6ZW_5rKZ5rm-5bm_5Zy6!5e0!3m2!1szh-CN!2shk!4v1767584496915!5m2!1szh-CN!2shk\" width=\"100%\" height=\"100%\" frameborder=\"0\"></iframe></p>",
            "ContentTransId": "00000000-0000-0000-0000-000000000000",
            "MContentTransId": "00000000-0000-0000-0000-000000000000",
            "Title": "Map",
            "TitleTransId": "00000000-0000-0000-0000-000000000000",
            "ImagePath": null,
            "CreateDate": "2026-01-05 11:43:13",
            "UpdateDate": null,
            "CreateDateVal": null,
            "UpdateDateVal": null,
            "CatId": 40128,
            "Cover": "",
            "CoverId": null,
            "Url": "",
            "UrlTransId": "00000000-0000-0000-0000-000000000000",
            "Category": {
              "Id": 40128,
              "Name": "HomeRelated",
              "ParentId": 0,
              "Path": "40128",
              "CatPaths": [
                {
                  "CatId": "40128",
                  "PathName": "HomeRelated"
                }
              ]
            },
            "SeoKeyword": "",
            "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
            "SeoDesc": "",
            "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
            "Status": 0,
            "CmsControl": [],
            "ContentDateTime": null,
            "IsTop": false,
            "IsOpenWindows": false,
            "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
            "IsMobile": true,
            "WeekNum": null,
            "ContentDateTimeStr": null,
            "Parentid": 0,
            "CatKey": null,
            "PreviousId": "20343",
            "NextId": "20345",
            "Seq": null
          },
          "Code": 0
        },
        "{\"Key\":\"footerContact\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"footerContact\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"LINK\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"LINK\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"AppointmentRenewal\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"AppointmentRenewal\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        }
      },
      "contentByKey": {
        "{\"key\":\"HomeRelated\"}": {
          "Id": 0,
          "Key": "",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 0,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/?flag=1778685651221",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 0,
            "Name": null,
            "ParentId": 0,
            "Path": null,
            "CatPaths": null
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": null,
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"key\":\"HomeAbout\"}": {
          "Id": 20340,
          "Key": "HomeAbout",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "About Us",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "<div class=\"HomeNormal\"><p class=\"perText\"><em class=\"colorText\">New Century International Insurance Advisory Limited (NCI)</em> was established in 2007 and is a <span style=\"color: rgb(15, 17, 21); font-family: quote-cjk-patch, Inter, system-ui, -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Oxygen, Ubuntu, Cantarell, &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, sans-serif; background-color: rgb(255, 255, 255);\">Member of the Insurance Authority (License Number FB1543)</span>. Its main business is to provide customers with high-quality insurance intermediary services. NCI has a professional team with comprehensive and rich qualifications and years of experience. It is highly innovative and leading in the field of insurance planning and is committed to providing high-net-worth clients worldwide with life insurance planning advice and tailor-made professional services with a global perspective.</p><p class=\"perText\">The needs of high-net-worth clients vary, and NCI adheres to the customer-centric belief, delving deep into understanding the unique needs of each client...</p></div>",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "About Us",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 10:52:40",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40128,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0cb969dd-55f4-4c53-bbe1-9bdf58e7498e.jpg",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40128,
            "Name": "HomeRelated",
            "ParentId": 0,
            "Path": "40128",
            "CatPaths": [
              {
                "CatId": "40128",
                "PathName": "HomeRelated"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": null,
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"key\":\"HomeBusinessPhilosophy\"}": {
          "Id": 20341,
          "Key": "HomeBusinessPhilosophy",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "Business Philosophy",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "<div class=\"HomeNormal\"><p class=\"perText\">Insurance serves as an important asset safeguard for individuals and families. Life is full of ups and downs, and the wealth accumulated through a lifetime of hard work may fluctuate with changes in the market environment. Therefore, high-net-worth clients particularly need more proactive and effective insurance and financial planning to build a solid wealth safeguard, enabling their family businesses to remain stable and thrive.</p><p class=\"perText\">NCI understands the unique needs of every high-net-worth client and adheres to professional and rigorous service quality to help you accomplish the great task of wealth inheritance...</p></div>",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "Business Philosophy",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 10:53:37",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40128,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0667ecec-42aa-4579-bd0e-30bce7c2cb05.jpg",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40128,
            "Name": "HomeRelated",
            "ParentId": 0,
            "Path": "40128",
            "CatPaths": [
              {
                "CatId": "40128",
                "PathName": "HomeRelated"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": null,
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"key\":\"HomeQualityService\"}": {
          "Id": 20342,
          "Key": "HomeQualityService",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "Quality Service",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "Quality Service",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 10:54:26",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40128,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/226b859b-d3fd-49f7-a19d-eaa154941db7.jpg",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40128,
            "Name": "HomeRelated",
            "ParentId": 0,
            "Path": "40128",
            "CatPaths": [
              {
                "CatId": "40128",
                "PathName": "HomeRelated"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": null,
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"key\":\"HomeUniversalLifeInsurance\"}": {
          "Id": 20343,
          "Key": "HomeUniversalLifeInsurance",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "Universal Life Insurance",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "<div class=\"HomeNormal\"><p class=\"perText\">Universal life insurance is an insurance product that combines life protection and wealth appreciation. Compared to traditional life insurance products, universal life insurance not only provides protection but also offers relatively stable profit returns, achieving the goals of savings, asset appreciation, and inheritance...</p></div>",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "Universal Life Insurance",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 10:54:59",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40128,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/3d242c00-301d-4a2d-bb1d-2f83a18a779e.jpg",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40128,
            "Name": "HomeRelated",
            "ParentId": 0,
            "Path": "40128",
            "CatPaths": [
              {
                "CatId": "40128",
                "PathName": "HomeRelated"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": null,
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"key\":\"HomeContactUs\"}": {
          "Id": 20345,
          "Key": "HomeContactUs",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "Contact Us",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">Address:</p><p class=\"text\">Room 502A, 5/F, Phase I, Cheung Sha Wan Plaza, 833 Cheung Sha Wan Road, Kowloon, Hong Kong</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">Telephone:</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">Fax:</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">Email:</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "Contact Us",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 11:49:48",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40128,
          "Cover": "",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40128,
            "Name": "HomeRelated",
            "ParentId": 0,
            "Path": "40128",
            "CatPaths": [
              {
                "CatId": "40128",
                "PathName": "HomeRelated"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": null,
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"key\":\"HomeMap\"}": {
          "Id": 20344,
          "Key": "HomeMap",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "Map",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "<p><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.4372524704454!2d114.14615207586719!3d22.33711294155908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340407548be66e61%3A0xc6bc9dedfdffc038!2z6ZW_5rKZ5rm-5bm_5Zy6!5e0!3m2!1szh-CN!2shk!4v1767584496915!5m2!1szh-CN!2shk\" width=\"100%\" height=\"100%\" frameborder=\"0\"></iframe></p>",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "Map",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "2026-01-05 11:43:13",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 40128,
          "Cover": "",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 40128,
            "Name": "HomeRelated",
            "ParentId": 0,
            "Path": "40128",
            "CatPaths": [
              {
                "CatId": "40128",
                "PathName": "HomeRelated"
              }
            ]
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": null,
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"key\":\"footerContact\"}": {
          "Id": 0,
          "Key": "",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 0,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/?flag=1778685675159",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 0,
            "Name": null,
            "ParentId": 0,
            "Path": null,
            "CatPaths": null
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": null,
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"key\":\"LINK\"}": {
          "Id": 0,
          "Key": "",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 0,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/?flag=1778685677081",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 0,
            "Name": null,
            "ParentId": 0,
            "Path": null,
            "CatPaths": null
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": null,
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        },
        "{\"key\":\"AppointmentRenewal\"}": {
          "Id": 0,
          "Key": "",
          "Author": "",
          "AuthorTransId": "00000000-0000-0000-0000-000000000000",
          "Desc": "",
          "DescTransId": "00000000-0000-0000-0000-000000000000",
          "Body": "",
          "ContentTransId": "00000000-0000-0000-0000-000000000000",
          "MContentTransId": "00000000-0000-0000-0000-000000000000",
          "Title": "",
          "TitleTransId": "00000000-0000-0000-0000-000000000000",
          "ImagePath": null,
          "CreateDate": "",
          "UpdateDate": null,
          "CreateDateVal": null,
          "UpdateDateVal": null,
          "CatId": 0,
          "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/?flag=1778685679581",
          "CoverId": null,
          "Url": "",
          "UrlTransId": "00000000-0000-0000-0000-000000000000",
          "Category": {
            "Id": 0,
            "Name": null,
            "ParentId": 0,
            "Path": null,
            "CatPaths": null
          },
          "SeoKeyword": "",
          "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
          "SeoDesc": "",
          "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
          "Status": 0,
          "CmsControl": null,
          "ContentDateTime": null,
          "IsTop": false,
          "IsOpenWindows": false,
          "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
          "IsMobile": false,
          "WeekNum": null,
          "ContentDateTimeStr": null,
          "Parentid": 0,
          "CatKey": null,
          "PreviousId": null,
          "NextId": null,
          "Seq": null
        }
      },
      "contentsByCatKey": {
        "{\"key\":\"HomeRelated\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 1,
          "TotalRecord": 6,
          "Data": [
            {
              "Id": 20340,
              "Key": "HomeAbout",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "About Us",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeNormal\"><p class=\"perText\"><em class=\"colorText\">New Century International Insurance Advisory Limited (NCI)</em> was established in 2007 and is a <span style=\"color: rgb(15, 17, 21); font-family: quote-cjk-patch, Inter, system-ui, -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Oxygen, Ubuntu, Cantarell, &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, sans-serif; background-color: rgb(255, 255, 255);\">Member of the Insurance Authority (License Number FB1543)</span>. Its main business is to provide customers with high-quality insurance intermediary services. NCI has a professional team with comprehensive and rich qualifications and years of experience. It is highly innovative and leading in the field of insurance planning and is committed to providing high-net-worth clients worldwide with life insurance planning advice and tailor-made professional services with a global perspective.</p><p class=\"perText\">The needs of high-net-worth clients vary, and NCI adheres to the customer-centric belief, delving deep into understanding the unique needs of each client...</p></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "About Us",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:52:40",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:52:40",
              "UpdateDateVal": "2026-05-07 15:45:50",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0cb969dd-55f4-4c53-bbe1-9bdf58e7498e.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "HomeRelated",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "HomeRelated"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:51:49",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            },
            {
              "Id": 20345,
              "Key": "HomeContactUs",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Contact Us",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">Address:</p><p class=\"text\">Room 502A, 5/F, Phase I, Cheung Sha Wan Plaza, 833 Cheung Sha Wan Road, Kowloon, Hong Kong</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">Telephone:</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">Fax:</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">Email:</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Contact Us",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 11:49:48",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 11:49:48",
              "UpdateDateVal": "2026-01-05 11:49:48",
              "CatId": 40128,
              "Cover": "",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "HomeRelated",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "HomeRelated"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 11:48:37",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            },
            {
              "Id": 20344,
              "Key": "HomeMap",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Map",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<p><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.4372524704454!2d114.14615207586719!3d22.33711294155908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340407548be66e61%3A0xc6bc9dedfdffc038!2z6ZW_5rKZ5rm-5bm_5Zy6!5e0!3m2!1szh-CN!2shk!4v1767584496915!5m2!1szh-CN!2shk\" width=\"100%\" height=\"100%\" frameborder=\"0\"></iframe></p>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Map",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 11:43:13",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 11:43:13",
              "UpdateDateVal": "2026-01-05 11:43:13",
              "CatId": 40128,
              "Cover": "",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "HomeRelated",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "HomeRelated"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 11:42:07",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            },
            {
              "Id": 20342,
              "Key": "HomeQualityService",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Quality Service",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Quality Service",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:54:26",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:54:26",
              "UpdateDateVal": "2026-01-05 11:25:57",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/226b859b-d3fd-49f7-a19d-eaa154941db7.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "HomeRelated",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "HomeRelated"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:53:40",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            },
            {
              "Id": 20343,
              "Key": "HomeUniversalLifeInsurance",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Universal Life Insurance",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeNormal\"><p class=\"perText\">Universal life insurance is an insurance product that combines life protection and wealth appreciation. Compared to traditional life insurance products, universal life insurance not only provides protection but also offers relatively stable profit returns, achieving the goals of savings, asset appreciation, and inheritance...</p></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Universal Life Insurance",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:54:59",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:54:59",
              "UpdateDateVal": "2026-01-05 11:21:47",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/3d242c00-301d-4a2d-bb1d-2f83a18a779e.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "HomeRelated",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "HomeRelated"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:54:29",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            },
            {
              "Id": 20341,
              "Key": "HomeBusinessPhilosophy",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Business Philosophy",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeNormal\"><p class=\"perText\">Insurance serves as an important asset safeguard for individuals and families. Life is full of ups and downs, and the wealth accumulated through a lifetime of hard work may fluctuate with changes in the market environment. Therefore, high-net-worth clients particularly need more proactive and effective insurance and financial planning to build a solid wealth safeguard, enabling their family businesses to remain stable and thrive.</p><p class=\"perText\">NCI understands the unique needs of every high-net-worth client and adheres to professional and rigorous service quality to help you accomplish the great task of wealth inheritance...</p></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Business Philosophy",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:53:37",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:53:37",
              "UpdateDateVal": "2026-01-05 11:06:26",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0667ecec-42aa-4579-bd0e-30bce7c2cb05.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "HomeRelated",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "HomeRelated"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:52:46",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            }
          ],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"key\":\"HomeAbout\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"key\":\"HomeBusinessPhilosophy\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"key\":\"HomeQualityService\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"key\":\"HomeUniversalLifeInsurance\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"key\":\"HomeContactUs\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"key\":\"HomeMap\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"key\":\"footerContact\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"key\":\"LINK\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"key\":\"AppointmentRenewal\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        }
      },
      "contentsByCatKeyEx": {
        "{\"Key\":\"HomeRelated\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 1,
          "TotalRecord": 6,
          "Data": [
            {
              "Id": 20340,
              "Key": "HomeAbout",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "About Us",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeNormal\"><p class=\"perText\"><em class=\"colorText\">New Century International Insurance Advisory Limited (NCI)</em> was established in 2007 and is a <span style=\"color: rgb(15, 17, 21); font-family: quote-cjk-patch, Inter, system-ui, -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Oxygen, Ubuntu, Cantarell, &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, sans-serif; background-color: rgb(255, 255, 255);\">Member of the Insurance Authority (License Number FB1543)</span>. Its main business is to provide customers with high-quality insurance intermediary services. NCI has a professional team with comprehensive and rich qualifications and years of experience. It is highly innovative and leading in the field of insurance planning and is committed to providing high-net-worth clients worldwide with life insurance planning advice and tailor-made professional services with a global perspective.</p><p class=\"perText\">The needs of high-net-worth clients vary, and NCI adheres to the customer-centric belief, delving deep into understanding the unique needs of each client...</p></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "About Us",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:52:40",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:52:40",
              "UpdateDateVal": "2026-05-07 15:45:50",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0cb969dd-55f4-4c53-bbe1-9bdf58e7498e.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "HomeRelated",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "HomeRelated"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:51:49",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": "Monday",
              "ContentDateTimeStr": "2026/01/05 10:51:49",
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            },
            {
              "Id": 20345,
              "Key": "HomeContactUs",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Contact Us",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">Address:</p><p class=\"text\">Room 502A, 5/F, Phase I, Cheung Sha Wan Plaza, 833 Cheung Sha Wan Road, Kowloon, Hong Kong</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">Telephone:</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">Fax:</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">Email:</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Contact Us",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 11:49:48",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 11:49:48",
              "UpdateDateVal": "2026-01-05 11:49:48",
              "CatId": 40128,
              "Cover": "",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "HomeRelated",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "HomeRelated"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 11:48:37",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": "Monday",
              "ContentDateTimeStr": "2026/01/05 11:48:37",
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            },
            {
              "Id": 20344,
              "Key": "HomeMap",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Map",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<p><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.4372524704454!2d114.14615207586719!3d22.33711294155908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340407548be66e61%3A0xc6bc9dedfdffc038!2z6ZW_5rKZ5rm-5bm_5Zy6!5e0!3m2!1szh-CN!2shk!4v1767584496915!5m2!1szh-CN!2shk\" width=\"100%\" height=\"100%\" frameborder=\"0\"></iframe></p>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Map",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 11:43:13",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 11:43:13",
              "UpdateDateVal": "2026-01-05 11:43:13",
              "CatId": 40128,
              "Cover": "",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "HomeRelated",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "HomeRelated"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 11:42:07",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": "Monday",
              "ContentDateTimeStr": "2026/01/05 11:42:07",
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            },
            {
              "Id": 20342,
              "Key": "HomeQualityService",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Quality Service",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Quality Service",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:54:26",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:54:26",
              "UpdateDateVal": "2026-01-05 11:25:57",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/226b859b-d3fd-49f7-a19d-eaa154941db7.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "HomeRelated",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "HomeRelated"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:53:40",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": "Monday",
              "ContentDateTimeStr": "2026/01/05 10:53:40",
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            },
            {
              "Id": 20343,
              "Key": "HomeUniversalLifeInsurance",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Universal Life Insurance",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeNormal\"><p class=\"perText\">Universal life insurance is an insurance product that combines life protection and wealth appreciation. Compared to traditional life insurance products, universal life insurance not only provides protection but also offers relatively stable profit returns, achieving the goals of savings, asset appreciation, and inheritance...</p></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Universal Life Insurance",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:54:59",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:54:59",
              "UpdateDateVal": "2026-01-05 11:21:47",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/3d242c00-301d-4a2d-bb1d-2f83a18a779e.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "HomeRelated",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "HomeRelated"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:54:29",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": "Monday",
              "ContentDateTimeStr": "2026/01/05 10:54:29",
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            },
            {
              "Id": 20341,
              "Key": "HomeBusinessPhilosophy",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Business Philosophy",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeNormal\"><p class=\"perText\">Insurance serves as an important asset safeguard for individuals and families. Life is full of ups and downs, and the wealth accumulated through a lifetime of hard work may fluctuate with changes in the market environment. Therefore, high-net-worth clients particularly need more proactive and effective insurance and financial planning to build a solid wealth safeguard, enabling their family businesses to remain stable and thrive.</p><p class=\"perText\">NCI understands the unique needs of every high-net-worth client and adheres to professional and rigorous service quality to help you accomplish the great task of wealth inheritance...</p></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Business Philosophy",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:53:37",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:53:37",
              "UpdateDateVal": "2026-01-05 11:06:26",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0667ecec-42aa-4579-bd0e-30bce7c2cb05.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "HomeRelated",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "HomeRelated"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:52:46",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": "Monday",
              "ContentDateTimeStr": "2026/01/05 10:52:46",
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": 999
            }
          ],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"Key\":\"HomeAbout\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"Key\":\"HomeBusinessPhilosophy\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"Key\":\"HomeQualityService\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"Key\":\"HomeUniversalLifeInsurance\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"Key\":\"HomeContactUs\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"Key\":\"HomeMap\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"Key\":\"footerContact\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"Key\":\"LINK\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"Key\":\"AppointmentRenewal\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        }
      },
      "contentsByCatId": {
        "{\"catId\":\"40137\",\"page\":1,\"pageSize\":100}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        }
      },
      "contents": {},
      "categoryTree": {
        "{\"id\":\"40137\"}": [],
        "{\"Id\":40137}": []
      },
      "nextCategoryTree": {},
      "subCatContents": {
        "{\"CatId\":\"40137\",\"IsMobile\":false}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        },
        "{\"CatId\":\"40137\",\"IsMobile\":true}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        }
      },
      "lastestContents": {},
      "categoryRelateContent": {},
      "contentsByTitle": {
        "{\"Title\":\"\",\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 2,
          "TotalRecord": 11,
          "Data": [
            {
              "Id": 20340,
              "Key": "HomeAbout",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "About Us",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeNormal\"><p class=\"perText\"><em class=\"colorText\">New Century International Insurance Advisory Limited (NCI)</em> was established in 2007 and is a <span style=\"color: rgb(15, 17, 21); font-family: quote-cjk-patch, Inter, system-ui, -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Oxygen, Ubuntu, Cantarell, &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, sans-serif; background-color: rgb(255, 255, 255);\">Member of the Insurance Authority (License Number FB1543)</span>. Its main business is to provide customers with high-quality insurance intermediary services. NCI has a professional team with comprehensive and rich qualifications and years of experience. It is highly innovative and leading in the field of insurance planning and is committed to providing high-net-worth clients worldwide with life insurance planning advice and tailor-made professional services with a global perspective.</p><p class=\"perText\">The needs of high-net-worth clients vary, and NCI adheres to the customer-centric belief, delving deep into understanding the unique needs of each client...</p></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "About Us",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:52:40",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:52:40",
              "UpdateDateVal": "2026-05-07 15:45:50",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0cb969dd-55f4-4c53-bbe1-9bdf58e7498e.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "HomeRelated",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "HomeRelated"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:51:49",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": null
            },
            {
              "Id": 20346,
              "Key": "K20260105143250",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "About NCI",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"AboutNCI\"><div class=\"contentBox\"><div class=\"leftT\"><p class=\"perText\"><em class=\"colorText\">New Century International Insurance Advisory Limited (NCI)</em> was established in 2007 and is a member of the Insurance Authority of Hong Kong (License Number FB1543). Its main business is to provide customers with high-quality insurance intermediary services. NCI has a professional team with comprehensive and rich qualifications and years of experience. It is highly innovative and leading in the field of insurance planning and is committed to providing high-net-worth clients worldwide with life insurance planning advice and tailor-designed professional services with a global perspective.</p><p class=\"perText\">High-net-worth clients have diverse needs. NCI adheres to the customer-centric belief, deeply understanding the unique needs of each client and providing comprehensive insurance product advice and sales. Integrity is the most fundamental core value. NCI upholds this belief, carefully selecting insurance products and partners to fully safeguard client rights and interests. With its innovative and comprehensive insurance planning, NCI provides personalized and high-quality services to each high-net-worth client, striving to pursue mutual trust and long-term cooperation with clients.</p><p class=\"perText\">NCI represents products from several internationally renowned insurance companies and has established close interactive relationships with relevant professional partner institutions such as private banks, asset management consultants, accountants, and other teams. It strives to formulate the most suitable insurance plans for high-net-worth clients, aligning with clients&#39; goals such as asset allocation, inheritance, and financial planning.</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_29.jpg\"/></div></div><div class=\"bottomImg\"><img src=\"/nci/images/pc/Ebanner/Ebanner_02.png\"/></div></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "About NCI",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 14:32:50",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 14:32:50",
              "UpdateDateVal": "2026-05-06 15:36:56",
              "CatId": 40129,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/aa3c60e9-ad80-442b-ae3f-8f3dc5d64898.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40129,
                "Name": "About NCI",
                "ParentId": 0,
                "Path": "40129",
                "CatPaths": [
                  {
                    "CatId": "40129",
                    "PathName": "About NCI"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 14:32:33",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": null
            },
            {
              "Id": 20349,
              "Key": "K20260105163036",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Quality Service",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"ExcellentServiceBox\"><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">Providing</em><em class=\"smallText\">Comprehensive Insurance Planning</em></p><p class=\"normarText\">NCI\nrepresents insurance products from multiple internationally renowned insurance companies. We have an in-depth understanding of the characteristics of different products, excel at comprehensive analysis and evaluation, and collaborate with top-tier private banks, professional tax and financial teams worldwide to recommend well-rounded insurance plans. These plans are tailored to match clients&#39; asset preservation and wealth appreciation needs at different stages, aiming to design the best insurance planning solutions according to each client&#39;s unique requirements.</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_12.jpg\"/></div></div></div><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">Comprehensive</em><em class=\"smallText\">Product Analysis and Comparison</em></p><p class=\"normarText\">NCI maintains close cooperative relationships with insurance companies, enabling us to quickly grasp the latest market information and keep clients fully informed about product trends, profitability analysis, cost calculations, and changes. Meanwhile, our professional team leverages long-accumulated rich experience to analyze the pros and cons of various insurance products according to clients&#39; needs, assisting clients in making full use of insurance and banking services to select the most autonomous insurance and financial planning solutions.</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_13.jpg\"/></div></div></div><div class=\"Perlist\"><div class=\"warperBox\"><div class=\"leftT\"><p class=\"normarTitle\"><em class=\"bigText\">Prestigious</em><em class=\"smallText\">Customer Service</em></p><p class=\"normarText\">NCI places clients at the forefront and provides high-quality services, including:</p><p class=\"circleText\">Establishing comprehensive insurance plans for clients</p><p class=\"circleText\">Creating comprehensive insurance product analyses and comparisons</p><p class=\"circleText\">Providing clients with the latest information on the financial insurance market</p><p class=\"circleText\">Proactively reviewing annual reports based on the original insurance plans, analyzing the performance of policies over the years to safeguard clients&#39; rights and interests</p><p class=\"circleText\">Assisting high-net-worth clients in establishing correct insurance concepts</p></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_14.jpg\"/></div></div></div></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Quality Service",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 16:30:36",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 16:30:36",
              "UpdateDateVal": "2026-01-06 15:59:30",
              "CatId": 40132,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/1ac895eb-52fe-4fdd-bb8c-e72db4bb7b48.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40132,
                "Name": "Quality Service",
                "ParentId": 0,
                "Path": "40132",
                "CatPaths": [
                  {
                    "CatId": "40132",
                    "PathName": "Quality Service"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 16:30:14",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": null
            },
            {
              "Id": 20350,
              "Key": "K20260105163059",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Universal Life Insurance",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"UniversalLifeInsuranceBox\"><div class=\"topbox\"><div class=\"warper\"><p class=\"perText\">Universal life insurance is an insurance product that combines life protection and wealth appreciation. Compared with traditional life insurance products, universal life insurance not only provides protection but also enables relatively stable investment returns, achieving the goals of savings, asset appreciation, and inheritance.</p></div></div><div class=\"contentBox\"><div class=\"leftT\"><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">A More Flexible Type of Insurance </em></p><p class=\"NrText\">Most universal life insurance policies allow the policyholder to adjust the insured amount according to actual needs or modify the savings component of the policy, with flexible premium adjustments. Policyholders can also invest additional funds or withdraw the accumulated cash value at any time based on their personal circumstances and financial environment. Compared with traditional life insurance products, universal life insurance is more flexible and transparent, providing policyholders with adaptable autonomy to meet the needs of different life stages in line with their actual family and financial situations.</p></div><div class=\"tpA\"><p class=\"perTitle\"><em class=\"bigText\">Premium/Policy Financing </em></p><p class=\"NrText\">Universal life insurance policies have stable value and can serve as collateral for private bank loans, enabling high-net-worth clients to make good use of low-interest-rate financing leverage to enhance financial management efficiency. Whether it is using premium financing to obtain high-amount life insurance protection or utilizing policy financing limits to accumulate a potential reserve fund for various plans such as investment, inheritance, and retirement, it allows wealth preservation while more efficiently achieving diverse financial goals. NCI closely collaborates with multiple private banks and financial institutions to provide premium or policy financing services according to clients&#39; needs.</p></div></div><div class=\"rightT\"><img src=\"/nci/images/pc/pc_22.jpg\"/></div></div></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Universal Life Insurance",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 16:30:59",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 16:30:59",
              "UpdateDateVal": "2026-01-06 15:25:08",
              "CatId": 40133,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/f740b11e-6925-4eaf-9979-151dcdb2e09c.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40133,
                "Name": "Universal Life Insurance",
                "ParentId": 0,
                "Path": "40133",
                "CatPaths": [
                  {
                    "CatId": "40133",
                    "PathName": "Universal Life Insurance"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 16:30:40",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": null
            },
            {
              "Id": 20348,
              "Key": "K20260105163008",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Business Philosophy",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"BusinessPhilosophyBox\">\n  <div class=\"topbox\">\n    <div class=\"warper\">\n      <p class=\"perText\">\n        Insurance is an important asset barrier for individuals and families. Life is full of ups and downs, and the wealth accumulated through a lifetime of hard work may fluctuate with changes in the market environment. Therefore, high-net-worth clients particularly need more proactive and effective insurance financial planning to build a solid wealth barrier, enabling the family business to remain stable and thrive.\n      </p>\n      <p class=\"perText\">NCI understands the unique needs of every high-net-worth client and upholds professional and rigorous service quality to help you achieve the great endeavor of wealth inheritance.\n      </p>\n    </div>\n  </div>\n  <div class=\"contentBox\">\n    <div class=\"leftT\">\n      <div class=\"tpA\">\n        <p class=\"perTitle\"><em class=\"bigText\">NCI </em><em class=\"smallText\">combines insurance with other strategic partners to strive to help high-net-worth clients:</em></p>\n        <p class=\"circleText\">Have stable and secure personal and family protection</p>\n        <p class=\"circleText\">Integrate wealth resources and enjoy a rich life</p>\n        <p class=\"circleText\">Achieve asset appreciation and intergenerational wealth inheritance</p>\n        <p class=\"circleText\">Develop a positive and proactive insurance financial outlook</p>\n      </div>\n      <div class=\"tpA\">\n        <p class=\"perTitle\"><em class=\"bigText\">NCI </em><em class=\"smallText\">stands out with its unique values:</em></p>\n        <p class=\"circleText\">Break through market barriers or product-oriented approaches and tailor the best insurance plans specifically for clients</p>\n        <p class=\"circleText\">Prioritize client interests and use actuarial techniques to compare various insurance products</p>\n        <p class=\"circleText\">Provide the most appropriate insurance planning according to clients' different needs at various life stages</p>\n        <p class=\"circleText\">Integrate partner resources to assist clients in achieving their insurance financial plans</p>\n        <p class=\"circleText\">Grasp trends and suggest to international insurance groups to develop high-quality insurance products that best meet clients' needs</p>\n      </div>\n    </div>\n    <div class=\"rightT\">\n      <img src=\"/nci/images/pc/pc_18.jpg\">\n    </div>\n  </div>\n</div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Business Philosophy",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 16:30:08",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 16:30:08",
              "UpdateDateVal": "2026-01-06 14:59:48",
              "CatId": 40131,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/7e277cbe-d10a-42b2-bf51-f466e3eac7a6.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40131,
                "Name": "Business Philosophy",
                "ParentId": 0,
                "Path": "40131",
                "CatPaths": [
                  {
                    "CatId": "40131",
                    "PathName": "Business Philosophy"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 16:29:45",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": null
            },
            {
              "Id": 20347,
              "Key": "ContactUs",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Contact Us",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">Address:</p><p class=\"text\">Room 502A, 5/F, Phase I, Cheung Sha Wan Plaza, 833 Cheung Sha Wan Road, Kowloon, Hong Kong</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">Telephone:</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">Fax:</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">Email:</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Contact Us",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 14:56:39",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 14:56:39",
              "UpdateDateVal": "2026-01-05 15:01:24",
              "CatId": 40130,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/6cc86398-3d89-4fd5-868a-d51aa4306425.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40130,
                "Name": "Contact Us",
                "ParentId": 0,
                "Path": "40130",
                "CatPaths": [
                  {
                    "CatId": "40130",
                    "PathName": "Contact Us"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 14:56:20",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": null
            },
            {
              "Id": 20345,
              "Key": "HomeContactUs",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Contact Us",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">Address:</p><p class=\"text\">Room 502A, 5/F, Phase I, Cheung Sha Wan Plaza, 833 Cheung Sha Wan Road, Kowloon, Hong Kong</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">Telephone:</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">Fax:</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">Email:</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Contact Us",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 11:49:48",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 11:49:48",
              "UpdateDateVal": "2026-01-05 11:49:48",
              "CatId": 40128,
              "Cover": "",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "HomeRelated",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "HomeRelated"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 11:48:37",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": null
            },
            {
              "Id": 20344,
              "Key": "HomeMap",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Map",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<p><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.4372524704454!2d114.14615207586719!3d22.33711294155908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340407548be66e61%3A0xc6bc9dedfdffc038!2z6ZW_5rKZ5rm-5bm_5Zy6!5e0!3m2!1szh-CN!2shk!4v1767584496915!5m2!1szh-CN!2shk\" width=\"100%\" height=\"100%\" frameborder=\"0\"></iframe></p>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Map",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 11:43:13",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 11:43:13",
              "UpdateDateVal": "2026-01-05 11:43:13",
              "CatId": 40128,
              "Cover": "",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "HomeRelated",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "HomeRelated"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 11:42:07",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": null
            },
            {
              "Id": 20342,
              "Key": "HomeQualityService",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Quality Service",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Quality Service",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:54:26",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:54:26",
              "UpdateDateVal": "2026-01-05 11:25:57",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/226b859b-d3fd-49f7-a19d-eaa154941db7.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "HomeRelated",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "HomeRelated"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:53:40",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": null
            },
            {
              "Id": 20343,
              "Key": "HomeUniversalLifeInsurance",
              "Author": "",
              "AuthorTransId": "00000000-0000-0000-0000-000000000000",
              "Desc": "Universal Life Insurance",
              "DescTransId": "00000000-0000-0000-0000-000000000000",
              "Body": "<div class=\"HomeNormal\"><p class=\"perText\">Universal life insurance is an insurance product that combines life protection and wealth appreciation. Compared to traditional life insurance products, universal life insurance not only provides protection but also offers relatively stable profit returns, achieving the goals of savings, asset appreciation, and inheritance...</p></div>",
              "ContentTransId": "00000000-0000-0000-0000-000000000000",
              "MContentTransId": "00000000-0000-0000-0000-000000000000",
              "Title": "Universal Life Insurance",
              "TitleTransId": "00000000-0000-0000-0000-000000000000",
              "ImagePath": null,
              "CreateDate": "2026-01-05 10:54:59",
              "UpdateDate": null,
              "CreateDateVal": "2026-01-05 10:54:59",
              "UpdateDateVal": "2026-01-05 11:21:47",
              "CatId": 40128,
              "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/3d242c00-301d-4a2d-bb1d-2f83a18a779e.jpg",
              "CoverId": null,
              "Url": "",
              "UrlTransId": "00000000-0000-0000-0000-000000000000",
              "Category": {
                "Id": 40128,
                "Name": "HomeRelated",
                "ParentId": 0,
                "Path": "40128",
                "CatPaths": [
                  {
                    "CatId": "40128",
                    "PathName": "HomeRelated"
                  }
                ]
              },
              "SeoKeyword": "",
              "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
              "SeoDesc": "",
              "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
              "Status": 0,
              "CmsControl": [],
              "ContentDateTime": "2026-01-05 10:54:29",
              "IsTop": false,
              "IsOpenWindows": false,
              "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
              "IsMobile": false,
              "WeekNum": null,
              "ContentDateTimeStr": null,
              "Parentid": 0,
              "CatKey": null,
              "PreviousId": null,
              "NextId": null,
              "Seq": null
            }
          ],
          "Page": 1,
          "PageSize": 10,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        }
      },
      "category": {
        "{\"id\":\"40137\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        }
      },
      "categoryByDevice": {
        "{\"Key\":\"HomeRelated\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 40128,
            "Key": "HomeRelated",
            "Name": "HomeRelated",
            "Description": "HomeRelated",
            "Content": "",
            "URL": "/cms/catDetail/40128",
            "OpenNewWin": true,
            "ParentId": 0,
            "PageStyle": "1",
            "Children": [],
            "Img": null,
            "Collapse": false,
            "ImagePath": "",
            "Path": "40128",
            "CatPaths": [
              {
                "CatId": "40128",
                "PathName": "HomeRelated"
              }
            ],
            "SeoKeyword": "",
            "SeoDesc": "",
            "Father": [],
            "GroupId": 0,
            "RedirectURL": null,
            "Contents": [
              {
                "Id": 20340,
                "Key": "HomeAbout",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "About Us",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeNormal\"><p class=\"perText\"><em class=\"colorText\">New Century International Insurance Advisory Limited (NCI)</em> was established in 2007 and is a <span style=\"color: rgb(15, 17, 21); font-family: quote-cjk-patch, Inter, system-ui, -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Oxygen, Ubuntu, Cantarell, &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, sans-serif; background-color: rgb(255, 255, 255);\">Member of the Insurance Authority (License Number FB1543)</span>. Its main business is to provide customers with high-quality insurance intermediary services. NCI has a professional team with comprehensive and rich qualifications and years of experience. It is highly innovative and leading in the field of insurance planning and is committed to providing high-net-worth clients worldwide with life insurance planning advice and tailor-made professional services with a global perspective.</p><p class=\"perText\">The needs of high-net-worth clients vary, and NCI adheres to the customer-centric belief, delving deep into understanding the unique needs of each client...</p></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "About Us",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:52:40",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:52:40",
                "UpdateDateVal": "2026-05-07 15:45:50",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0cb969dd-55f4-4c53-bbe1-9bdf58e7498e.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "HomeRelated",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "HomeRelated"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:51:49",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": "Monday",
                "ContentDateTimeStr": "2026/01/05 10:51:49",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20345,
                "Key": "HomeContactUs",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "Contact Us",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">Address:</p><p class=\"text\">Room 502A, 5/F, Phase I, Cheung Sha Wan Plaza, 833 Cheung Sha Wan Road, Kowloon, Hong Kong</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">Telephone:</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">Fax:</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">Email:</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "Contact Us",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 11:49:48",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 11:49:48",
                "UpdateDateVal": "2026-01-05 11:49:48",
                "CatId": 40128,
                "Cover": "",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "HomeRelated",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "HomeRelated"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 11:48:37",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": "Monday",
                "ContentDateTimeStr": "2026/01/05 11:48:37",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20344,
                "Key": "HomeMap",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "Map",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<p><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.4372524704454!2d114.14615207586719!3d22.33711294155908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340407548be66e61%3A0xc6bc9dedfdffc038!2z6ZW_5rKZ5rm-5bm_5Zy6!5e0!3m2!1szh-CN!2shk!4v1767584496915!5m2!1szh-CN!2shk\" width=\"100%\" height=\"100%\" frameborder=\"0\"></iframe></p>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "Map",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 11:43:13",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 11:43:13",
                "UpdateDateVal": "2026-01-05 11:43:13",
                "CatId": 40128,
                "Cover": "",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "HomeRelated",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "HomeRelated"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 11:42:07",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": "Monday",
                "ContentDateTimeStr": "2026/01/05 11:42:07",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20342,
                "Key": "HomeQualityService",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "Quality Service",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "Quality Service",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:54:26",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:54:26",
                "UpdateDateVal": "2026-01-05 11:25:57",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/226b859b-d3fd-49f7-a19d-eaa154941db7.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "HomeRelated",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "HomeRelated"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:53:40",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": "Monday",
                "ContentDateTimeStr": "2026/01/05 10:53:40",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20343,
                "Key": "HomeUniversalLifeInsurance",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "Universal Life Insurance",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeNormal\"><p class=\"perText\">Universal life insurance is an insurance product that combines life protection and wealth appreciation. Compared to traditional life insurance products, universal life insurance not only provides protection but also offers relatively stable profit returns, achieving the goals of savings, asset appreciation, and inheritance...</p></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "Universal Life Insurance",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:54:59",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:54:59",
                "UpdateDateVal": "2026-01-05 11:21:47",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/3d242c00-301d-4a2d-bb1d-2f83a18a779e.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "HomeRelated",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "HomeRelated"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:54:29",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": "Monday",
                "ContentDateTimeStr": "2026/01/05 10:54:29",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20341,
                "Key": "HomeBusinessPhilosophy",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "Business Philosophy",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeNormal\"><p class=\"perText\">Insurance serves as an important asset safeguard for individuals and families. Life is full of ups and downs, and the wealth accumulated through a lifetime of hard work may fluctuate with changes in the market environment. Therefore, high-net-worth clients particularly need more proactive and effective insurance and financial planning to build a solid wealth safeguard, enabling their family businesses to remain stable and thrive.</p><p class=\"perText\">NCI understands the unique needs of every high-net-worth client and adheres to professional and rigorous service quality to help you accomplish the great task of wealth inheritance...</p></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "Business Philosophy",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:53:37",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:53:37",
                "UpdateDateVal": "2026-01-05 11:06:26",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0667ecec-42aa-4579-bd0e-30bce7c2cb05.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "HomeRelated",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "HomeRelated"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:52:46",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": "Monday",
                "ContentDateTimeStr": "2026/01/05 10:52:46",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              }
            ],
            "Seq": 0,
            "CreateDate": "2026-01-05 10:51:44",
            "UpdateDate": "2026-01-05 10:51:44"
          },
          "Code": 0
        },
        "{\"Key\":\"HomeRelated\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 40128,
            "Key": "HomeRelated",
            "Name": "HomeRelated",
            "Description": "HomeRelated",
            "Content": "",
            "URL": "/cms/catDetail/40128",
            "OpenNewWin": true,
            "ParentId": 0,
            "PageStyle": "1",
            "Children": [],
            "Img": null,
            "Collapse": false,
            "ImagePath": "",
            "Path": "40128",
            "CatPaths": [
              {
                "CatId": "40128",
                "PathName": "HomeRelated"
              }
            ],
            "SeoKeyword": "",
            "SeoDesc": "",
            "Father": [],
            "GroupId": 0,
            "RedirectURL": null,
            "Contents": [
              {
                "Id": 20340,
                "Key": "HomeAbout",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "About Us",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeNormal\"><p class=\"perText\"><em class=\"colorText\">New Century International Insurance Advisory Limited (NCI)</em> was established in 2007 and is a <span style=\"color: rgb(15, 17, 21); font-family: quote-cjk-patch, Inter, system-ui, -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Oxygen, Ubuntu, Cantarell, &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, sans-serif; background-color: rgb(255, 255, 255);\">Member of the Insurance Authority (License Number FB1543)</span>. Its main business is to provide customers with high-quality insurance intermediary services. NCI has a professional team with comprehensive and rich qualifications and years of experience. It is highly innovative and leading in the field of insurance planning and is committed to providing high-net-worth clients worldwide with life insurance planning advice and tailor-made professional services with a global perspective.</p><p class=\"perText\">The needs of high-net-worth clients vary, and NCI adheres to the customer-centric belief, delving deep into understanding the unique needs of each client...</p></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "About Us",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:52:40",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:52:40",
                "UpdateDateVal": "2026-05-07 15:45:50",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/5e466c8a-c463-40cb-b1eb-3966dfb332f4.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "HomeRelated",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "HomeRelated"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:51:49",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": true,
                "WeekNum": "Monday",
                "ContentDateTimeStr": "2026/01/05 10:51:49",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20345,
                "Key": "HomeContactUs",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "Contact Us",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">Address:</p><p class=\"text\">Room 502A, 5/F, Phase I, Cheung Sha Wan Plaza, 833 Cheung Sha Wan Road, Kowloon, Hong Kong</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">Telephone:</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">Fax:</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">Email:</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "Contact Us",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 11:49:48",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 11:49:48",
                "UpdateDateVal": "2026-01-05 11:49:48",
                "CatId": 40128,
                "Cover": "",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "HomeRelated",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "HomeRelated"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 11:48:37",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": true,
                "WeekNum": "Monday",
                "ContentDateTimeStr": "2026/01/05 11:48:37",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20344,
                "Key": "HomeMap",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "Map",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<p><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.4372524704454!2d114.14615207586719!3d22.33711294155908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340407548be66e61%3A0xc6bc9dedfdffc038!2z6ZW_5rKZ5rm-5bm_5Zy6!5e0!3m2!1szh-CN!2shk!4v1767584496915!5m2!1szh-CN!2shk\" width=\"100%\" height=\"100%\" frameborder=\"0\"></iframe></p>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "Map",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 11:43:13",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 11:43:13",
                "UpdateDateVal": "2026-01-05 11:43:13",
                "CatId": 40128,
                "Cover": "",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "HomeRelated",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "HomeRelated"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 11:42:07",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": true,
                "WeekNum": "Monday",
                "ContentDateTimeStr": "2026/01/05 11:42:07",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20342,
                "Key": "HomeQualityService",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "Quality Service",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "Quality Service",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:54:26",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:54:26",
                "UpdateDateVal": "2026-01-05 11:25:57",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0b7880a1-04e6-4b49-8f16-cbb9fe317fd7.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "HomeRelated",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "HomeRelated"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:53:40",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": true,
                "WeekNum": "Monday",
                "ContentDateTimeStr": "2026/01/05 10:53:40",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20343,
                "Key": "HomeUniversalLifeInsurance",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "Universal Life Insurance",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeNormal\"><p class=\"perText\">Universal life insurance is an insurance product that combines life protection and wealth appreciation. Compared to traditional life insurance products, universal life insurance not only provides protection but also offers relatively stable profit returns, achieving the goals of savings, asset appreciation, and inheritance...</p></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "Universal Life Insurance",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:54:59",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:54:59",
                "UpdateDateVal": "2026-01-05 11:21:47",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/b01b6a8d-da30-4e94-871d-ce4603e10b0a.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "HomeRelated",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "HomeRelated"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:54:29",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": true,
                "WeekNum": "Monday",
                "ContentDateTimeStr": "2026/01/05 10:54:29",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20341,
                "Key": "HomeBusinessPhilosophy",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "Business Philosophy",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeNormal\"><p class=\"perText\">Insurance serves as an important asset safeguard for individuals and families. Life is full of ups and downs, and the wealth accumulated through a lifetime of hard work may fluctuate with changes in the market environment. Therefore, high-net-worth clients particularly need more proactive and effective insurance and financial planning to build a solid wealth safeguard, enabling their family businesses to remain stable and thrive.</p><p class=\"perText\">NCI understands the unique needs of every high-net-worth client and adheres to professional and rigorous service quality to help you accomplish the great task of wealth inheritance...</p></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "Business Philosophy",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:53:37",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:53:37",
                "UpdateDateVal": "2026-01-05 11:06:26",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/c98b9ba6-b92b-4850-b3c4-78a06e1f1e68.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "HomeRelated",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "HomeRelated"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:52:46",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": true,
                "WeekNum": "Monday",
                "ContentDateTimeStr": "2026/01/05 10:52:46",
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              }
            ],
            "Seq": 0,
            "CreateDate": "2026-01-05 10:51:44",
            "UpdateDate": "2026-01-05 10:51:44"
          },
          "Code": 0
        },
        "{\"Key\":\"HomeAbout\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeAbout\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeBusinessPhilosophy\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeBusinessPhilosophy\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeQualityService\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeQualityService\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeUniversalLifeInsurance\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeUniversalLifeInsurance\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeContactUs\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeContactUs\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeMap\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"HomeMap\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"footerContact\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"footerContact\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"LINK\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"LINK\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"AppointmentRenewal\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"Key\":\"AppointmentRenewal\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"CatId\":\"40137\",\"IsMobile\":false}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"CatId\":\"40137\",\"IsMobile\":true}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        }
      },
      "catByKey": {
        "{\"key\":\"HomeRelated\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "Id": 40128,
            "Key": "HomeRelated",
            "Name": "HomeRelated",
            "Description": "HomeRelated",
            "Content": "",
            "URL": "/cms/catDetail/40128",
            "OpenNewWin": true,
            "ParentId": 0,
            "PageStyle": "1",
            "Children": [],
            "Img": null,
            "Collapse": false,
            "ImagePath": "",
            "Path": "40128",
            "CatPaths": [
              {
                "CatId": "40128",
                "PathName": "HomeRelated"
              }
            ],
            "SeoKeyword": "",
            "SeoDesc": "",
            "Father": [],
            "GroupId": 0,
            "RedirectURL": null,
            "Contents": [
              {
                "Id": 20340,
                "Key": "HomeAbout",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "About Us",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeNormal\"><p class=\"perText\"><em class=\"colorText\">New Century International Insurance Advisory Limited (NCI)</em> was established in 2007 and is a <span style=\"color: rgb(15, 17, 21); font-family: quote-cjk-patch, Inter, system-ui, -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Oxygen, Ubuntu, Cantarell, &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, sans-serif; background-color: rgb(255, 255, 255);\">Member of the Insurance Authority (License Number FB1543)</span>. Its main business is to provide customers with high-quality insurance intermediary services. NCI has a professional team with comprehensive and rich qualifications and years of experience. It is highly innovative and leading in the field of insurance planning and is committed to providing high-net-worth clients worldwide with life insurance planning advice and tailor-made professional services with a global perspective.</p><p class=\"perText\">The needs of high-net-worth clients vary, and NCI adheres to the customer-centric belief, delving deep into understanding the unique needs of each client...</p></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "About Us",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:52:40",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:52:40",
                "UpdateDateVal": "2026-05-07 15:45:50",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0cb969dd-55f4-4c53-bbe1-9bdf58e7498e.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "HomeRelated",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "HomeRelated"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:51:49",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": null,
                "ContentDateTimeStr": null,
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20345,
                "Key": "HomeContactUs",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "Contact Us",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeContact\"><div class=\"perData\"><div class=\"leftT\"><em class=\"iconA\"></em></div><div class=\"rightT\"><p class=\"text\">Address:</p><p class=\"text\">Room 502A, 5/F, Phase I, Cheung Sha Wan Plaza, 833 Cheung Sha Wan Road, Kowloon, Hong Kong</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconB\"></em></div><div class=\"rightT\"><p class=\"text\">Telephone:</p><p class=\"text\">(+852)3106-0515</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconC\"></em></div><div class=\"rightT\"><p class=\"text\">Fax:</p><p class=\"text\">(+852)3106-0516</p></div></div><div class=\"perData\"><div class=\"leftT\"><em class=\"iconD\"></em></div><div class=\"rightT\"><p class=\"text\">Email:</p><p class=\"text\">cs@ncihk.com</p></div></div></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "Contact Us",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 11:49:48",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 11:49:48",
                "UpdateDateVal": "2026-01-05 11:49:48",
                "CatId": 40128,
                "Cover": "",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "HomeRelated",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "HomeRelated"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 11:48:37",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": null,
                "ContentDateTimeStr": null,
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20344,
                "Key": "HomeMap",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "Map",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<p><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.4372524704454!2d114.14615207586719!3d22.33711294155908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340407548be66e61%3A0xc6bc9dedfdffc038!2z6ZW_5rKZ5rm-5bm_5Zy6!5e0!3m2!1szh-CN!2shk!4v1767584496915!5m2!1szh-CN!2shk\" width=\"100%\" height=\"100%\" frameborder=\"0\"></iframe></p>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "Map",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 11:43:13",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 11:43:13",
                "UpdateDateVal": "2026-01-05 11:43:13",
                "CatId": 40128,
                "Cover": "",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "HomeRelated",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "HomeRelated"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 11:42:07",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": null,
                "ContentDateTimeStr": null,
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20342,
                "Key": "HomeQualityService",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "Quality Service",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "Quality Service",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:54:26",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:54:26",
                "UpdateDateVal": "2026-01-05 11:25:57",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/226b859b-d3fd-49f7-a19d-eaa154941db7.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "HomeRelated",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "HomeRelated"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:53:40",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": null,
                "ContentDateTimeStr": null,
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20343,
                "Key": "HomeUniversalLifeInsurance",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "Universal Life Insurance",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeNormal\"><p class=\"perText\">Universal life insurance is an insurance product that combines life protection and wealth appreciation. Compared to traditional life insurance products, universal life insurance not only provides protection but also offers relatively stable profit returns, achieving the goals of savings, asset appreciation, and inheritance...</p></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "Universal Life Insurance",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:54:59",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:54:59",
                "UpdateDateVal": "2026-01-05 11:21:47",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/3d242c00-301d-4a2d-bb1d-2f83a18a779e.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "HomeRelated",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "HomeRelated"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:54:29",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": null,
                "ContentDateTimeStr": null,
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              },
              {
                "Id": 20341,
                "Key": "HomeBusinessPhilosophy",
                "Author": "",
                "AuthorTransId": "00000000-0000-0000-0000-000000000000",
                "Desc": "Business Philosophy",
                "DescTransId": "00000000-0000-0000-0000-000000000000",
                "Body": "<div class=\"HomeNormal\"><p class=\"perText\">Insurance serves as an important asset safeguard for individuals and families. Life is full of ups and downs, and the wealth accumulated through a lifetime of hard work may fluctuate with changes in the market environment. Therefore, high-net-worth clients particularly need more proactive and effective insurance and financial planning to build a solid wealth safeguard, enabling their family businesses to remain stable and thrive.</p><p class=\"perText\">NCI understands the unique needs of every high-net-worth client and adheres to professional and rigorous service quality to help you accomplish the great task of wealth inheritance...</p></div>",
                "ContentTransId": "00000000-0000-0000-0000-000000000000",
                "MContentTransId": "00000000-0000-0000-0000-000000000000",
                "Title": "Business Philosophy",
                "TitleTransId": "00000000-0000-0000-0000-000000000000",
                "ImagePath": null,
                "CreateDate": "2026-01-05 10:53:37",
                "UpdateDate": null,
                "CreateDateVal": "2026-01-05 10:53:37",
                "UpdateDateVal": "2026-01-05 11:06:26",
                "CatId": 40128,
                "Cover": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/cmscategory/0667ecec-42aa-4579-bd0e-30bce7c2cb05.jpg",
                "CoverId": null,
                "Url": "",
                "UrlTransId": "00000000-0000-0000-0000-000000000000",
                "Category": {
                  "Id": 40128,
                  "Name": "HomeRelated",
                  "ParentId": 0,
                  "Path": "40128",
                  "CatPaths": [
                    {
                      "CatId": "40128",
                      "PathName": "HomeRelated"
                    }
                  ]
                },
                "SeoKeyword": "",
                "SeoKeyTransId": "00000000-0000-0000-0000-000000000000",
                "SeoDesc": "",
                "SeoDescTransId": "00000000-0000-0000-0000-000000000000",
                "Status": 0,
                "CmsControl": [],
                "ContentDateTime": "2026-01-05 10:52:46",
                "IsTop": false,
                "IsOpenWindows": false,
                "UrlTypeTransId": "00000000-0000-0000-0000-000000000000",
                "IsMobile": false,
                "WeekNum": null,
                "ContentDateTimeStr": null,
                "Parentid": 0,
                "CatKey": null,
                "PreviousId": null,
                "NextId": null,
                "Seq": 999
              }
            ],
            "Seq": 0,
            "CreateDate": "2026-01-05 10:51:44",
            "UpdateDate": "2026-01-05 10:51:44"
          },
          "Code": 0
        },
        "{\"key\":\"HomeAbout\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"key\":\"HomeBusinessPhilosophy\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"key\":\"HomeQualityService\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"key\":\"HomeUniversalLifeInsurance\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"key\":\"HomeContactUs\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"key\":\"HomeMap\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"key\":\"footerContact\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"key\":\"LINK\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        },
        "{\"key\":\"AppointmentRenewal\"}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": null,
          "Code": 0
        }
      }
    },
    "product": {
      "products": {},
      "search": {
        "{\"Key\":\"\",\"Type\":0,\"PageInfo\":{\"Page\":1,\"PageSize\":100}}": {
          "TotalPage": 0,
          "TotalRecord": 0,
          "Data": [],
          "Page": 1,
          "PageSize": 100,
          "Offset": 0,
          "SortName": "",
          "SortOrder": ""
        }
      },
      "catProducts": {},
      "related": {},
      "latest": {
        "{\"qty\":12}": []
      },
      "catalogs": [],
      "catalog": {},
      "attrImage": {},
      "productUpOrDown": {},
      "checkProductStatus": {}
    },
    "site": {
      "contact": {
        "__fetchError": true,
        "status": 404,
        "message": "Request failed with status code 404",
        "data": {
          "Message": "No HTTP resource was found that matches the request URI 'https://api.uat.in-store.hk/V2/common/contact'.",
          "MessageDetail": "No type was found that matches the controller named 'common'."
        }
      }
    },
    "photoAlbum": {
      "folders": {
        "TotalPage": 0,
        "TotalRecord": 0,
        "Data": [],
        "Page": 1,
        "PageSize": 50,
        "Offset": 0,
        "SortName": "",
        "SortOrder": ""
      },
      "folderInfo": {}
    },
    "calendar": {
      "listByCond": {
        "{\"Year\":2026,\"Month\":5,\"Day\":13}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": {
            "TotalPage": 0,
            "TotalRecord": 0,
            "Data": [],
            "Page": 1,
            "PageSize": 10,
            "Offset": 0,
            "SortName": "",
            "SortOrder": ""
          },
          "Code": 0
        }
      },
      "byId": {}
    },
    "common": {
      "country": [
        {
          "Id": 537,
          "Name": "Afghanistan",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AFA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 538,
          "Name": "Albania",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ALA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 539,
          "Name": "Algeria",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "DZA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 540,
          "Name": "Andorra",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ADA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 541,
          "Name": "Angola",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AOA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 542,
          "Name": "Anguilla",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AIA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 543,
          "Name": "Antigua & Barbuda",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AGA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 544,
          "Name": "Argentina",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ARA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 545,
          "Name": "Armenia",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AMA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 546,
          "Name": "Ascension",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ACA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 547,
          "Name": "Aruba",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AWA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 548,
          "Name": "Australia (WA)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AUA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 549,
          "Name": "Australia (others)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AUB",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 550,
          "Name": "Austria",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ATA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 551,
          "Name": "Azerbaijan",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AZA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 552,
          "Name": "Azores",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PTB",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 553,
          "Name": "Bahamas",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BSA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 554,
          "Name": "Bahrain",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BHA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 555,
          "Name": "Baleares Islands",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "IBA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 556,
          "Name": "Bangladesh",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BDA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 557,
          "Name": "Barbados",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BBA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 558,
          "Name": "Belarus",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BYA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 559,
          "Name": "Belgium",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BEA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 560,
          "Name": "Belize",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BZA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 561,
          "Name": "Benin",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BJA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 562,
          "Name": "Bermuda",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BMA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 563,
          "Name": "Bhutan",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BTA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 564,
          "Name": "Bolivia",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BOA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 565,
          "Name": "Bosnia and Herzegovina",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BAA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 566,
          "Name": "Botswana",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BWA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 567,
          "Name": "Brazil",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BRA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 568,
          "Name": "British Indian O.T.",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "IOA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 569,
          "Name": "Brunei Darussalam",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BNA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 570,
          "Name": "Bulgaria",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BGA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 571,
          "Name": "Burkina Faso",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BFA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 572,
          "Name": "Burundi",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "BIA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 573,
          "Name": "Cambodia",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KHA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 574,
          "Name": "Cameroon",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CMA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 575,
          "Name": "Canada",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CAA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 576,
          "Name": "Canary Islands",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ESC",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 577,
          "Name": "Cape Verde Island",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CVA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 578,
          "Name": "Caroline Islands (Micronesia)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "FMA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 579,
          "Name": "Caroline Islands (Palau)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PWA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 580,
          "Name": "Cayman Islands",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KYA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 581,
          "Name": "Central Africa Republic",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CFA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 582,
          "Name": "Chad",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TDA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 583,
          "Name": "Chile",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CLA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 584,
          "Name": "Christmas Islands",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CXA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 585,
          "Name": "Cocos (Keeling) Island",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CCA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 586,
          "Name": "Colombia",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "COA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 587,
          "Name": "Comoros",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KMA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 588,
          "Name": "Congo (Democratic Rep Of the)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CDA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 589,
          "Name": "Congo (Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CGA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 590,
          "Name": "Corsica",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "EUA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 591,
          "Name": "Costa Rica",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CRA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 592,
          "Name": "Cote d\\'Ivoire (Ivory Coast)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CIA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 593,
          "Name": "Croatia",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "HRA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 594,
          "Name": "Cuba (Guantanamo Bay)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CUA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 595,
          "Name": "Cuba (Other places)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CUB",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 596,
          "Name": "Cyprus",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CYA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 597,
          "Name": "Czech Republic",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CZA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 598,
          "Name": "Denmark",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "DKA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 599,
          "Name": "Djibouti",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "DJA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 600,
          "Name": "Dominica",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "DMA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 601,
          "Name": "Dominican Republic",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "DOA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 602,
          "Name": "East Timor",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TPA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 603,
          "Name": "Ecuador",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ECA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 604,
          "Name": "Egypt",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "EGA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 605,
          "Name": "El Salvador",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SVA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 606,
          "Name": "Equatorial Guinea (Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GQA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 607,
          "Name": "Eritrea",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ERA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 608,
          "Name": "Estonia (Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "EEA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 609,
          "Name": "Ethiopia",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ETA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 610,
          "Name": "Falkland Island (inc. Deps)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "FKA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 611,
          "Name": "Faroe Islands",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "FOA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 612,
          "Name": "Fiji",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "FJA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 613,
          "Name": "Finland",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "FIA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 614,
          "Name": "France",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "FRA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 615,
          "Name": "French Guiana",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GFA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 616,
          "Name": "French Polynesia",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PFA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 617,
          "Name": "FR. W. I. (Guadeloupe)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GPA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 618,
          "Name": "FR. W. I. (Martinique)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MQA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 619,
          "Name": "Gabon",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GAA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 620,
          "Name": "Gambia",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GMA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 621,
          "Name": "Gaza and Khan Yunis",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "XEA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 622,
          "Name": "Georgia (Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GEA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 623,
          "Name": "Germany",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "DEA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 624,
          "Name": "Ghana",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GHA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 625,
          "Name": "Gibraltar",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GIA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 626,
          "Name": "Greece",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GRA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 627,
          "Name": "Greenland",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GLA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 628,
          "Name": "Grenada",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GDA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 629,
          "Name": "Guam",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GUA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 630,
          "Name": "Guatemala",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GTA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 631,
          "Name": "Guinea (Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GNA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 632,
          "Name": "Guinea Bissau (Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GWA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 633,
          "Name": "Guyana",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GYA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 634,
          "Name": "Haiti",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "HTA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 635,
          "Name": "Honduras (Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "HNA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 636,
          "Name": "Hungary",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "HUA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 637,
          "Name": "Iceland",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ISA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 638,
          "Name": "India (Mumbai)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "INA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 639,
          "Name": "India (Other places)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "INB",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 640,
          "Name": "Indonesia",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "IDA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 641,
          "Name": "Iran",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "IRA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 642,
          "Name": "Iraq",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "IQA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 643,
          "Name": "Ireland",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "IEA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 644,
          "Name": "Israel",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ILA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 645,
          "Name": "Italy",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ITA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 646,
          "Name": "Jamaica",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "JMA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 647,
          "Name": "Japan",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "JPA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 648,
          "Name": "Japan (Ryukyu Islands)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "JPB",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 649,
          "Name": "Jordan",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "JOA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 650,
          "Name": "Kazakhstan",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KZA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 651,
          "Name": "Kenya",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KEA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 652,
          "Name": "Kiribati",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KIA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 653,
          "Name": "Korea, North",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KPA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 654,
          "Name": "Korea, South",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KRA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 655,
          "Name": "Kuwait",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KWA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 656,
          "Name": "Kyrgyzstan",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KGA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 657,
          "Name": "Laos",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LAA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 658,
          "Name": "Latvia",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LVA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 659,
          "Name": "Lebanon",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LBA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 660,
          "Name": "Lesotho",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LSA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 661,
          "Name": "Liberia",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LRA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 662,
          "Name": "Libyan Arab Jamahiriya (Libya)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LYA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 663,
          "Name": "Liechtenstein",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LIA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 664,
          "Name": "Lithuania (Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LTA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 665,
          "Name": "Luxembourg",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LUA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 666,
          "Name": "Macau",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MOA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 667,
          "Name": "Macedonia",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MKA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 668,
          "Name": "Madagascar (Democratic Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MGA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 669,
          "Name": "Madeira",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PTC",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 670,
          "Name": "Malawi",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MWA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 671,
          "Name": "Malaysia (Peninsular)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MYA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 672,
          "Name": "Malaysia (Sabah)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MYB",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 673,
          "Name": "Malaysia (Sarawak)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MYC",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 674,
          "Name": "Maldives (Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MVA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 675,
          "Name": "Mali",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MLA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 676,
          "Name": "Malta",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MTA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 677,
          "Name": "Mariana Islands",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MPA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 678,
          "Name": "Marshall Islands",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MHA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 679,
          "Name": "Mauritania",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MRA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 680,
          "Name": "Mauritius",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MUA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 681,
          "Name": "Mexico",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MXA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 682,
          "Name": "Moldova (Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MDA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 683,
          "Name": "Monaco",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MCA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 684,
          "Name": "Mongolia",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MNA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 685,
          "Name": "Montenegro (Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MEA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 686,
          "Name": "Montserrat",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MSA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 687,
          "Name": "Morocco",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MAA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 688,
          "Name": "Mozambique",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MZA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 689,
          "Name": "Myanmar (Union of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "MMA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 690,
          "Name": "Namibia",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NAA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 691,
          "Name": "Nauru Islands",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NRA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 692,
          "Name": "Nepal",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NPA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 693,
          "Name": "Netherlands",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NLA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 694,
          "Name": "Netherlands Antilles",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ANA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 695,
          "Name": "Netherlands Aruba",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ANB",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 696,
          "Name": "New Caledonia",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NCA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 697,
          "Name": "New Zealand",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NZA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 698,
          "Name": "New Zealand Islands Territories (Cook Islands)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "XLA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 699,
          "Name": "Nicaragua",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NIA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 700,
          "Name": "Niger Republic",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NEA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 701,
          "Name": "Nigeria",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NGA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 702,
          "Name": "Norfolk Islands",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NFA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 703,
          "Name": "Norway",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "NOA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 704,
          "Name": "Oman, Sultanate of",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "OMA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 705,
          "Name": "Pakistan",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PKA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 706,
          "Name": "Panama (Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PAA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 707,
          "Name": "Papua New Guinea",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PGA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 708,
          "Name": "Paraguay",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PYA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 709,
          "Name": "Peru",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PEA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 710,
          "Name": "Philippines",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PHA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 711,
          "Name": "Pitcairn Island",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PNA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 712,
          "Name": "Poland",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PLA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 713,
          "Name": "Portugal",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PTA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 714,
          "Name": "Puerto Rico",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PRA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 715,
          "Name": "Qatar (State of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "QAA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 716,
          "Name": "Reunion (State of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "REA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 717,
          "Name": "Romania",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ROA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 718,
          "Name": "Russian Federation",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "RUA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 719,
          "Name": "Rwanda",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "RWA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 720,
          "Name": "Samoa (U.S.A. Territory)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ASA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 721,
          "Name": "San Marino",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SMA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 722,
          "Name": "Sao Tome & Principe (Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "STA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 723,
          "Name": "Saudi Arabia",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SAA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 724,
          "Name": "Senegal",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SNA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 725,
          "Name": "Serbia (Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "RSA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 726,
          "Name": "Seychelles",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SCA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 727,
          "Name": "Sierra Leone",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SLA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 728,
          "Name": "Singapore",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SGA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 729,
          "Name": "Slovakia Republic",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SKA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 730,
          "Name": "Slovenia (Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SIA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 731,
          "Name": "Solomon Islands",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SBA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 732,
          "Name": "Somali",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SOA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 733,
          "Name": "South Africa (Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ZAA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 734,
          "Name": "Spain",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ESA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 735,
          "Name": "Spanish terr. of N.A.",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ESB",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 736,
          "Name": "Spitzbergen",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SJA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 737,
          "Name": "Sri Lanka (Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LKA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 738,
          "Name": "St. Christopher (St. Kitts) And Nevis",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "KNA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 739,
          "Name": "St. Helena",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SHA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 740,
          "Name": "St. Lucia",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "LCA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 741,
          "Name": "St. Pierre & Miquelon",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "PMA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 742,
          "Name": "St. Vincent Grenadines",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "VCA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 743,
          "Name": "Sudan (Rep.of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SDA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 744,
          "Name": "Suriname",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SRA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 745,
          "Name": "Swaziland",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SZA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 746,
          "Name": "Sweden",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SEA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 747,
          "Name": "Switzerland",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CHA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 748,
          "Name": "Syrian Arab Republic (Syria)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "SYA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 749,
          "Name": "Taiwan",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TWA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 750,
          "Name": "Tajikistan (Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TJA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 751,
          "Name": "Tanzania",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TZA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 752,
          "Name": "Thailand",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "THA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 753,
          "Name": "Togo",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TGA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 754,
          "Name": "Tonga",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TOA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 755,
          "Name": "Tortola (British Virgin Islands) (Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "VGA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 756,
          "Name": "Trinidad & Tobago",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TTA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 757,
          "Name": "Tristan de Cunha",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TAA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 758,
          "Name": "Tunisia",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TNA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 759,
          "Name": "Turkey",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TRA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 760,
          "Name": "Turkmenistan",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TMA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 761,
          "Name": "Turks & Caicos Islands",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TCA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 762,
          "Name": "Tuvalu",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "TVA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 763,
          "Name": "Uganda",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "UGA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 764,
          "Name": "Ukraine",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "UAA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 765,
          "Name": "United Arab Emirates",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AEA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 766,
          "Name": "United Kingdom",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "GBA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 767,
          "Name": "USA (Hawaii)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "USA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 768,
          "Name": "USA (New York)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "USB",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 769,
          "Name": "USA (other States)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "USC",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 770,
          "Name": "Uruguay",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "UYA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 771,
          "Name": "Uzbekistan (Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "UZA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 772,
          "Name": "Vanuatu (The Republic of)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "VUA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 773,
          "Name": "Vatican City",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "VAA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 774,
          "Name": "Venezuela",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "VEA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 775,
          "Name": "Vietnam",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "VNA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 776,
          "Name": "Virgin Islands of the U.S.A.",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "VIA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 777,
          "Name": "Wake Island",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "UMA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 778,
          "Name": "Wallis & Futuna Is.",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "WFA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 779,
          "Name": "Western Samoa",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "WSA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 780,
          "Name": "Yemen",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "YEA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 781,
          "Name": "Yemen (Other Places)",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "YEB",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 782,
          "Name": "Zambia",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ZMA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 783,
          "Name": "Zimbabwe",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "ZWA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 784,
          "Name": "China, Mainland",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "CNA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 786,
          "Name": "Hong Kong Local",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "HKG",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 821,
          "Name": "Aruba",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "AWA",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 1821,
          "Name": "Oversea",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "03",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        },
        {
          "Id": 1822,
          "Name": "Local islands",
          "Name_e": null,
          "Name_c": null,
          "Name_s": null,
          "Name_j": null,
          "Code": "05",
          "Code2": null,
          "Code3": null,
          "Language": "E",
          "Selected": false,
          "Provice": null,
          "is_Del": null,
          "date_changed": null,
          "CountryItem": null
        }
      ],
      "paymentMethod": [
        {
          "Id": 3020,
          "Code": "MASTER",
          "Desc": "VISA & MASTER CARD",
          "Name": "VISA & MASTER CARD",
          "Img": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/paymethods/0_20191227094137.jpg?flag=1778685685925",
          "PaymentDiscount": [],
          "PayType": 0
        },
        {
          "Id": 3021,
          "Code": "UNION",
          "Desc": "MPGS-UNIONPAY",
          "Name": "MPGS-UNIONPAY",
          "Img": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/paymethods/0_20191227094401.jpg?flag=1778685685925",
          "PaymentDiscount": [],
          "PayType": 0
        },
        {
          "Id": 3022,
          "Code": "WeChat",
          "Desc": "WeChat Pay",
          "Name": "WeChat Pay",
          "Img": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/paymethods/0_20191227094439.png?flag=1778685685925",
          "PaymentDiscount": [],
          "PayType": 0
        },
        {
          "Id": 3025,
          "Code": "Stripe",
          "Desc": "Stripe",
          "Name": "Stripe",
          "Img": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/paymethods/0_20191227094513.png?flag=1778685685925",
          "PaymentDiscount": [],
          "PayType": 0
        },
        {
          "Id": 3026,
          "Code": "Paypal",
          "Desc": "Paypal",
          "Name": "Paypal",
          "Img": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/paymethods/0_20191227094940.png?flag=1778685685925",
          "PaymentDiscount": [],
          "PayType": 0
        },
        {
          "Id": 3027,
          "Code": "Payme",
          "Desc": "Payme",
          "Name": "Payme",
          "Img": "/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/paymethods/0_20200214135924.jpg?flag=1778685685925",
          "PaymentDiscount": [],
          "PayType": 0
        }
      ],
      "expressAndOutlets": [
        {
          "Id": null,
          "ExpressCompanyId": "P",
          "ExpressPointId": null,
          "ExpressPointList": null,
          "ExpressCompanyName": "Pick Up at Stores",
          "Price": 0,
          "Discount": 0,
          "CountryCode": null,
          "ServiceType": null,
          "IsExpressPoint": true,
          "IsSelfDefineDeliveryDate": false,
          "ComeFrom": null,
          "ExpressCode": null,
          "DiscountPrice": 0,
          "PickupDateRequire": null,
          "PickupInfoRequire": null
        }
      ],
      "pickupAddress": [
        {
          "Id": "66",
          "Phone": "11111111",
          "Address": "ASD",
          "Name": "ABC",
          "Seq": "1"
        },
        {
          "Id": "67",
          "Phone": "2",
          "Address": "22",
          "Name": "22",
          "Seq": "3"
        }
      ],
      "attrList": {
        "{\"type\":1}": {
          "Succeeded": true,
          "Message": null,
          "ReturnValue": [],
          "Code": 1
        }
      }
    }
  }
};

export default rawLocalData;
